
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("4DJNq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $acd7b471cc125c7d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dGrdR = parcelRequire("dGrdR");

var $lL5b5 = parcelRequire("lL5b5");

var $rhg2G = parcelRequire("rhg2G");

var $5rqex = parcelRequire("5rqex");

var $9dbF6 = parcelRequire("9dbF6");

var $4dRjY = parcelRequire("4dRjY");

var $l8ruj = parcelRequire("l8ruj");

var $1bQGJ = parcelRequire("1bQGJ");

var $3nGSC = parcelRequire("3nGSC");
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $acd7b471cc125c7d$var$notificationsPersonalSettingsPageLoad = (0, $dGrdR.metrics).pageLoad({
    key: 'personal-settings-notifications',
    ssr: {
        doneAsFmp: true
    }
});
const $acd7b471cc125c7d$var$NotificationsPersonalSettingsShell = ({ extraProps: extraProps, queries: queries })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "personal-settings-notifications"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4dRjY.MarkProductStart), null), extraProps.accountId ? queries?.pageAndProject && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $rhg2G.NotificationsPersonalSettings), {
        queryReference: queries?.pageAndProject
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5rqex.default), {
        appName: "personal-settings-notifications",
        isExpectedToHaveSsr: true,
        metric: $acd7b471cc125c7d$var$notificationsPersonalSettingsPageLoad
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9dbF6.SubProductUpdater), {
        subProduct: "platform"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3nGSC.NotificationsPageTitle), null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lL5b5.default), null));
var $acd7b471cc125c7d$export$2e2bcd8739ae039 = (0, $1bQGJ.withRouter)($acd7b471cc125c7d$var$NotificationsPersonalSettingsShell);

});
parcelRegister("lL5b5", function(module, exports) {

$parcel$export(module.exports, "default", () => $07c2532655d93687$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $j0xEB = parcelRequire("j0xEB");

var $j2Jlg = parcelRequire("j2Jlg");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$07c2532655d93687$export$2e2bcd8739ae039 = ()=>{
    const { href: href = null } = (0, $j0xEB.default)() || {};
    if (href && !href.includes('login.jsp')) {
        const encodedRedirectUrl = encodeURIComponent(href);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j2Jlg.default), {
            url: `/login.jsp?os_destination=${encodedRedirectUrl}`
        });
    }
    return null;
};

});
parcelRegister("j2Jlg", function(module, exports) {

$parcel$export(module.exports, "default", () => $773e6f988af77e5c$export$2e2bcd8739ae039);

var $gKZoD = parcelRequire("gKZoD");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$773e6f988af77e5c$export$2e2bcd8739ae039 = ({ url: url })=>{
    (0, $gKZoD.di)(window);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.assign(url);
    return null;
};

});


parcelRegister("rhg2G", function(module, exports) {

$parcel$export(module.exports, "NotificationsPersonalSettings", () => $1290e4c1217126aa$export$b8a154a182a1b4e3);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $iXVV6 = parcelRequire("iXVV6");

var $ieDtd = parcelRequire("ieDtd");

var $aIRu6 = parcelRequire("aIRu6");
function $1290e4c1217126aa$export$b8a154a182a1b4e3({ queryReference: queryReference }) {
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const pageViewFromEmail = window?.location?.hash?.substring(1) === 'emailpreferences';
    const [engagement = ''] = (0, $ieDtd.useQueryParam)('engagement');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "notificationsSettings",
        packageName: "jiraPersonalSettingsNotifications",
        teamName: "jira-notifications-platform"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "personalSettingsNotifications",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        attributes: {
            pageViewFromEmail: pageViewFromEmail,
            engagement: engagement
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aIRu6.NotificationsPage), {
        queryReference: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        queryReference
    })));
}

});
// SCREENS
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("aIRu6", function(module, exports) {

$parcel$export(module.exports, "NotificationsPage", () => $99e2bc5f13a91407$export$741be6e0988afc38);

var $7P45F = parcelRequire("7P45F");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $fuUnn = parcelRequire("fuUnn");
var $jbeEq = parcelRequire("jbeEq");

var $fVnbM = parcelRequire("fVnbM");

var $bAkIV = parcelRequire("bAkIV");
var $bJcWY = parcelRequire("bJcWY");
var $aZdfU = parcelRequire("aZdfU");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $cS37j = parcelRequire("cS37j");

var $7CMCs = parcelRequire("7CMCs");

var $4R6GH = parcelRequire("4R6GH");

var $5Zxxp = parcelRequire("5Zxxp");

var $koVbs = parcelRequire("koVbs");

var $gEQzr = parcelRequire("gEQzr");

var $dcT9d = parcelRequire("dcT9d");

var $FvXgY = parcelRequire("FvXgY");

var $lGrfI = parcelRequire("lGrfI");

var $1C2yb = parcelRequire("1C2yb");

var $8DBQC = parcelRequire("8DBQC");

var $lfTZh = parcelRequire("lfTZh");

var $5oFIy = parcelRequire("5oFIy");

var $a94gn = parcelRequire("a94gn");

var $8NIyn = parcelRequire("8NIyn");
const $99e2bc5f13a91407$var$LEARN_MORE_ABOUT_MANAGING_NOTIFICATIONS_HELP_ID = '3Tr3hYdpC7xV6AUcjsfEXW';
const $99e2bc5f13a91407$var$NotificationsPageContent = ({ queryReference: queryReference })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const data = (0, $8Uumt.usePreloadedQuery)((0, $7P45F.default), queryReference);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dcT9d.FieldWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($99e2bc5f13a91407$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($99e2bc5f13a91407$var$PreferenceHeading, null, formatMessage((0, $8NIyn.default).notificationEmailPreferencesHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $99e2bc5f13a91407$var$preferenceDescStyles
    }, formatMessage((0, $8NIyn.default).notificationEmailPreferencesDescriptionWithBatching)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8DBQC.NotificationPreferencesOptions), {
        emailEnabledFragment: data.jira.notificationGlobalPreference.options
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "global-personal-notification-settings",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a94gn.PersonalSettingsNotificationsGlobalTableSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $FvXgY.GlobalNotificationConfigTableNew), {
        allPreferencesData: data.jira.notificationGlobalPreference
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($99e2bc5f13a91407$var$ProjectNotificationWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lGrfI.ProjectNotificationsConfig), {
        projects: data
    })));
};
const $99e2bc5f13a91407$export$741be6e0988afc38 = ({ queryReference: queryReference })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onOpenInProductHelpArticle = (0, $5Zxxp.useHelpPanelLink)();
    const onLearnMore = (0, $5uXOq.useCallback)(()=>{
        onOpenInProductHelpArticle($99e2bc5f13a91407$var$LEARN_MORE_ABOUT_MANAGING_NOTIFICATIONS_HELP_ID);
    }, [
        onOpenInProductHelpArticle
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        packageName: "jiraPersonalSettingsNotifications",
        id: "personalSettingsNotificationsTable"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bAkIV.default), {
        testId: "personal-settings-notifications.ui.main"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bJcWY.default), {
        layout: "fixed",
        spacing: "comfortable"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aZdfU.default), {
        medium: 12
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cS37j.default), {
        breadcrumbs: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jbeEq.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gEQzr.PersonalSettingsBreadcrumbItem), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fuUnn.default), {
            href: (0, $1C2yb.NOTIFICATIONS_PERSONAL_SETTINGS_PATH),
            text: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $8NIyn.default).notificationsPageTitleIssueTermRefresh : (0, $8NIyn.default).notificationsPageTitle)
        })),
        bottomBar: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, formatMessage((0, $8NIyn.default).notificationsExplanation), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            spacing: "none",
            appearance: "link",
            onClick: onLearnMore
        }, formatMessage((0, $8NIyn.default).notificationsSettingsHelper)))
    }, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $8NIyn.default).notificationsPageTitleIssueTermRefresh : (0, $8NIyn.default).notificationsPageTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($99e2bc5f13a91407$var$NotificationsPageContent, {
        queryReference: queryReference
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $99e2bc5f13a91407$var$PreferenceHeading = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "h5", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulppxbi _ca0q12x7 _u5f3idpf _n3tdu2gc _19bvidpf _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $99e2bc5f13a91407$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx21bp4 _otyrpxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $99e2bc5f13a91407$var$ProjectNotificationWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulpu2gc _1e0c1txw _2lx21bp4 _ca0qpxbi _u5f3idpf _n3tdpxbi _19bvidpf",
            __cmplp.className
        ])
    });
});
const $99e2bc5f13a91407$var$preferenceDescStyles = (0, $8CUq3.xcss)({
    marginBottom: 'space.200',
    marginTop: 'space.100'
});

});
parcelRegister("bAkIV", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e769a1b108c1b03$export$2e2bcd8739ae039);

var $cE92Q = parcelRequire("cE92Q");

var $bJcWY = parcelRequire("bJcWY");

var $aZdfU = parcelRequire("aZdfU");
var // Page already has a jsdoc where it is defined
// eslint-disable-next-line @repo/internal/react/require-jsdoc
$5e769a1b108c1b03$export$2e2bcd8739ae039 = (0, $cE92Q.default);

});
parcelRegister("cE92Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f4d1a89146de6ed$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $f1WIN = parcelRequire("f1WIN");
function $2f4d1a89146de6ed$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2f4d1a89146de6ed$var$bannerStyles = {
    name: "4oew4k",
    styles: "width:100%;position:fixed"
};
const $2f4d1a89146de6ed$var$bannerContainerStyles = {
    name: "1x3pv69",
    styles: "width:100%;position:relative;z-index:3;flex:1 0 auto;transition:height 0.25s ease-in-out"
};
const $2f4d1a89146de6ed$var$pageContentStyles = {
    name: "15n167b",
    styles: "min-width:0;position:relative;z-index:1;flex:1 1 auto"
};
const $2f4d1a89146de6ed$var$wrapperStyles = {
    name: "m5v4sl",
    styles: "display:flex;width:100%;min-height:100%;flex-direction:column"
};
const $2f4d1a89146de6ed$var$mainContainerStyles = {
    name: "1cete8c",
    styles: "display:flex;flex:1 1 auto"
};
const $2f4d1a89146de6ed$var$navigationStyles = {
    name: "wrqbg1",
    styles: "position:relative;z-index:2"
};
/**
 * __Page__
 *
 * Used to build page layouts.
 *
 * Has built in support for positioning [banners](https://atlassian.design/components/banner/examples)
 * and the deprecated `@atlaskit/navigation`.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $2f4d1a89146de6ed$var$Page = ({ isBannerOpen: isBannerOpen = false, bannerHeight: bannerHeight = (0, $f1WIN.defaultBannerHeight), banner: banner, navigation: navigation, children: children, testId: testId })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $2f4d1a89146de6ed$var$wrapperStyles,
        "data-testid": testId
    }, banner ? /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $2f4d1a89146de6ed$var$bannerContainerStyles,
        style: {
            height: isBannerOpen ? `${bannerHeight}px` : '0'
        },
        "aria-hidden": !isBannerOpen,
        "data-testid": testId ? `${testId}--banner-container` : undefined
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $2f4d1a89146de6ed$var$bannerStyles
    }, banner)) : null, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $2f4d1a89146de6ed$var$mainContainerStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $2f4d1a89146de6ed$var$navigationStyles
    }, navigation), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $2f4d1a89146de6ed$var$pageContentStyles
    }, children)));
};
var $2f4d1a89146de6ed$export$2e2bcd8739ae039 = $2f4d1a89146de6ed$var$Page;

});
parcelRegister("f1WIN", function(module, exports) {

$parcel$export(module.exports, "defaultGridColumns", () => $196a11a7b8c2fbef$export$74797698e12f8baa);
$parcel$export(module.exports, "defaultGridColumnWidth", () => $196a11a7b8c2fbef$export$b8241a1616ab1b96);
$parcel$export(module.exports, "spacingMapping", () => $196a11a7b8c2fbef$export$2a89a65a43bab52d);
$parcel$export(module.exports, "defaultSpacing", () => $196a11a7b8c2fbef$export$8ec7372efd74b753);
$parcel$export(module.exports, "defaultBannerHeight", () => $196a11a7b8c2fbef$export$d77f83c3d17a7b8a);
$parcel$export(module.exports, "defaultMedium", () => $196a11a7b8c2fbef$export$f8725d21f81f3e01);
$parcel$export(module.exports, "defaultLayout", () => $196a11a7b8c2fbef$export$2303d2bd9eeff99a);
$parcel$export(module.exports, "varColumnsNum", () => $196a11a7b8c2fbef$export$9ddc3632bbfb8966);
$parcel$export(module.exports, "varColumnSpan", () => $196a11a7b8c2fbef$export$8b7e31f391e6e681);
$parcel$export(module.exports, "varGridSpacing", () => $196a11a7b8c2fbef$export$936829b4511db3e4);
const $196a11a7b8c2fbef$var$defaultGridSize = 8;
const $196a11a7b8c2fbef$export$74797698e12f8baa = 12;
const $196a11a7b8c2fbef$export$b8241a1616ab1b96 = $196a11a7b8c2fbef$var$defaultGridSize * 10;
const $196a11a7b8c2fbef$export$2a89a65a43bab52d = {
    comfortable: $196a11a7b8c2fbef$var$defaultGridSize * 5,
    cosy: $196a11a7b8c2fbef$var$defaultGridSize * 2,
    compact: $196a11a7b8c2fbef$var$defaultGridSize * 0.5
};
const $196a11a7b8c2fbef$export$8ec7372efd74b753 = 'cosy';
const $196a11a7b8c2fbef$export$d77f83c3d17a7b8a = 52;
const $196a11a7b8c2fbef$export$f8725d21f81f3e01 = 0;
const $196a11a7b8c2fbef$export$2303d2bd9eeff99a = 'fixed';
const $196a11a7b8c2fbef$export$9ddc3632bbfb8966 = '--ds-columns-num';
const $196a11a7b8c2fbef$export$8b7e31f391e6e681 = '--ds-column-span';
const $196a11a7b8c2fbef$export$936829b4511db3e4 = '--ds-grid-spacing';

});


parcelRegister("bJcWY", function(module, exports) {

$parcel$export(module.exports, "default", () => $08fe944bdcd177c2$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $f1WIN = parcelRequire("f1WIN");

var $itnZ9 = parcelRequire("itnZ9");

var $aZdfU = parcelRequire("aZdfU");

var $ephoW = parcelRequire("ephoW");
/**
 * __Grid__
 *
 * A grid contains one or more `GridColumn` to provide a grid layout.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $08fe944bdcd177c2$var$GridWrapper = ({ spacing: spacingProp, columns: columnsProp, layout: layout, testId: testId, children: children, theme: theme })=>{
    /**
	 * isRoot is `true` only in the default context (i.e. no ancestor Grid).
	 */ const { isRoot: isRoot } = (0, $5uXOq.useContext)((0, $ephoW.GridContext));
    const { medium: medium } = (0, $5uXOq.useContext)((0, $aZdfU.GridColumnContext));
    /**
	 * The colspan of the current containing GridColumn provides
	 * the default amount of columns in a nested grid.
	 */ const defaultColumns = medium > 0 ? medium : (0, $f1WIN.defaultGridColumns);
    /**
	 * This is to account for the eventual removal of the `theme` prop. In theory, this should not be exposed.
	 * However, consumers are still using it - there should be a major rerelease with the complete removal of this prop later.
	 */ const spacing = spacingProp ?? theme?.spacing ?? (0, $f1WIN.defaultSpacing);
    const columns = columnsProp ?? theme?.columns ?? defaultColumns;
    const isNested = theme?.isNestedGrid ?? !isRoot;
    const contextValue = (0, $5uXOq.useMemo)(()=>({
            isRoot: false,
            isNested: isNested,
            spacing: spacing,
            columns: columns
        }), [
        spacing,
        columns,
        isNested
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ephoW.GridContext).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $itnZ9.Grid), {
            layout: layout,
            testId: testId,
            children: children
        })
    });
};
var $08fe944bdcd177c2$export$2e2bcd8739ae039 = $08fe944bdcd177c2$var$GridWrapper;

});
parcelRegister("itnZ9", function(module, exports) {

$parcel$export(module.exports, "Grid", () => $92e4fcbfc398e3a4$export$ef2184bd89960b14);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $f1WIN = parcelRequire("f1WIN");

var $ephoW = parcelRequire("ephoW");
function $92e4fcbfc398e3a4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $92e4fcbfc398e3a4$var$gridStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'flex',
    margin: '0 auto',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: `0 calc(var(${(0, $f1WIN.varGridSpacing)}) / 2)`,
    position: 'relative',
    alignItems: 'flex-start',
    flexWrap: 'wrap'
});
const $92e4fcbfc398e3a4$var$gridLayoutStyles = {
    fixed: /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(var(${(0, $f1WIN.varColumnsNum)}) * ${(0, $f1WIN.defaultGridColumnWidth)}px)`
    }),
    fluid: {
        name: "qhxz92",
        styles: "max-width:100%"
    }
};
const $92e4fcbfc398e3a4$var$nestedGridStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `0 calc(-1 * var(${(0, $f1WIN.varGridSpacing)}))`
});
const $92e4fcbfc398e3a4$export$ef2184bd89960b14 = ({ layout: layout = (0, $f1WIN.defaultLayout), testId: testId, children: children })=>{
    const { isNested: isNested, columns: columns, spacing: spacing } = (0, $5uXOq.useContext)((0, $ephoW.GridContext));
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $92e4fcbfc398e3a4$var$gridStyles,
            $92e4fcbfc398e3a4$var$gridLayoutStyles[layout],
            isNested && $92e4fcbfc398e3a4$var$nestedGridStyles
        ],
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $f1WIN.varColumnsNum)]: columns,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $f1WIN.varGridSpacing)]: `${(0, $f1WIN.spacingMapping)[spacing]}px`
        },
        "data-testid": testId
    }, children);
};

});
parcelRegister("ephoW", function(module, exports) {

$parcel$export(module.exports, "GridContext", () => $529bf77650fbff0f$export$11cae3e04ab99fae);

var $5uXOq = parcelRequire("5uXOq");

var $f1WIN = parcelRequire("f1WIN");
const $529bf77650fbff0f$export$11cae3e04ab99fae = /*#__PURE__*/ (0, $5uXOq.createContext)({
    isRoot: true,
    isNested: false,
    spacing: (0, $f1WIN.defaultSpacing),
    columns: (0, $f1WIN.defaultGridColumns)
});

});


parcelRegister("aZdfU", function(module, exports) {

$parcel$export(module.exports, "GridColumnContext", () => $11b791725219e059$export$1229ad7112b989f5);
$parcel$export(module.exports, "default", () => $11b791725219e059$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $f1WIN = parcelRequire("f1WIN");

var $ephoW = parcelRequire("ephoW");
/**
 * Determines the method by which column width is calculated.
 */ var $11b791725219e059$var$ColumnVariant = /*#__PURE__*/ function(ColumnVariant) {
    /**
   * Column occupies available space.
   *
   * Used when `medium` is 0 (the default).
   */ ColumnVariant["Auto"] = "auto";
    /**
   * Column occupies specified space.
   *
   * Used when 0 < `medium` < `columns`.
   */ ColumnVariant["Bounded"] = "bounded";
    /**
   * Column occupies entire row.
   *
   * Used when `medium` >= `columns`.
   *
   * This case is handled separately because of rounding.
   */ ColumnVariant["FullWidth"] = "fullWidth";
    return ColumnVariant;
}($11b791725219e059$var$ColumnVariant || {});
const $11b791725219e059$var$getVariant = ({ medium: medium, columns: columns })=>{
    if (medium === (0, $f1WIN.defaultMedium)) return "auto";
    else if (medium < columns) return "bounded";
    return "fullWidth";
};
/**
 * IE11 and Edge both have rounding issues for flexbox which is why a width of
 * 99.9999% is used. Using 100% here causes columns to wrap prematurely.
 */ const $11b791725219e059$var$availableWidth = '99.9999%';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $11b791725219e059$var$singleColumnWidth = `(${$11b791725219e059$var$availableWidth} / var(${(0, $f1WIN.varColumnsNum)}))`;
const $11b791725219e059$var$gridColumnStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    minWidth: `calc(${$11b791725219e059$var$singleColumnWidth} - var(${(0, $f1WIN.varGridSpacing)}))`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `0 calc(var(${(0, $f1WIN.varGridSpacing)}) / 2)`,
    flexGrow: 1,
    flexShrink: 0,
    wordWrap: 'break-word'
});
const $11b791725219e059$var$gridColumnWidthStyles = {
    ["auto"]: /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(100% - var(${(0, $f1WIN.varGridSpacing)}))`,
        flexBasis: `auto`
    }),
    ["bounded"]: /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(${$11b791725219e059$var$singleColumnWidth} *  var(${(0, $f1WIN.varColumnSpan)}) - var(${(0, $f1WIN.varGridSpacing)}))`,
        flexBasis: `100%`
    }),
    ["fullWidth"]: /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: `calc(100% - var(${(0, $f1WIN.varGridSpacing)}))`,
        flexBasis: `100%`
    })
};
const $11b791725219e059$export$1229ad7112b989f5 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    medium: (0, $f1WIN.defaultMedium)
});
/**
 * __Grid column__
 *
 * A grid column can span one or more column positions within a grid.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ const $11b791725219e059$var$GridColumn = ({ medium: medium = (0, $f1WIN.defaultMedium), children: children, testId: testId })=>{
    const { columns: columns } = (0, $5uXOq.useContext)((0, $ephoW.GridContext));
    const contextValue = (0, $5uXOq.useMemo)(()=>({
            medium: medium
        }), [
        medium
    ]);
    /**
   * The real column span,
   * obtained by clamping the passed `medium` value within the allowed range.
   */ const colSpan = Math.max(1, Math.min(medium, columns));
    /**
   * How we should calculate the column width.
   */ const variant = $11b791725219e059$var$getVariant({
        medium: medium,
        columns: columns
    });
    return /*#__PURE__*/ (0, $f8Sb3.jsx)($11b791725219e059$export$1229ad7112b989f5.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: [
            $11b791725219e059$var$gridColumnStyles,
            $11b791725219e059$var$gridColumnWidthStyles[variant]
        ],
        style: {
            /**
       * The 'auto' value here isn't actually consumed anywhere and is
       * just to better reflect what is happening when inspecting CSS.
       */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $f1WIN.varColumnSpan)]: variant === "auto" ? 'auto' : colSpan
        },
        "data-testid": testId
    }, children));
};
var $11b791725219e059$export$2e2bcd8739ae039 = $11b791725219e059$var$GridColumn;

});



parcelRegister("gEQzr", function(module, exports) {

$parcel$export(module.exports, "PersonalSettingsBreadcrumbItem", () => $c0b187832616c1cc$export$8d4b46ece371da50);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $fuUnn = parcelRequire("fuUnn");

var $7iULw = parcelRequire("7iULw");

var $coTzA = parcelRequire("coTzA");

var $koVbs = parcelRequire("koVbs");

var $2PRPN = parcelRequire("2PRPN");

const $c0b187832616c1cc$export$fa63c8dd87ea8148 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $coTzA.FeedbackCollectorButton), {
        entrypointId: (0, $7iULw.ENTRYPOINT_ID_JIRA_PLATFORM),
        feedbackGroupId: "personal-settings-sidebar"
    });
const $c0b187832616c1cc$var$TextBreadcrumbItem = /*#__PURE__*/ (0, $5uXOq.forwardRef)((_props, _ref)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c0b187832616c1cc$var$PlainBreadcrumbItem, null, formatMessage((0, $2PRPN.default).personalSettingsBreadcrumb));
});
const $c0b187832616c1cc$export$8d4b46ece371da50 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fuUnn.default), {
        component: $c0b187832616c1cc$var$TextBreadcrumbItem,
        text: ""
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c0b187832616c1cc$var$PlainBreadcrumbItem = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1rjcv77o _kqswh2mm _syaz131l",
            __cmplp.className
        ])
    });
});

});
parcelRegister("coTzA", function(module, exports) {

$parcel$export(module.exports, "FeedbackCollectorButton", () => $85f5e51eda76fbac$export$b39479f42d974760);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $aEHvW = parcelRequire("aEHvW");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $koeKL = parcelRequire("koeKL");

var $4R6GH = parcelRequire("4R6GH");

var $7iULw = parcelRequire("7iULw");

var $dseDh = parcelRequire("dseDh");

var $4uMrp = parcelRequire("4uMrp");
const $85f5e51eda76fbac$var$TooltipWrapper = ({ children: children, appearance: appearance, customLabel: customLabel })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (appearance === 'icon') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: customLabel || formatMessage((0, $4uMrp.messages).leaveFeedback),
        position: "top"
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};
const $85f5e51eda76fbac$export$b39479f42d974760 = ({ buttonAppearance: buttonAppearance = 'normal', testId: testId, icon: Icon = (0, (/*@__PURE__*/$parcel$interopDefault($aEHvW))), feedbackButtonCustomLabel: feedbackButtonCustomLabel, ...feedbackCollectorProps })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const cloudId = (0, $koeKL.useCloudId)();
    const { openFeedbackCollector: openFeedbackCollector } = (0, $dseDh.useFeedbackCollectorActions)();
    const buttonRef = (0, $5uXOq.useRef)(null);
    const onOpen = (0, $5uXOq.useCallback)(()=>{
        // Check if feedbackContext already contains the cloud ID entry
        const hasCloudId = feedbackCollectorProps?.feedbackContext?.some((entry)=>entry.id === (0, $7iULw.EntryKeys).CLOUD_ID);
        // If not, add cloud id to feedback context
        const updatedFeedbackContext = hasCloudId ? feedbackCollectorProps.feedbackContext : [
            ...feedbackCollectorProps.feedbackContext || [],
            {
                id: (0, $7iULw.EntryKeys).CLOUD_ID,
                value: cloudId
            }
        ];
        openFeedbackCollector({
            ...feedbackCollectorProps,
            feedbackContext: updatedFeedbackContext,
            triggerRef: buttonRef
        });
    }, [
        cloudId,
        feedbackCollectorProps,
        openFeedbackCollector
    ]);
    const displayAsLink = buttonAppearance === 'link';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($85f5e51eda76fbac$var$TooltipWrapper, {
        appearance: buttonAppearance,
        customLabel: feedbackButtonCustomLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($85f5e51eda76fbac$var$StyledButton, {
        testId: testId,
        ref: buttonRef,
        appearance: displayAsLink ? 'link' : 'subtle',
        isHighlight: buttonAppearance === 'highlight',
        spacing: displayAsLink ? 'none' : 'default',
        onClick: onOpen,
        iconBefore: displayAsLink ? undefined : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Icon, {
            color: buttonAppearance === 'highlight' ? "var(--ds-text-discovery, #5E4DB2)" : "var(--ds-text, #172B4D)",
            label: ""
        }),
        "aria-label": // Only add aria-label if this is an icon button
        buttonAppearance === 'icon' && (feedbackButtonCustomLabel || formatMessage((0, $4uMrp.messages).leaveFeedback)) || '',
        ...(0, $4R6GH.fg)('jfp_a11y_autodev_feedback_collector_aria_popup') ? {
            'aria-haspopup': 'dialog'
        } : {}
    }, buttonAppearance !== 'icon' && (feedbackButtonCustomLabel || formatMessage((0, $4uMrp.messages).leaveFeedback))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $85f5e51eda76fbac$var$StyledButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $fVnbM.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            __cmplp.isHighlight && "_1w901u28 _16hgp7j4 _1fh11u28 _u1mb1jkz _r7smdh45 _1l5a1gfe",
            __cmplp.className
        ])
    });
});

});
parcelRegister("aEHvW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c129a0bf5d2aeea221ba2044e3fd85fd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7c1f64cf4f9c421f$var$_react = $7c1f64cf4f9c421f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $7c1f64cf4f9c421f$var$_feedback = $7c1f64cf4f9c421f$var$_interopRequireDefault((parcelRequire("5dqGX")));

var $7c1f64cf4f9c421f$var$_feedback2 = $7c1f64cf4f9c421f$var$_interopRequireDefault((parcelRequire("3g1Fk")));
function $7c1f64cf4f9c421f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for FeedbackIcon.
 * This component is FeedbackIcon, with `UNSAFE_fallbackIcon` set to "FeedbackIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: customer feedback.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7c1f64cf4f9c421f$var$FeedbackIcon = (props)=>/*#__PURE__*/ $7c1f64cf4f9c421f$var$_react.default.createElement($7c1f64cf4f9c421f$var$_feedback.default, Object.assign({
        LEGACY_fallbackIcon: $7c1f64cf4f9c421f$var$_feedback2.default
    }, props));
$7c1f64cf4f9c421f$var$FeedbackIcon.Name = 'FeedbackIconMigration';
var $7c1f64cf4f9c421f$var$_default = module.exports.default = $7c1f64cf4f9c421f$var$FeedbackIcon;

});
parcelRegister("5dqGX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f238518c984ab5d0530bd2cff7eccbeb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3cc2df171aca9493$var$_react = $3cc2df171aca9493$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3cc2df171aca9493$var$_baseNew = $3cc2df171aca9493$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $3cc2df171aca9493$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Feedback".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: customer feedback.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3cc2df171aca9493$var$FeedbackIcon = (props)=>/*#__PURE__*/ $3cc2df171aca9493$var$_react.default.createElement($3cc2df171aca9493$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6.221l-4.064 2.63A.75.75 0 0 1 1 15V9.5h1.5v4.121l3.093-2A.75.75 0 0 1 6 11.5h7a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v2.75a.5.5 0 0 0 .5.5h5.44L7.22 5.03l1.06-1.06 2.5 2.5a.75.75 0 0 1 0 1.06l-2.5 2.5-1.06-1.06 1.22-1.22H3a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$3cc2df171aca9493$var$FeedbackIcon.displayName = 'FeedbackIcon';
var $3cc2df171aca9493$var$_default = module.exports.default = $3cc2df171aca9493$var$FeedbackIcon;

});

parcelRegister("3g1Fk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $25f4287f17f73dc4$var$_react = $25f4287f17f73dc4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $25f4287f17f73dc4$var$_feedback = $25f4287f17f73dc4$var$_interopRequireDefault((parcelRequire("5dqGX")));
function $25f4287f17f73dc4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $25f4287f17f73dc4$var$FeedbackIcon = (props)=>/*#__PURE__*/ $25f4287f17f73dc4$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m10.88 5.48-8.43 6.83c-.4.32-.58.96-.41 1.42l.1.27c.17.46.73.83 1.23.82l1.13-.02 6.06-.1 3.65-.06c.51-.01.79-.38.62-.86l-2.92-8.03c-.1-.29-.32-.44-.57-.44a.73.73 0 0 0-.46.18m-5.9 10.46 1.75 4.82a1 1 0 1 0 1.88-.68l-1.54-4.23zm13.71-9.11-2.82 1.03a1 1 0 1 0 .68 1.88l2.82-1.03a1 1 0 1 0-.68-1.88m-1.79 3.85a1 1 0 0 0-.64.77 1 1 0 0 0 .81 1.16l2.96.52a1 1 0 0 0 1.12-1.3l-.02-.05a1 1 0 0 0-.76-.62l-2.95-.52a.97.97 0 0 0-.51.05m-.56-7.65-1.93 2.3a1 1 0 0 0 1.53 1.29l1.93-2.3a1 1 0 0 0-.76-1.64 1 1 0 0 0-.77.36"/></svg>`
    }, props, {
        newIcon: $25f4287f17f73dc4$var$_feedback.default
    }));
$25f4287f17f73dc4$var$FeedbackIcon.displayName = 'FeedbackIcon';
var $25f4287f17f73dc4$var$_default = module.exports.default = $25f4287f17f73dc4$var$FeedbackIcon;

});


parcelRegister("4uMrp", function(module, exports) {

$parcel$export(module.exports, "messages", () => $0c42512912e196d1$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $0c42512912e196d1$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    leaveFeedback: {
        "id": "platform.feedback.feedback-collector.button.leave-feedback",
        "defaultMessage": "Give feedback"
    }
});

});


parcelRegister("2PRPN", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e7d4d450e3a77fc$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $6e7d4d450e3a77fc$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    personalSettingsBreadcrumb: {
        "id": "personal-settings-common.breadcrumb",
        "defaultMessage": "Personal settings"
    }
});

});


parcelRegister("dcT9d", function(module, exports) {

$parcel$export(module.exports, "FieldWrapper", () => $66abb1990c47baf8$export$6a00f65eec6002a6);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $66abb1990c47baf8$export$d586e0ae81c7b89b = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _zulpu2gc _p12fgx0z _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $66abb1990c47baf8$export$6a00f65eec6002a6 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulppxbi _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});

});

parcelRegister("FvXgY", function(module, exports) {

$parcel$export(module.exports, "GlobalNotificationConfigTableNew", () => $53b3d977b492b6f4$export$8dbfdb8bc461bd45);

var $7Q8y5 = parcelRequire("7Q8y5");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $6tRzQ = parcelRequire("6tRzQ");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $jgJNO = parcelRequire("jgJNO");

var $iXVV6 = parcelRequire("iXVV6");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");


var $alXN4 = parcelRequire("alXN4");

var $1pLvM = parcelRequire("1pLvM");

var $hShCB = parcelRequire("hShCB");

var $dxt1X = parcelRequire("dxt1X");

var $1rVbx = parcelRequire("1rVbx");

var $jeTJ6 = parcelRequire("jeTJ6");

var $aydym = parcelRequire("aydym");

var $iDjms = parcelRequire("iDjms");
const $53b3d977b492b6f4$export$8dbfdb8bc461bd45 = ({ allPreferencesData: allPreferencesData })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const globalHeadMutationInProduct = (0, $aydym.useGlobalHeadMutation)({
        channel: (0, $e7aa8280669c3543$export$201863d4c54f4831)
    });
    const globalHeadMutationEmail = (0, $aydym.useGlobalHeadMutation)({
        channel: (0, $e7aa8280669c3543$export$61171c632678b12e)
    });
    const globalRowMutation = (0, $iDjms.useGlobalRowMutation)();
    const [isInfoPanelOpen, setIsInfoPanelOpen] = (0, $5uXOq.useState)(false);
    const allPreferences = (0, $8Uumt.useFragment)((0, $7Q8y5.default), allPreferencesData);
    const { preferences: preferences } = allPreferences;
    const emailGlobalHeadCheckboxId = 'email';
    const inProductGlobalHeadCheckboxId = 'inProduct';
    const headCheckboxIds = {
        EMAIL: emailGlobalHeadCheckboxId,
        IN_PRODUCT: inProductGlobalHeadCheckboxId
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "personalSettingsGlobalNotifications",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($53b3d977b492b6f4$var$DefaultNotificationHeader, null, formatMessage((0, $6s1PB.expVal)('spike-itr-rollout-strategy', 'is_enabled', false) ? (0, $alXN4.default).defaultNotificationSettings : (0, $alXN4.default).defaultNotificationSettings)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($53b3d977b492b6f4$var$DefaultNotificationHeaderDescription, null, formatMessage((0, $alXN4.default).defaultNotificationSettingsDescription))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($53b3d977b492b6f4$var$GlobalContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $53b3d977b492b6f4$var$tableWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jeTJ6.Table), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jeTJ6.TableHeadContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jeTJ6.TableHeadRowContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jeTJ6.HeadCellContainer), null, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $alXN4.default).notificationColumnHeaderAllIssuesIssueTermRefresh : (0, $alXN4.default).notificationColumnHeaderAllIssues)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dxt1X.HeadCellCheckboxContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hShCB.HeadCheckbox), {
        id: `all-issues-${inProductGlobalHeadCheckboxId}`,
        commitMutation: globalHeadMutationInProduct,
        channel: (0, $e7aa8280669c3543$export$201863d4c54f4831),
        enabledDataFragment: allPreferences,
        label: formatMessage((0, $alXN4.default).inProductColumnHeader),
        allPreferences: preferences,
        categories: [
            'ISSUE_ASSIGNED',
            'ISSUE_MENTIONED'
        ]
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dxt1X.HeadCellCheckboxContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hShCB.HeadCheckbox), {
        id: `all-issues-${emailGlobalHeadCheckboxId}`,
        commitMutation: globalHeadMutationEmail,
        channel: (0, $e7aa8280669c3543$export$61171c632678b12e),
        enabledDataFragment: allPreferences,
        label: formatMessage((0, $alXN4.default).emailColumnHeader),
        allPreferences: preferences,
        categories: [
            'ISSUE_ASSIGNED',
            'ISSUE_MENTIONED'
        ]
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jeTJ6.TBody), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rVbx.NotificationsConfigRow), {
        preference: preferences.issueAssigned,
        allPreferences: preferences,
        enabledDataFragment: allPreferences,
        label: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $alXN4.default).issueAssignedTypeIssueTermRefresh : (0, $alXN4.default).issueAssignedType),
        id: "issueAssigned",
        headCheckboxIds: headCheckboxIds,
        commitMutation: globalRowMutation
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rVbx.NotificationsConfigRow), {
        preference: preferences.mentionsCombined,
        allPreferences: preferences,
        enabledDataFragment: allPreferences,
        label: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $alXN4.default).mentionsCombinedTypeIssueTermRefresh : (0, $alXN4.default).mentionsCombinedType),
        id: "mentionsCombined",
        headCheckboxIds: headCheckboxIds,
        commitMutation: globalRowMutation
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $53b3d977b492b6f4$var$tableWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jeTJ6.Table), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jeTJ6.TableHeadContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jeTJ6.TableHeadRowContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jeTJ6.HeadCellContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center"
    }, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $alXN4.default).notificationColumnHeaderRelevantIssuesIssueTermRefresh : (0, $alXN4.default).notificationColumnHeaderRelevantIssues), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        placement: "right-start",
        messageId: "personal-settings-notifications-config-table.ui.global-notifications-config-table.popup",
        messageType: "transactional",
        isOpen: isInfoPanelOpen,
        onClose: ()=>{
            setIsInfoPanelOpen(false);
        },
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                padding: "space.200"
            }, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $alXN4.default).relevantIssueNotificationTableInfoIconTextIssueTermRefresh : (0, $alXN4.default).relevantIssueNotificationTableInfoIconText)),
        trigger: ({ 'aria-expanded': _, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                xcss: $53b3d977b492b6f4$var$infoIconStyles,
                onMouseEnter: ()=>{
                    setIsInfoPanelOpen(true);
                },
                onMouseLeave: ()=>{
                    setIsInfoPanelOpen(false);
                },
                testId: "personal-settings-notifications-config-table.ui.global-notifications-config-table.warning-pop-up-button-container" // eslint-disable-next-line react/jsx-props-no-spreading
                ,
                ...triggerProps
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6tRzQ))), {
                spacing: "spacious",
                label: "warning",
                color: "var(--ds-icon-accent-gray, #758195)"
            }))
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dxt1X.HeadCellCheckboxContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hShCB.HeadCheckbox), {
        id: `relevant-issues-${inProductGlobalHeadCheckboxId}`,
        commitMutation: globalHeadMutationInProduct,
        channel: (0, $e7aa8280669c3543$export$201863d4c54f4831),
        enabledDataFragment: allPreferences,
        label: formatMessage((0, $alXN4.default).inProductColumnHeader),
        allPreferences: preferences,
        categories: [
            'ISSUE_CHANGES',
            'COMMENT_CHANGES',
            'ISSUE_WORKLOG_CHANGES',
            'ISSUE_MISCELLANEOUS'
        ]
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dxt1X.HeadCellCheckboxContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hShCB.HeadCheckbox), {
        id: `relevant-issues-${emailGlobalHeadCheckboxId}`,
        commitMutation: globalHeadMutationEmail,
        channel: (0, $e7aa8280669c3543$export$61171c632678b12e),
        enabledDataFragment: allPreferences,
        label: formatMessage((0, $alXN4.default).emailColumnHeader),
        allPreferences: preferences,
        categories: [
            'ISSUE_CHANGES',
            'COMMENT_CHANGES',
            'ISSUE_WORKLOG_CHANGES',
            'ISSUE_MISCELLANEOUS'
        ]
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jeTJ6.TBody), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1pLvM.NotificationsConfigRow), {
        allPreferences: preferences,
        enabledDataFragment: allPreferences,
        label: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $alXN4.default).issueChangesCategoryTypeIssueTermRefresh : (0, $alXN4.default).issueChangesCategoryType),
        id: "issueChanges",
        headCheckboxIds: headCheckboxIds,
        onRowMutation: globalRowMutation,
        onEmailHeadMutation: globalHeadMutationEmail,
        onInProductHeadMutation: globalHeadMutationInProduct,
        category: "ISSUE_CHANGES"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1pLvM.NotificationsConfigRow), {
        allPreferences: preferences,
        enabledDataFragment: allPreferences,
        label: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $alXN4.default).commentChangesCategoryTypeIssueTermRefresh : (0, $alXN4.default).commentChangesCategoryType),
        id: "commentChanges",
        headCheckboxIds: headCheckboxIds,
        onRowMutation: globalRowMutation,
        onEmailHeadMutation: globalHeadMutationEmail,
        onInProductHeadMutation: globalHeadMutationInProduct,
        category: "COMMENT_CHANGES"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rVbx.NotificationsConfigRow), {
        preference: preferences.worklogCombined,
        allPreferences: preferences,
        enabledDataFragment: allPreferences,
        label: formatMessage((0, $alXN4.default).worklogCombinedType),
        id: "worklogCombined",
        headCheckboxIds: headCheckboxIds,
        commitMutation: globalRowMutation
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rVbx.NotificationsConfigRow), {
        preference: preferences.miscellaneousIssueEventCombined,
        allPreferences: preferences,
        enabledDataFragment: allPreferences,
        label: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $alXN4.default).miscellaneousIssueEventCombinedIssueTermRefresh : (0, $alXN4.default).miscellaneousIssueEventCombined),
        id: "miscellaneousIssueEventCombined",
        headCheckboxIds: headCheckboxIds,
        commitMutation: globalRowMutation
    }))))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $53b3d977b492b6f4$var$GlobalContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1b66 _vchhusvi _19pku2gc _otyr1ejb _bfhkqbzx _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $53b3d977b492b6f4$var$DefaultNotificationHeader = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "h5", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});
const $53b3d977b492b6f4$var$infoIconStyles = (0, $8CUq3.xcss)({
    marginLeft: 'space.100',
    marginTop: 'space.025'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $53b3d977b492b6f4$var$DefaultNotificationHeaderDescription = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});
const $53b3d977b492b6f4$var$tableWrapperStyles = (0, $8CUq3.xcss)({
    borderWidth: 'border.width',
    borderStyle: 'solid',
    borderColor: 'color.border',
    backgroundColor: 'elevation.surface.raised',
    borderRadius: 'border.radius.050',
    marginBottom: 'space.200',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':last-of-type': {
        marginBottom: 'space.0'
    }
});

});
parcelRegister("7Q8y5", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7f7d2e7cb6478c3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9a35271c47791376042f2505e0464c7f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f7f7d2e7cb6478c3$var$node = function() {
    var v0 = [
        {
            "kind": "FragmentSpread",
            "name": "notificationsConfigRow_personalSettingsNotificationsConfigTable_preference"
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "globalNotificationsConfigTable_personalSettingsNotificationsConfigTable_GlobalNotificationConfigTableNew",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "notificationsConfigHead_personalSettingsNotificationsConfigTable_HeadCheckbox_enabledDataFragment"
            },
            {
                "kind": "FragmentSpread",
                "name": "notificationsAccordianRow_personalSettingsNotificationsConfigTable_NotificationsConfigRow_enabledDataFragment"
            },
            {
                "kind": "FragmentSpread",
                "name": "notificationsConfigRow_personalSettingsNotificationsConfigTable_enabledDataFragment"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraNotificationPreferences",
                    "kind": "LinkedField",
                    "name": "preferences",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "notificationsConfigHead_personalSettingsNotificationsConfigTable_HeadCheckbox_allPreferences"
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "notificationsAccordianRow_personalSettingsNotificationsConfigTable_NotificationsConfigRow_allPreferences"
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "notificationsConfigRow_personalSettingsNotificationsConfigTable_allPreferences"
                        },
                        {
                            "kind": "RequiredField",
                            "field": {
                                "concreteType": "JiraNotificationPreference",
                                "kind": "LinkedField",
                                "name": "issueAssigned",
                                "plural": false,
                                "selections": v0 /*: any*/ 
                            },
                            "action": "THROW",
                            "path": "preferences.issueAssigned"
                        },
                        {
                            "kind": "RequiredField",
                            "field": {
                                "concreteType": "JiraNotificationPreference",
                                "kind": "LinkedField",
                                "name": "mentionsCombined",
                                "plural": false,
                                "selections": v0 /*: any*/ 
                            },
                            "action": "THROW",
                            "path": "preferences.mentionsCombined"
                        },
                        {
                            "kind": "RequiredField",
                            "field": {
                                "concreteType": "JiraNotificationPreference",
                                "kind": "LinkedField",
                                "name": "worklogCombined",
                                "plural": false,
                                "selections": v0 /*: any*/ 
                            },
                            "action": "THROW",
                            "path": "preferences.worklogCombined"
                        },
                        {
                            "kind": "RequiredField",
                            "field": {
                                "concreteType": "JiraNotificationPreference",
                                "kind": "LinkedField",
                                "name": "miscellaneousIssueEventCombined",
                                "plural": false,
                                "selections": v0 /*: any*/ 
                            },
                            "action": "THROW",
                            "path": "preferences.miscellaneousIssueEventCombined"
                        }
                    ]
                },
                "action": "THROW",
                "path": "preferences"
            }
        ],
        "type": "JiraNotificationGlobalPreference"
    };
}();
$f7f7d2e7cb6478c3$var$node.hash = "d955dfbbde5b59fa912afe327338038b";
var $f7f7d2e7cb6478c3$export$2e2bcd8739ae039 = $f7f7d2e7cb6478c3$var$node;

});

const $e7aa8280669c3543$export$201863d4c54f4831 = 'IN_PRODUCT';
const $e7aa8280669c3543$export$61171c632678b12e = 'EMAIL';

parcelRegister("alXN4", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1f161e1a6e42919$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f1f161e1a6e42919$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    notificationColumnHeader: {
        "id": "personal-settings-notifications-config-table.common.notification-column-header",
        "defaultMessage": "Notification"
    },
    notificationColumnHeaderAllIssues: {
        "id": "personal-settings-notifications-config-table.common.notification-column-header-all-issues",
        "defaultMessage": "Notifications for all issues"
    },
    notificationColumnHeaderRelevantIssues: {
        "id": "personal-settings-notifications-config-table.common.notification-column-header-relevant-issues",
        "defaultMessage": "Notifications for relevant issues"
    },
    relevantIssueNotificationTableInfoIconText: {
        "id": "personal-settings-notifications-config-table.common.relevant-issue-notification-table-info-icon-text",
        "defaultMessage": "An issue is considered relevant to you if you\u2019re watching it, or if you\u2019re the issue\u2019s reporter or assignee."
    },
    emailColumnHeader: {
        "id": "personal-settings-notifications-config-table.common.email-column-header",
        "defaultMessage": "Email"
    },
    inProductColumnHeader: {
        "id": "personal-settings-notifications-config-table.common.in-product-column-header",
        "defaultMessage": "In product"
    },
    issueAssignedType: {
        "id": "personal-settings-notifications-config-table.common.issue-assigned-type",
        "defaultMessage": "You\u2019re assigned to an issue"
    },
    mentionedNotificationType: {
        "id": "personal-settings-notifications-config-table.common.mentioned-notification-type",
        "defaultMessage": "You\u2019re mentioned on an issue"
    },
    issueDeletedType: {
        "id": "personal-settings-notifications-config-table.common.issue-deleted-type",
        "defaultMessage": "An issue is deleted"
    },
    issueUpdatedType: {
        "id": "personal-settings-notifications-config-table.common.issue-updated-type",
        "defaultMessage": "An issue is edited"
    },
    commentCreatedType: {
        "id": "personal-settings-notifications-config-table.common.comment-created-type",
        "defaultMessage": "A comment is added"
    },
    commentEditedType: {
        "id": "personal-settings-notifications-config-table.common.comment-edited-type",
        "defaultMessage": "A comment is edited"
    },
    commentDeletedType: {
        "id": "personal-settings-notifications-config-table.common.comment-deleted-type",
        "defaultMessage": "A comment is deleted"
    },
    issueCreatedType: {
        "id": "personal-settings-notifications-config-table.common.issue-created-type",
        "defaultMessage": "An issue is created"
    },
    issueMovedType: {
        "id": "personal-settings-notifications-config-table.common.issue-moved-type",
        "defaultMessage": "An issue is moved"
    },
    mentionsCombinedType: {
        "id": "personal-settings-notifications-config-table.common.mentions-combined-type",
        "defaultMessage": "You\u2019re mentioned on an issue"
    },
    worklogCombinedType: {
        "id": "personal-settings-notifications-config-table.common.worklog-combined-type",
        "defaultMessage": "A work log is created, edited, or deleted"
    },
    miscellaneousIssueEventCombined: {
        "id": "personal-settings-notifications-config-table.common.miscellaneous-issue-event-combined",
        "defaultMessage": "Other issue events (including a change to an issue's status)"
    },
    defaultNotificationSettings: {
        "id": "personal-settings-notifications-config-table.common.default-notification-settings",
        "defaultMessage": "Default notification settings"
    },
    defaultNotificationSettingsDescription: {
        "id": "personal-settings-notifications-config-table.common.default-notification-settings-description",
        "defaultMessage": "Default notification settings apply across your projects. These can be overridden by your email preferences, or by custom project notifications settings."
    },
    issueChangesCategoryType: {
        "id": "personal-settings-notifications-config-table.common.issue-changes-category-type",
        "defaultMessage": "Changes to issues"
    },
    commentChangesCategoryType: {
        "id": "personal-settings-notifications-config-table.common.comment-changes-category-type",
        "defaultMessage": "Changes to comments on issues"
    },
    notificationColumnHeaderAllIssuesIssueTermRefresh: {
        "id": "personal-settings-notifications-config-table.common.notification-column-header-all-issues-issue-term-refresh",
        "defaultMessage": "Notifications for all work items"
    },
    notificationColumnHeaderRelevantIssuesIssueTermRefresh: {
        "id": "personal-settings-notifications-config-table.common.notification-column-header-relevant-issues-issue-term-refresh",
        "defaultMessage": "Notifications for relevant work items"
    },
    relevantIssueNotificationTableInfoIconTextIssueTermRefresh: {
        "id": "personal-settings-notifications-config-table.common.relevant-issue-notification-table-info-icon-text-issue-term-refresh",
        "defaultMessage": "A work item is considered relevant to you if you\u2019re watching it, or if you\u2019re the reporter or assignee."
    },
    issueAssignedTypeIssueTermRefresh: {
        "id": "personal-settings-notifications-config-table.common.issue-assigned-type-issue-term-refresh",
        "defaultMessage": "You\u2019re assigned to a work item"
    },
    mentionedNotificationTypeIssueTermRefresh: {
        "id": "personal-settings-notifications-config-table.common.mentioned-notification-type-issue-term-refresh",
        "defaultMessage": "You\u2019re mentioned on a work item"
    },
    issueDeletedTypeIssueTermRefresh: {
        "id": "personal-settings-notifications-config-table.common.issue-deleted-type-issue-term-refresh",
        "defaultMessage": "A work item is deleted"
    },
    issueUpdatedTypeIssueTermRefresh: {
        "id": "personal-settings-notifications-config-table.common.issue-updated-type-issue-term-refresh",
        "defaultMessage": "A work item is edited"
    },
    issueCreatedTypeIssueTermRefresh: {
        "id": "personal-settings-notifications-config-table.common.issue-created-type-issue-term-refresh",
        "defaultMessage": "A work item is created"
    },
    issueMovedTypeIssueTermRefresh: {
        "id": "personal-settings-notifications-config-table.common.issue-moved-type-issue-term-refresh",
        "defaultMessage": "A work item is moved"
    },
    mentionsCombinedTypeIssueTermRefresh: {
        "id": "personal-settings-notifications-config-table.common.mentions-combined-type-issue-term-refresh",
        "defaultMessage": "You\u2019re mentioned on a work item"
    },
    miscellaneousIssueEventCombinedIssueTermRefresh: {
        "id": "personal-settings-notifications-config-table.common.miscellaneous-issue-event-combined-issue-term-refresh",
        "defaultMessage": "Other work item events (including a change to a work item's status)"
    },
    issueChangesCategoryTypeIssueTermRefresh: {
        "id": "personal-settings-notifications-config-table.common.issue-changes-category-type-issue-term-refresh",
        "defaultMessage": "Changes to work items"
    },
    commentChangesCategoryTypeIssueTermRefresh: {
        "id": "personal-settings-notifications-config-table.common.comment-changes-category-type-issue-term-refresh",
        "defaultMessage": "Changes to comments on work items"
    }
});

});

parcelRegister("1pLvM", function(module, exports) {

$parcel$export(module.exports, "NotificationsConfigRow", () => $fd597c25c6c731f9$export$9ea27a385922f0da);

var $fjePg = parcelRequire("fjePg");

var $fAc3s = parcelRequire("fAc3s");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $2NMNM = parcelRequire("2NMNM");

var $c8Oei = parcelRequire("c8Oei");

var $hWZau = parcelRequire("hWZau");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");

var $e5wyW = parcelRequire("e5wyW");

var $4R6GH = parcelRequire("4R6GH");


var $alXN4 = parcelRequire("alXN4");

var $9PRJl = parcelRequire("9PRJl");

var $h1xg5 = parcelRequire("h1xg5");

var $jeTJ6 = parcelRequire("jeTJ6");
const $fd597c25c6c731f9$var$ATTRIBUTES_FOR_SINGLE_ROW_UPDATE = {
    type: 'row',
    issueAssigned: 'unchanged',
    issueUpdated: 'unchanged',
    issueDeleted: 'unchanged',
    commentCreated: 'unchanged',
    commentEdited: 'unchanged',
    commentDeleted: 'unchanged',
    issueCreated: 'unchanged',
    issueMoved: 'unchanged',
    mentionsCombined: 'unchanged',
    worklogCombined: 'unchanged',
    miscellaneousIssueEventCombined: 'unchanged'
};
const $fd597c25c6c731f9$var$NOTIFICATIONS_CONFIG_TYPE_MAP_WITH_ISSUE_TERM = {
    ISSUE_ASSIGNED: 'issueAssignedType',
    ISSUE_UPDATED: 'issueUpdatedType',
    ISSUE_DELETED: 'issueDeletedType',
    COMMENT_CREATED: 'commentCreatedType',
    COMMENT_EDITED: 'commentEditedType',
    COMMENT_DELETED: 'commentDeletedType',
    ISSUE_CREATED: 'issueCreatedType',
    ISSUE_MOVED: 'issueMovedType',
    MENTIONS_COMBINED: 'mentionsCombinedType',
    WORKLOG_COMBINED: 'worklogCombinedType',
    MISCELLANEOUS_ISSUE_EVENT_COMBINED: 'miscellaneousIssueEventCombined'
};
const $fd597c25c6c731f9$var$NOTIFICATIONS_CONFIG_TYPE_MAP_ISSUE_TERM_REFRESH = {
    ISSUE_ASSIGNED: 'issueAssignedTypeIssueTermRefresh',
    ISSUE_UPDATED: 'issueUpdatedTypeIssueTermRefresh',
    ISSUE_DELETED: 'issueDeletedTypeIssueTermRefresh',
    COMMENT_CREATED: 'commentCreatedType',
    COMMENT_EDITED: 'commentEditedType',
    COMMENT_DELETED: 'commentDeletedType',
    ISSUE_CREATED: 'issueCreatedTypeIssueTermRefresh',
    ISSUE_MOVED: 'issueMovedTypeIssueTermRefresh',
    MENTIONS_COMBINED: 'mentionsCombinedTypeIssueTermRefresh',
    WORKLOG_COMBINED: 'worklogCombinedType',
    MISCELLANEOUS_ISSUE_EVENT_COMBINED: 'miscellaneousIssueEventCombinedIssueTermRefresh'
};
const $fd597c25c6c731f9$var$getNotificationsConfTypeMap = (0, $e5wyW.functionWithCondition)(()=>(0, $4R6GH.fg)('jira-issue-terminology-refresh-m3'), ()=>$fd597c25c6c731f9$var$NOTIFICATIONS_CONFIG_TYPE_MAP_ISSUE_TERM_REFRESH, ()=>$fd597c25c6c731f9$var$NOTIFICATIONS_CONFIG_TYPE_MAP_WITH_ISSUE_TERM);
const $fd597c25c6c731f9$var$NOTIFICATIONS_CONFIG_TYPE_MAP = $fd597c25c6c731f9$var$getNotificationsConfTypeMap();
const $fd597c25c6c731f9$var$CHECKBOX_STATES = {
    CHECKED: 'checked',
    INDERMINATE: 'indeterminate',
    UNCHECKED: 'unchecked'
};
const $fd597c25c6c731f9$var$snakeToCamelCase = (str)=>str.toLowerCase().replace(/([-_]\w)/g, (g)=>g[1].toUpperCase());
const $fd597c25c6c731f9$export$9ea27a385922f0da = ({ label: label, id: id, headCheckboxIds: headCheckboxIds, allPreferences: allPreferences, onRowMutation: onRowMutation, onEmailHeadMutation: onEmailHeadMutation, onInProductHeadMutation: onInProductHeadMutation, enabledDataFragment: enabledDataFragment, category: category, projectId: projectId = '' })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onToggle = (0, $5uXOq.useCallback)((event)=>{
        if (event.currentTarget.open && !isOpen) setIsOpen(true);
        else if (!event.currentTarget.open && isOpen) setIsOpen(false);
    }, [
        isOpen
    ]);
    const emailCheckboxId = `email-${id}`;
    const inProductCheckboxId = `inProduct-${id}`;
    const Chevron = isOpen ? (0, (/*@__PURE__*/$parcel$interopDefault($c8Oei))) : (0, (/*@__PURE__*/$parcel$interopDefault($hWZau)));
    const enabledData = (0, $8Uumt.useFragment)((0, $fAc3s.default), enabledDataFragment);
    const allData = (0, $8Uumt.useFragment)((0, $fjePg.default), allPreferences);
    const createJiraNotificationPreference = (0, $5uXOq.useCallback)((notificationType, isEnabled, channel, changedNotificationType)=>{
        const retVal = {
            type: allData[notificationType]?.type,
            id: allData[notificationType]?.id ?? '',
            emailChannel: {
                channel: allData[notificationType]?.emailChannel.channel,
                isEnabled: changedNotificationType === allData[notificationType]?.type && channel === (0, $e7aa8280669c3543$export$61171c632678b12e) ? isEnabled : allData[notificationType]?.emailChannel.isEnabled,
                isEditable: allData[notificationType]?.emailChannel.isEditable
            }
        };
        const inProductChannelName = allData[notificationType]?.inProductChannel;
        if (inProductChannelName) retVal.inProductChannel = {
            channel: inProductChannelName.channel,
            isEnabled: changedNotificationType === allData[notificationType]?.type && channel === (0, $e7aa8280669c3543$export$201863d4c54f4831) ? isEnabled : inProductChannelName.isEnabled,
            isEditable: inProductChannelName.isEditable
        };
        return retVal;
    }, [
        allData
    ]);
    const onCheckboxChange = (0, $5uXOq.useCallback)((event, channel, type)=>{
        const isEnabled = event.target.checked;
        if (!type) return; // TODO: Add error handling
        const newPreferences = {
            issueAssigned: createJiraNotificationPreference('issueAssigned', isEnabled, channel, type),
            issueCreated: createJiraNotificationPreference('issueCreated', isEnabled, channel, type),
            issueUpdated: createJiraNotificationPreference('issueUpdated', isEnabled, channel, type),
            issueDeleted: createJiraNotificationPreference('issueDeleted', isEnabled, channel, type),
            commentCreated: createJiraNotificationPreference('commentCreated', isEnabled, channel, type),
            commentEdited: createJiraNotificationPreference('commentEdited', isEnabled, channel, type),
            commentDeleted: createJiraNotificationPreference('commentDeleted', isEnabled, channel, type),
            issueMoved: createJiraNotificationPreference('issueMoved', isEnabled, channel, type),
            mentionsCombined: createJiraNotificationPreference('mentionsCombined', isEnabled, channel, type),
            worklogCombined: createJiraNotificationPreference('worklogCombined', isEnabled, channel, type),
            miscellaneousIssueEventCombined: createJiraNotificationPreference('miscellaneousIssueEventCombined', isEnabled, channel, type)
        };
        onRowMutation(channel, isEnabled, newPreferences, type);
        const camelType = $fd597c25c6c731f9$var$snakeToCamelCase(type);
        const trackAnalyticsAttributes = $fd597c25c6c731f9$var$ATTRIBUTES_FOR_SINGLE_ROW_UPDATE;
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'checkbox updated', 'notificationCheckbox', {
            channel: channel,
            ...trackAnalyticsAttributes,
            [camelType]: isEnabled ? 'checked' : 'unchecked'
        });
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'checkbox clicked', camelType, {
            channel: channel,
            value: isEnabled ? 'checked' : 'unchecked'
        });
    }, [
        onRowMutation,
        createAnalyticsEvent,
        createJiraNotificationPreference
    ]);
    const getChildren = (0, $5uXOq.useCallback)(()=>{
        const childrenDetails = {
            prefrerences: [],
            noOfEmailOptions: 0,
            noOfInProductOptions: 0,
            noOfEmailOptionsChecked: 0,
            noOfInProductOptionsChecked: 0
        };
        const preferences = Object.values(allData);
        const relevantPreferences = preferences.filter((pref)=>pref.category === category);
        childrenDetails.prefrerences = relevantPreferences;
        relevantPreferences.forEach((preference)=>{
            childrenDetails.noOfEmailOptions += preference.emailChannel.isEditable ? 1 : 0;
            childrenDetails.noOfInProductOptions += preference.inProductChannel?.isEditable ? 1 : 0;
            childrenDetails.noOfEmailOptionsChecked += preference.emailChannel.isEnabled ? 1 : 0;
            childrenDetails.noOfInProductOptionsChecked += preference.inProductChannel?.isEnabled ? 1 : 0;
        });
        return childrenDetails;
    }, [
        allData,
        category
    ]);
    const getCheckboxState = (totalOptions, checkedOptions)=>{
        if (checkedOptions === 0) return $fd597c25c6c731f9$var$CHECKBOX_STATES.UNCHECKED;
        if (totalOptions === checkedOptions) return $fd597c25c6c731f9$var$CHECKBOX_STATES.CHECKED;
        return $fd597c25c6c731f9$var$CHECKBOX_STATES.INDERMINATE;
    };
    const getHeaderCheckboxStatus = (0, $5uXOq.useCallback)((channel)=>{
        const { noOfEmailOptions: noOfEmailOptions, noOfEmailOptionsChecked: noOfEmailOptionsChecked, noOfInProductOptions: noOfInProductOptions, noOfInProductOptionsChecked: noOfInProductOptionsChecked } = getChildren();
        if (channel === (0, $e7aa8280669c3543$export$61171c632678b12e)) return getCheckboxState(noOfEmailOptions, noOfEmailOptionsChecked);
        if (channel === (0, $e7aa8280669c3543$export$201863d4c54f4831)) return getCheckboxState(noOfInProductOptions, noOfInProductOptionsChecked);
    }, [
        getChildren
    ]);
    const onHeadCheckboxChange = (0, $5uXOq.useCallback)((_event, channel)=>{
        // For a channel, if no notification types are selected or indeterminate, enable the channel.
        // Else disable the channel.
        const { noOfEmailOptions: noOfEmailOptions, noOfInProductOptions: noOfInProductOptions, noOfInProductOptionsChecked: noOfInProductOptionsChecked, noOfEmailOptionsChecked: noOfEmailOptionsChecked, prefrerences: prefrerences } = getChildren();
        const newPreferencesAsList = [];
        const newEmailChannelEnabledValue = noOfEmailOptionsChecked < noOfEmailOptions;
        const newInProductChannelEnabledValue = noOfInProductOptionsChecked < noOfInProductOptions;
        const getUpdatedEnabledValueForCurrentChannel = ()=>{
            if (channel === (0, $e7aa8280669c3543$export$61171c632678b12e)) return newEmailChannelEnabledValue;
            if (channel === (0, $e7aa8280669c3543$export$201863d4c54f4831)) return newInProductChannelEnabledValue;
        };
        const newPreferencesWithChannels = prefrerences.reduce((acc, notificationPreference)=>{
            if (channel === (0, $e7aa8280669c3543$export$61171c632678b12e)) {
                if (notificationPreference?.emailChannel.isEditable) {
                    if (notificationPreference.type) {
                        acc[$fd597c25c6c731f9$var$snakeToCamelCase(notificationPreference.type)] = createJiraNotificationPreference($fd597c25c6c731f9$var$snakeToCamelCase(notificationPreference.type), newEmailChannelEnabledValue, 'EMAIL', notificationPreference.type);
                        newPreferencesAsList.push({
                            type: notificationPreference.type,
                            isEnabled: newEmailChannelEnabledValue,
                            channel: channel
                        });
                    }
                }
            } else if (channel === (0, $e7aa8280669c3543$export$201863d4c54f4831)) {
                if (notificationPreference?.inProductChannel?.isEditable) {
                    if (notificationPreference.type) {
                        acc[$fd597c25c6c731f9$var$snakeToCamelCase(notificationPreference.type)] = createJiraNotificationPreference($fd597c25c6c731f9$var$snakeToCamelCase(notificationPreference.type), newInProductChannelEnabledValue, 'IN_PRODUCT', notificationPreference.type);
                        newPreferencesAsList.push({
                            type: notificationPreference.type,
                            isEnabled: newInProductChannelEnabledValue,
                            channel: channel
                        });
                    }
                }
            }
            return acc;
        }, {});
        if (allData) {
            const checkBoxStatus = getHeaderCheckboxStatus(channel);
            let previousValue = 'unchecked';
            let currentValue = 'checked';
            if (checkBoxStatus === $fd597c25c6c731f9$var$CHECKBOX_STATES.INDERMINATE) {
                previousValue = 'mixed';
                currentValue = 'checked';
            } else if (checkBoxStatus === $fd597c25c6c731f9$var$CHECKBOX_STATES.CHECKED) {
                previousValue = 'checked';
                currentValue = 'unchecked';
            }
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'checkbox updated', 'notificationCheckbox', {
                type: 'all',
                ...Object.keys(newPreferencesWithChannels).reduce((acc, key)=>{
                    let oldPreference;
                    if (channel === (0, $e7aa8280669c3543$export$61171c632678b12e)) oldPreference = allData[key].emailChannel.isEnabled;
                    else if (channel === (0, $e7aa8280669c3543$export$201863d4c54f4831)) oldPreference = allData[key].inProductChannel?.isEnabled;
                    const newPreference = getUpdatedEnabledValueForCurrentChannel();
                    if (oldPreference === newPreference) acc[key] = 'unchanged';
                    else if (newPreference) acc[key] = 'checked';
                    else acc[key] = 'unchecked';
                    return acc;
                }, {}),
                channel: channel
            });
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'checkbox clicked', 'all', {
                channel: channel,
                previousValue: previousValue,
                currentValue: currentValue
            });
            if (channel === (0, $e7aa8280669c3543$export$61171c632678b12e)) onEmailHeadMutation(newPreferencesAsList, newPreferencesWithChannels);
            if (channel === (0, $e7aa8280669c3543$export$201863d4c54f4831)) onInProductHeadMutation(newPreferencesAsList, newPreferencesWithChannels);
        }
    }, [
        getChildren,
        allData,
        createJiraNotificationPreference,
        getHeaderCheckboxStatus,
        createAnalyticsEvent,
        onEmailHeadMutation,
        onInProductHeadMutation
    ]);
    const renderChildren = (0, $5uXOq.useMemo)(()=>{
        const { prefrerences: prefrerences } = getChildren();
        return prefrerences.map((notificationPreference, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h1xg5.NotificationsConfigRow), {
                preference: notificationPreference,
                key: notificationPreference.id,
                headCheckboxIds: headCheckboxIds,
                label: formatMessage((0, $alXN4.default)[$fd597c25c6c731f9$var$NOTIFICATIONS_CONFIG_TYPE_MAP[notificationPreference.type]]),
                isOpen: isOpen,
                onChange: onCheckboxChange,
                isLastChild: index === prefrerences.length - 1,
                id: `${$fd597c25c6c731f9$var$snakeToCamelCase(notificationPreference.type)}${projectId ? `-${projectId}` : ''}`,
                isEmailNotificationDisabled: enabledData.options.isEmailNotificationEnabled === false
            }));
    }, [
        formatMessage,
        getChildren,
        headCheckboxIds,
        isOpen,
        onCheckboxChange,
        enabledData,
        projectId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fd597c25c6c731f9$var$TableRowContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jeTJ6.HeadCellContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("details", {
        "data-testid": `personal-settings-notifications-config-table.common.ui.accordion.accordion-wrapper-${id}`,
        onToggle: onToggle,
        open: isOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fd597c25c6c731f9$var$AccordianHeader, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $fd597c25c6c731f9$var$headerChevronStyles,
        paddingInline: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Chevron, {
        color: "var(--ds-icon, #44546F)",
        LEGACY_primaryColor: "var(--ds-icon, #44546F)",
        label: ""
    })), label)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jeTJ6.HeadCellContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9PRJl.NotificationsConfigCheckbox), {
        "aria-labelledby": `${id} ${headCheckboxIds.IN_PRODUCT}`,
        "aria-label": formatMessage((0, $alXN4.default).inProductColumnHeader),
        id: inProductCheckboxId,
        name: inProductCheckboxId,
        testId: `personal-settings-notifications-config-table.ui.notifications-config-row-accordion.${inProductCheckboxId}`,
        isChecked: getHeaderCheckboxStatus((0, $e7aa8280669c3543$export$201863d4c54f4831)) === $fd597c25c6c731f9$var$CHECKBOX_STATES.CHECKED || getHeaderCheckboxStatus((0, $e7aa8280669c3543$export$201863d4c54f4831)) === $fd597c25c6c731f9$var$CHECKBOX_STATES.INDERMINATE,
        isIndeterminate: getHeaderCheckboxStatus((0, $e7aa8280669c3543$export$201863d4c54f4831)) === $fd597c25c6c731f9$var$CHECKBOX_STATES.INDERMINATE,
        onChange: (ev)=>onHeadCheckboxChange(ev, (0, $e7aa8280669c3543$export$201863d4c54f4831))
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jeTJ6.HeadCellContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9PRJl.NotificationsConfigCheckbox), {
        "aria-labelledby": `${id} ${headCheckboxIds.EMAIL}`,
        "aria-label": formatMessage((0, $alXN4.default).emailColumnHeader),
        id: emailCheckboxId,
        isDisabled: enabledData.options.isEmailNotificationEnabled === false,
        name: emailCheckboxId,
        testId: `personal-settings-notifications-config-table.ui.notifications-config-row-accordion.${emailCheckboxId}`,
        isChecked: getHeaderCheckboxStatus((0, $e7aa8280669c3543$export$61171c632678b12e)) === $fd597c25c6c731f9$var$CHECKBOX_STATES.CHECKED || getHeaderCheckboxStatus((0, $e7aa8280669c3543$export$61171c632678b12e)) === $fd597c25c6c731f9$var$CHECKBOX_STATES.INDERMINATE,
        isIndeterminate: getHeaderCheckboxStatus((0, $e7aa8280669c3543$export$61171c632678b12e)) === $fd597c25c6c731f9$var$CHECKBOX_STATES.INDERMINATE,
        onChange: (ev)=>onHeadCheckboxChange(ev, (0, $e7aa8280669c3543$export$61171c632678b12e))
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, renderChildren));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fd597c25c6c731f9$var$AccordianHeader = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "summary", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_qtt8glyw _80omtlke",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fd597c25c6c731f9$var$TableRowContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "tr", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3ioahv _irr3166n",
            __cmplp.className
        ])
    });
});
const $fd597c25c6c731f9$var$headerChevronStyles = (0, $8CUq3.xcss)({
    verticalAlign: 'middle'
});

});
parcelRegister("fjePg", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7b3d0ec1cd9db6b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<064530e839ff78cf0aea3bde3f74571b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d7b3d0ec1cd9db6b$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "type"
    }, v2 = [
        {
            "kind": "ScalarField",
            "name": "channel"
        },
        {
            "kind": "ScalarField",
            "name": "isEnabled"
        },
        {
            "kind": "ScalarField",
            "name": "isEditable"
        }
    ], v3 = {
        "concreteType": "JiraNotificationChannel",
        "kind": "LinkedField",
        "name": "emailChannel",
        "plural": false,
        "selections": v2 /*: any*/ 
    }, v4 = {
        "concreteType": "JiraNotificationChannel",
        "kind": "LinkedField",
        "name": "inProductChannel",
        "plural": false,
        "selections": v2 /*: any*/ 
    }, v5 = {
        "kind": "ScalarField",
        "name": "category"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "notificationsAccordianRow_personalSettingsNotificationsConfigTable_NotificationsConfigRow_allPreferences",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "issueAssigned",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "issueAssigned.id"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v1 /*: any*/ ,
                            "action": "THROW",
                            "path": "issueAssigned.type"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v3 /*: any*/ ,
                            "action": "THROW",
                            "path": "issueAssigned.emailChannel"
                        },
                        v4 /*: any*/ ,
                        {
                            "kind": "RequiredField",
                            "field": v5 /*: any*/ ,
                            "action": "THROW",
                            "path": "issueAssigned.category"
                        }
                    ]
                },
                "action": "THROW",
                "path": "issueAssigned"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "issueCreated",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "issueCreated.id"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v1 /*: any*/ ,
                            "action": "THROW",
                            "path": "issueCreated.type"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v3 /*: any*/ ,
                            "action": "THROW",
                            "path": "issueCreated.emailChannel"
                        },
                        v4 /*: any*/ ,
                        {
                            "kind": "RequiredField",
                            "field": v5 /*: any*/ ,
                            "action": "THROW",
                            "path": "issueCreated.category"
                        }
                    ]
                },
                "action": "THROW",
                "path": "issueCreated"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "issueUpdated",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "issueUpdated.id"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v1 /*: any*/ ,
                            "action": "THROW",
                            "path": "issueUpdated.type"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v3 /*: any*/ ,
                            "action": "THROW",
                            "path": "issueUpdated.emailChannel"
                        },
                        v4 /*: any*/ ,
                        {
                            "kind": "RequiredField",
                            "field": v5 /*: any*/ ,
                            "action": "THROW",
                            "path": "issueUpdated.category"
                        }
                    ]
                },
                "action": "THROW",
                "path": "issueUpdated"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "issueDeleted",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "issueDeleted.id"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v1 /*: any*/ ,
                            "action": "THROW",
                            "path": "issueDeleted.type"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v3 /*: any*/ ,
                            "action": "THROW",
                            "path": "issueDeleted.emailChannel"
                        },
                        v4 /*: any*/ ,
                        {
                            "kind": "RequiredField",
                            "field": v5 /*: any*/ ,
                            "action": "THROW",
                            "path": "issueDeleted.category"
                        }
                    ]
                },
                "action": "THROW",
                "path": "issueDeleted"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "commentCreated",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "commentCreated.id"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v1 /*: any*/ ,
                            "action": "THROW",
                            "path": "commentCreated.type"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v3 /*: any*/ ,
                            "action": "THROW",
                            "path": "commentCreated.emailChannel"
                        },
                        v4 /*: any*/ ,
                        {
                            "kind": "RequiredField",
                            "field": v5 /*: any*/ ,
                            "action": "THROW",
                            "path": "commentCreated.category"
                        }
                    ]
                },
                "action": "THROW",
                "path": "commentCreated"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "commentEdited",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "commentEdited.id"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v1 /*: any*/ ,
                            "action": "THROW",
                            "path": "commentEdited.type"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v3 /*: any*/ ,
                            "action": "THROW",
                            "path": "commentEdited.emailChannel"
                        },
                        v4 /*: any*/ ,
                        {
                            "kind": "RequiredField",
                            "field": v5 /*: any*/ ,
                            "action": "THROW",
                            "path": "commentEdited.category"
                        }
                    ]
                },
                "action": "THROW",
                "path": "commentEdited"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "commentDeleted",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "commentDeleted.id"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v1 /*: any*/ ,
                            "action": "THROW",
                            "path": "commentDeleted.type"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v3 /*: any*/ ,
                            "action": "THROW",
                            "path": "commentDeleted.emailChannel"
                        },
                        v4 /*: any*/ ,
                        {
                            "kind": "RequiredField",
                            "field": v5 /*: any*/ ,
                            "action": "THROW",
                            "path": "commentDeleted.category"
                        }
                    ]
                },
                "action": "THROW",
                "path": "commentDeleted"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "issueMoved",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "issueMoved.id"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v1 /*: any*/ ,
                            "action": "THROW",
                            "path": "issueMoved.type"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v3 /*: any*/ ,
                            "action": "THROW",
                            "path": "issueMoved.emailChannel"
                        },
                        v4 /*: any*/ ,
                        {
                            "kind": "RequiredField",
                            "field": v5 /*: any*/ ,
                            "action": "THROW",
                            "path": "issueMoved.category"
                        }
                    ]
                },
                "action": "THROW",
                "path": "issueMoved"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "mentionsCombined",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "mentionsCombined.id"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v1 /*: any*/ ,
                            "action": "THROW",
                            "path": "mentionsCombined.type"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v3 /*: any*/ ,
                            "action": "THROW",
                            "path": "mentionsCombined.emailChannel"
                        },
                        v4 /*: any*/ ,
                        {
                            "kind": "RequiredField",
                            "field": v5 /*: any*/ ,
                            "action": "THROW",
                            "path": "mentionsCombined.category"
                        }
                    ]
                },
                "action": "THROW",
                "path": "mentionsCombined"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "worklogCombined",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "worklogCombined.id"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v1 /*: any*/ ,
                            "action": "THROW",
                            "path": "worklogCombined.type"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v3 /*: any*/ ,
                            "action": "THROW",
                            "path": "worklogCombined.emailChannel"
                        },
                        v4 /*: any*/ ,
                        {
                            "kind": "RequiredField",
                            "field": v5 /*: any*/ ,
                            "action": "THROW",
                            "path": "worklogCombined.category"
                        }
                    ]
                },
                "action": "THROW",
                "path": "worklogCombined"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "miscellaneousIssueEventCombined",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "miscellaneousIssueEventCombined.id"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v1 /*: any*/ ,
                            "action": "THROW",
                            "path": "miscellaneousIssueEventCombined.type"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v3 /*: any*/ ,
                            "action": "THROW",
                            "path": "miscellaneousIssueEventCombined.emailChannel"
                        },
                        v4 /*: any*/ ,
                        {
                            "kind": "RequiredField",
                            "field": v5 /*: any*/ ,
                            "action": "THROW",
                            "path": "miscellaneousIssueEventCombined.category"
                        }
                    ]
                },
                "action": "THROW",
                "path": "miscellaneousIssueEventCombined"
            }
        ],
        "type": "JiraNotificationPreferences"
    };
}();
$d7b3d0ec1cd9db6b$var$node.hash = "a366e41282957cf903b69c56052adc8d";
var $d7b3d0ec1cd9db6b$export$2e2bcd8739ae039 = $d7b3d0ec1cd9db6b$var$node;

});

parcelRegister("fAc3s", function(module, exports) {

$parcel$export(module.exports, "default", () => $33a1dcc7970fbfcd$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<36539ff6c9328d06237b2c2ab9935977>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $33a1dcc7970fbfcd$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "notificationsAccordianRow_personalSettingsNotificationsConfigTable_NotificationsConfigRow_enabledDataFragment",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraNotificationOptions",
                "kind": "LinkedField",
                "name": "options",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isEmailNotificationEnabled"
                    }
                ]
            },
            "action": "THROW",
            "path": "options"
        }
    ],
    "type": "JiraNotificationGlobalPreference"
};
$33a1dcc7970fbfcd$var$node.hash = "2f9c5245399476edc2437dfaad9bc9f0";
var $33a1dcc7970fbfcd$export$2e2bcd8739ae039 = $33a1dcc7970fbfcd$var$node;

});

parcelRegister("9PRJl", function(module, exports) {

$parcel$export(module.exports, "NotificationsConfigCheckbox", () => $9a6b5596e0c2426c$export$386f2824b35e47e3);

var $5uXOq = parcelRequire("5uXOq");

var $kkJfY = parcelRequire("kkJfY");

var $jeTJ6 = parcelRequire("jeTJ6");
const $9a6b5596e0c2426c$export$386f2824b35e47e3 = (props)=>{
    const { label: label, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kkJfY.default), {
        ...rest,
        label: label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jeTJ6.CheckboxLabelContainer), null, label)
    });
};

});
parcelRegister("kkJfY", function(module, exports) {

$parcel$export(module.exports, "default", () => $3106eb14f9b0a593$export$2e2bcd8739ae039);
/* checkbox.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $6QvkM = parcelRequire("6QvkM");

var $5JjdN = parcelRequire("5JjdN");

var $kag1C = parcelRequire("kag1C");
var $7xteU = parcelRequire("7xteU");
var $hsLv2 = parcelRequire("hsLv2");
var $e62YQ = parcelRequire("e62YQ");
const $3106eb14f9b0a593$var$checkboxStyles = {
    root: "_19itglyw _nd5lfibj _12ji1r31 _1qu2glyw _12y31o36 _1bsb1osq _4t3i1osq _r06hglyw _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _tzy4idpf _r050fibj _9bg71mn3 _19op11so _a30fhteq _1610e4h9 _13wo93zu _q5a61gyf _8gq114p8 _wje2mov0 _1fo21cni _eyedglyw _1ef7js4s _1h6rjs4s _smzgj3jf _1dk7j3jf _l71j1i6y _t34a1i6y _y32gkivo _1ah9199y _1frj180l _h78e1g3k _dwvb1ps2 _1bok170n _1mhr17cl _fx2i3rva _10oaq2ws _w12s155b _15y61vek _e6ww155b _sg1j1vek _rphw18jz _y9y9mz2b _141bmz2b _255gmz2b _jj67mz2b _swhgmz2b _axq81diq _1jiz1diq _s9051diq _1efy1diq _1oav1diq _10y313gf _1wt913gf _qq8613gf _1adw13gf _12sr13gf _16jiglyw _693jglyw _1niqglyw _cl9tglyw _1jbnglyw _j1ta1hou _18qu1ps2 _1g52170n _1log17cl _32hzmz2b _1vv91diq _yjhd1hou _w1cowc43 _jdqn1onz _4y4t1onz _lvfrwc43 _g68dwc43 _13dk1onz _w1el1onz _a9yw1onz _1l3g1onz _dcdpgir2 _wobcgir2 _rp9wgir2 _9ebfwc43 _e43iwc43 _1tkuwc43 _1lehwc43 _b9q3wc43 _tu2918qt _1uxv18qt _1ufw18qt _opo918qt _1e8318qt _1k3d18qt _25yv18qt _1igz18qt _c7cc18qt _1swg18qt"
}; /**
    * __Checkbox__
    *
    * A checkbox an input control that allows a user to select one or more options from a number of choices.
    *
    * - [Examples](https://atlassian.design/components/checkbox/examples)
    * - [Code](https://atlassian.design/components/checkbox/code)
    * - [Usage](https://atlassian.design/components/checkbox/usage)
    */ 
const $3106eb14f9b0a593$var$Checkbox = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function Checkbox({ isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, className: className, ...rest }, ref) {
    const [isCheckedState, setIsCheckedState] = (0, $5uXOq.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const internalRef = (0, $5uXOq.useRef)(null);
    const mergedRefs = (0, $5JjdN.default)([
        internalRef,
        ref
    ]); // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $5uXOq.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $7xteU.default), {
        isDisabled: isDisabled,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // When there is more usage of this pattern we'll update the lint rule.
        xcss: xcss,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("input" // It is necessary only for Safari. It allows to render focus styles.
            , {
                tabIndex: 0,
                ...rest,
                type: "checkbox",
                ref: mergedRefs,
                disabled: isDisabled,
                checked: isChecked,
                value: value,
                name: name,
                required: isRequired,
                className: (0, $bwpsq.default)([
                    $3106eb14f9b0a593$var$checkboxStyles.root,
                    className
                ]),
                onChange: onChangeAnalytics,
                "aria-invalid": isInvalid ? 'true' : undefined,
                "data-testid": testId && `${testId}--hidden-checkbox`,
                "data-invalid": isInvalid ? 'true' : undefined
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kag1C.default), {
                isIndeterminate: isIndeterminate,
                isChecked: isChecked
            }),
            label && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $hsLv2.default), {
                children: [
                    label,
                    isRequired && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e62YQ.default), {})
                ]
            })
        ]
    });
}));
$3106eb14f9b0a593$var$Checkbox.displayName = 'Checkbox';
var $3106eb14f9b0a593$export$2e2bcd8739ae039 = $3106eb14f9b0a593$var$Checkbox;

});
parcelRegister("kag1C", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0746a27410bc168$export$2e2bcd8739ae039);
/* checkbox-icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $dV6Te = parcelRequire("dV6Te");

var $VSDnB = parcelRequire("VSDnB");
function $a0746a27410bc168$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) {
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $VSDnB.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
            fill: "inherit",
            x: "8",
            y: "11",
            width: "8",
            height: "2",
            rx: "1"
        });
    }
    if (isChecked) {
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $VSDnB.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
            fill: "inherit"
        });
    }
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ const $a0746a27410bc168$var$CheckboxIcon = /*#__PURE__*/ (0, $5uXOq.memo)(({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $5uXOq.useMemo)(()=>$a0746a27410bc168$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dV6Te.default), {
        label: "",
        primaryColor: "var(--checkbox-background-color)",
        secondaryColor: "var(--checkbox-tick-color)",
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
                (0, $VSDnB.fg)('platform-visual-refresh-icons') ? /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                    fill: "currentColor",
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5"
                }) : /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                    fill: "currentColor",
                    x: "6",
                    y: "6",
                    width: "12",
                    height: "12",
                    rx: "2"
                }),
                icon
            ]
        })
    });
});
var $a0746a27410bc168$export$2e2bcd8739ae039 = $a0746a27410bc168$var$CheckboxIcon;

});

parcelRegister("7xteU", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b368d644c230660$export$2e2bcd8739ae039);
/* label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $7b368d644c230660$var$baseStyles = null;
const $7b368d644c230660$var$textLabelLayoutStyles = null;
const $7b368d644c230660$var$disabledStyles = null;
const $7b368d644c230660$var$labelStyles = null;
function $7b368d644c230660$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("label", {
        className: (0, $bwpsq.default)([
            "_11c82smr _1e0c11p5 _1ejihkll _umai184x _syazj3m3 _80om73ad",
            label && "_zulp1nu5 _yv0ey09t",
            isDisabled && "_syaz1tvo _80om13gf",
            "_h5e3mag2 _1nzs11d3 _1eszzyvw _yp0jhh5a _ay2w1y1w _d51u10ko _phft1fmg _1g1funzk _l6wkzyvw _1dikhh5a _1sfg1q3k _fpdj1y1w _1yjc194a _oaj11fmg _1j3h1q3k _eawb1dzn _1rda1qbb _18q015t7 _13hr3acm",
            xcss
        ]),
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id,
        children: children
    });
}

});

parcelRegister("hsLv2", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce636d67b4ff1120$export$2e2bcd8739ae039);
/* label-text.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $ce636d67b4ff1120$var$labelTextStyles = null;
function $ce636d67b4ff1120$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        className: (0, $bwpsq.default)([
            "_nd5l11ig _1wpz1h6o"
        ]),
        children: children
    });
}

});

parcelRegister("e62YQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2156c28a3894cac$export$2e2bcd8739ae039);
/* required-indicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $d2156c28a3894cac$var$requiredIndicatorStyles = null;
function $d2156c28a3894cac$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "aria-hidden": true,
        className: (0, $bwpsq.default)([
            "_syaz1gtz _bozgv77o"
        ]),
        children: "*"
    });
}

});


parcelRegister("jeTJ6", function(module, exports) {

$parcel$export(module.exports, "Table", () => $20202b90448ae42f$export$54ec01a60f47d33d);
$parcel$export(module.exports, "TableHeadRowContainer", () => $20202b90448ae42f$export$2ed37f428538a29e);
$parcel$export(module.exports, "CheckboxLabelContainer", () => $20202b90448ae42f$export$34aecbd5c7584fa8);
$parcel$export(module.exports, "HeadCellContainer", () => $20202b90448ae42f$export$12cd2a7a0496696);
$parcel$export(module.exports, "TableHeadContainer", () => $20202b90448ae42f$export$686fc6781ca5e30);
$parcel$export(module.exports, "TBody", () => $20202b90448ae42f$export$7005b8a93a167348);
$parcel$export(module.exports, "CellContainer", () => $20202b90448ae42f$export$287da707e3318210);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $20202b90448ae42f$export$4267411171632d35 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1b66 _189et94y _1dqonqa1 _1h6dmuej _bfhkhp5a",
            __cmplp.className
        ])
    });
});
const $20202b90448ae42f$export$54ec01a60f47d33d = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "table", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1osq _yq5hcfaq",
            __cmplp.className
        ])
    });
});
const $20202b90448ae42f$export$2ed37f428538a29e = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "tr", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_c71l1jfw _4t3i1jfw",
            __cmplp.className
        ])
    });
});
const $20202b90448ae42f$export$34aecbd5c7584fa8 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz1gjq _ca0qutpp _n3tdutpp _k48p1wq8",
            __cmplp.className
        ])
    });
});
const $20202b90448ae42f$export$12cd2a7a0496696 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "th", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0cdav6 _r06hglyw _s7n4nkob _k48p1wq8 _syaz1gjq _1bsb1osq _u5f31b66 _19bv1b66 _1lhcpxbi",
            __cmplp.className
        ])
    });
});
const $20202b90448ae42f$export$686fc6781ca5e30 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "thead", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1r04idpf _s7n4nkob _kqswh2mm _1il9glyw _1tesidpf _1cs8stnw _txdo1s03 _1kt9b3bt _dsq4glyw _19woidpf _1aukidpf",
            __cmplp.className
        ])
    });
});
const $20202b90448ae42f$export$7005b8a93a167348 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "tbody", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19itglyw",
            __cmplp.className
        ])
    });
});
const $20202b90448ae42f$export$287da707e3318210 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "td", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_yq5h18uv _r06hglyw _vchhusvi _1e0cdav6 _u5f31b66 _19bv1b66 _s7n4nkob _1lhcpxbi",
            __cmplp.className
        ])
    });
});

});


parcelRegister("h1xg5", function(module, exports) {

$parcel$export(module.exports, "NotificationsConfigRow", () => $9659436bce235c02$export$9ea27a385922f0da);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $9PRJl = parcelRequire("9PRJl");
const $9659436bce235c02$export$9ea27a385922f0da = ({ headCheckboxIds: headCheckboxIds, preference: preference, label: label, isOpen: isOpen, onChange: onChange, isLastChild: isLastChild, id: id, isEmailNotificationDisabled: isEmailNotificationDisabled = false })=>{
    const { type: type } = preference;
    const emailCheckboxId = `email-${id}`;
    const inProductCheckboxId = `inProduct-${id}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9659436bce235c02$var$TableRowContainer, {
        className: (0, $bwpsq.default)([
            !isOpen && "_1e0cglyw",
            isLastChild && "_16qs1s03"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9659436bce235c02$var$CellContainer, {
        id: id
    }, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9659436bce235c02$var$CellContainer, null, preference.inProductChannel?.isEditable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9PRJl.NotificationsConfigCheckbox), {
        "aria-labelledby": `${id} ${headCheckboxIds.IN_PRODUCT}`,
        id: inProductCheckboxId,
        name: inProductCheckboxId,
        testId: `personal-settings-notifications-config-table.ui.notifications-config-row-lite.${inProductCheckboxId}`,
        isChecked: !!preference.inProductChannel.isEnabled,
        onChange: (ev)=>onChange(ev, 'IN_PRODUCT', type)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9659436bce235c02$var$CellContainer, null, preference.emailChannel?.isEditable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9PRJl.NotificationsConfigCheckbox), {
        "aria-labelledby": `${id} ${headCheckboxIds.EMAIL}`,
        id: emailCheckboxId,
        isDisabled: isEmailNotificationDisabled,
        name: emailCheckboxId,
        testId: `personal-settings-notifications-config-table.ui.notifications-config-row-lite.${emailCheckboxId}`,
        isChecked: !!preference.emailChannel.isEnabled,
        onChange: (ev)=>onChange(ev, 'EMAIL', type)
    })));
};
const $9659436bce235c02$var$hidden = null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
const $9659436bce235c02$var$border = null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9659436bce235c02$var$CellContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "td", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_yq5h18uv _r06hglyw _vchhusvi _1e0cdav6 _syaz1dyx _u5f31b66 _k48pi7a9 _19bv1b66 _s7n4nkob _1lhc1jfw",
            __cmplp.className
        ])
    });
});
const $9659436bce235c02$var$TableRowContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "tr", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3ioahv _irr3166n",
            __cmplp.className
        ])
    });
});

});


parcelRegister("hShCB", function(module, exports) {

$parcel$export(module.exports, "HeadCheckbox", () => $617498c42e3ec528$export$78ad90ca020f8dc8);

var $6zRnS = parcelRequire("6zRnS");

var $8FNLZ = parcelRequire("8FNLZ");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $2NMNM = parcelRequire("2NMNM");

var $8zOmE = parcelRequire("8zOmE");


var $9PRJl = parcelRequire("9PRJl");
const $617498c42e3ec528$var$notificationTypes = [
    'issueAssigned',
    'issueUpdated',
    'issueDeleted',
    'commentCreated',
    'commentEdited',
    'commentDeleted',
    'issueCreated',
    'issueMoved',
    'mentionsCombined',
    'worklogCombined',
    'miscellaneousIssueEventCombined'
];
// TODO: Move these functions to utils
const $617498c42e3ec528$var$preferenceCategoryMap = {
    ISSUE_ASSIGNED: 'ISSUE_ASSIGNED',
    ISSUE_UPDATED: 'ISSUE_CHANGES',
    ISSUE_DELETED: 'ISSUE_CHANGES',
    COMMENT_CREATED: 'COMMENT_CHANGES',
    COMMENT_EDITED: 'COMMENT_CHANGES',
    COMMENT_DELETED: 'COMMENT_CHANGES',
    ISSUE_CREATED: 'ISSUE_CHANGES',
    ISSUE_MOVED: 'ISSUE_CHANGES',
    MENTIONS_COMBINED: 'ISSUE_MENTIONED',
    WORKLOG_COMBINED: 'ISSUE_WORKLOG_CHANGES',
    MISCELLANEOUS_ISSUE_EVENT_COMBINED: 'ISSUE_MISCELLANEOUS'
};
const $617498c42e3ec528$var$createJiraNotificationPreferenceNew = (notificationPreference, isEnabled, channelClicked)=>{
    const jiraNotificationPreference = {
        type: notificationPreference.type,
        id: notificationPreference.id,
        emailChannel: {
            channel: notificationPreference.emailChannel.channel,
            isEnabled: channelClicked === (0, $e7aa8280669c3543$export$61171c632678b12e) ? isEnabled : notificationPreference.emailChannel.isEnabled,
            isEditable: notificationPreference.emailChannel.isEditable
        },
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        category: $617498c42e3ec528$var$preferenceCategoryMap[// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        notificationPreference.type]
    };
    const { inProductChannel: inProductChannel } = notificationPreference;
    if (inProductChannel) jiraNotificationPreference.inProductChannel = {
        channel: inProductChannel.channel,
        isEnabled: channelClicked === (0, $e7aa8280669c3543$export$201863d4c54f4831) ? isEnabled : inProductChannel.isEnabled,
        isEditable: inProductChannel.isEditable
    };
    return jiraNotificationPreference;
};
const $617498c42e3ec528$var$belongsToCategoryGroup = (jiraNotificationType, categoryGroup)=>{
    const category = $617498c42e3ec528$var$preferenceCategoryMap[jiraNotificationType];
    return category && categoryGroup.includes(category);
};
const $617498c42e3ec528$var$isChannelEditable = (notificationPreference, channel)=>{
    if (channel === (0, $e7aa8280669c3543$export$61171c632678b12e)) return notificationPreference.emailChannel?.isEditable;
    if (channel === (0, $e7aa8280669c3543$export$201863d4c54f4831)) return notificationPreference.inProductChannel?.isEditable;
    return false;
};
const $617498c42e3ec528$export$78ad90ca020f8dc8 = ({ label: label, channel: channel, allPreferences: allPreferences, enabledDataFragment: enabledDataFragment, neverUnselected: neverUnselected = false, commitMutation: commitMutation, id: id, categories: categories })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const enabledData = (0, $8Uumt.useFragment)((0, $8FNLZ.default), enabledDataFragment);
    const data = (0, $8Uumt.useFragment)((0, $6zRnS.default), allPreferences);
    const optionsInNewDesign = (0, $5uXOq.useMemo)(()=>{
        if (channel === (0, $e7aa8280669c3543$export$61171c632678b12e)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return Object.values(data).filter((pref)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const preference = pref;
            return preference && preference.type && preference.emailChannel.isEditable && categories && $617498c42e3ec528$var$belongsToCategoryGroup(preference.type, categories);
        });
        if (channel === (0, $e7aa8280669c3543$export$201863d4c54f4831)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return Object.values(data).filter((pref)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const preference = pref;
            return preference && preference.type && preference.inProductChannel?.isEditable && categories && $617498c42e3ec528$var$belongsToCategoryGroup(preference.type, categories);
        });
        return [];
    }, [
        categories,
        channel,
        data
    ]);
    const numberOfSelectedOptions = (0, $5uXOq.useMemo)(()=>{
        if (channel === (0, $e7aa8280669c3543$export$61171c632678b12e)) return optionsInNewDesign.filter((option)=>option?.emailChannel.isEnabled).length;
        if (channel === (0, $e7aa8280669c3543$export$201863d4c54f4831)) return optionsInNewDesign.filter((option)=>option?.inProductChannel?.isEnabled).length;
        return 0;
    }, [
        channel,
        optionsInNewDesign
    ]);
    const createElementOfNewPreferencesAsList = (0, $5uXOq.useCallback)((type, isEnabled)=>({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            type: type,
            channel: channel,
            isEnabled: isEnabled
        }), [
        channel
    ]);
    const isChecked = numberOfSelectedOptions > 0 || neverUnselected;
    const isIndeterminate = isChecked && numberOfSelectedOptions < optionsInNewDesign.length;
    const onChange = (0, $5uXOq.useCallback)((_event)=>{
        // For a channel, if no notification types are selected or indeterminate, enable the channel.
        // Else disable the channel.
        const newChannelEnabledValue = numberOfSelectedOptions < optionsInNewDesign.length;
        const newPreferencesWithChannels = $617498c42e3ec528$var$notificationTypes.reduce((acc, val)=>{
            const notificationPreference = data[val];
            if (notificationPreference && categories?.length && $617498c42e3ec528$var$belongsToCategoryGroup(notificationPreference.type, categories) && $617498c42e3ec528$var$isChannelEditable(notificationPreference, channel)) acc[val] = $617498c42e3ec528$var$createJiraNotificationPreferenceNew(notificationPreference, newChannelEnabledValue, channel);
            return acc;
        }, {});
        if (data) {
            const newPreferencesAsList = Object.values(newPreferencesWithChannels).reduce((acc, val)=>{
                const type = val.type?.toUpperCase().replace(/ /g, '_');
                acc.push(createElementOfNewPreferencesAsList(type, newChannelEnabledValue));
                return acc;
            }, []);
            commitMutation(newPreferencesAsList, newPreferencesWithChannels);
            let previousValue = 'unchecked';
            let currentValue = 'unchecked';
            if (isIndeterminate) previousValue = 'mixed';
            else if (isChecked) previousValue = 'checked';
            if (numberOfSelectedOptions < optionsInNewDesign.length) currentValue = 'checked';
            else if (numberOfSelectedOptions === optionsInNewDesign.length) currentValue = neverUnselected ? 'mixed' : 'unchecked';
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'checkbox updated', 'notificationCheckbox', {
                type: 'all',
                ...Object.keys(newPreferencesWithChannels).reduce((acc, key)=>{
                    let oldPreference;
                    if (channel === (0, $e7aa8280669c3543$export$61171c632678b12e)) oldPreference = /* eslint-disable @typescript-eslint/consistent-type-assertions */ data[key].emailChannel.isEnabled;
                    else if (channel === (0, $e7aa8280669c3543$export$201863d4c54f4831)) oldPreference = /* eslint-disable @typescript-eslint/consistent-type-assertions */ data[key].inProductChannel?.isEnabled;
                    const newPreference = newChannelEnabledValue;
                    if (oldPreference === newPreference) acc[key] = 'unchanged';
                    else if (newPreference) acc[key] = 'checked';
                    else acc[key] = 'unchecked';
                    return acc;
                }, {}),
                channel: channel
            });
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'checkbox clicked', 'all', {
                channel: channel,
                previousValue: previousValue,
                currentValue: currentValue
            });
        }
    }, [
        numberOfSelectedOptions,
        optionsInNewDesign,
        data,
        categories,
        channel,
        commitMutation,
        createAnalyticsEvent,
        createElementOfNewPreferencesAsList,
        isIndeterminate,
        isChecked,
        neverUnselected
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9PRJl.NotificationsConfigCheckbox), {
        id: id,
        name: id,
        testId: `personal-settings-notifications-config-table.ui.notifications-config-head.${id}-head-checkbox`,
        label: label,
        isChecked: isChecked,
        isIndeterminate: isIndeterminate,
        isDisabled: enabledData.options.isEmailNotificationEnabled === false && channel === (0, $e7aa8280669c3543$export$61171c632678b12e),
        onChange: onChange
    });
};

});
parcelRegister("6zRnS", function(module, exports) {

$parcel$export(module.exports, "default", () => $064b705795aaa361$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5d32657834f7c87c929e7982af3024dd>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $064b705795aaa361$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "type"
    }, v2 = [
        {
            "kind": "ScalarField",
            "name": "channel"
        },
        {
            "kind": "ScalarField",
            "name": "isEnabled"
        },
        {
            "kind": "ScalarField",
            "name": "isEditable"
        }
    ], v3 = {
        "concreteType": "JiraNotificationChannel",
        "kind": "LinkedField",
        "name": "emailChannel",
        "plural": false,
        "selections": v2 /*: any*/ 
    }, v4 = {
        "concreteType": "JiraNotificationChannel",
        "kind": "LinkedField",
        "name": "inProductChannel",
        "plural": false,
        "selections": v2 /*: any*/ 
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "notificationsConfigHead_personalSettingsNotificationsConfigTable_HeadCheckbox_allPreferences",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "issueAssigned",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "issueAssigned.id"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v1 /*: any*/ ,
                            "action": "THROW",
                            "path": "issueAssigned.type"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v3 /*: any*/ ,
                            "action": "THROW",
                            "path": "issueAssigned.emailChannel"
                        },
                        v4 /*: any*/ 
                    ]
                },
                "action": "THROW",
                "path": "issueAssigned"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "issueUpdated",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "issueUpdated.id"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v1 /*: any*/ ,
                            "action": "THROW",
                            "path": "issueUpdated.type"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v3 /*: any*/ ,
                            "action": "THROW",
                            "path": "issueUpdated.emailChannel"
                        },
                        v4 /*: any*/ 
                    ]
                },
                "action": "THROW",
                "path": "issueUpdated"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "issueDeleted",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "issueDeleted.id"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v1 /*: any*/ ,
                            "action": "THROW",
                            "path": "issueDeleted.type"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v3 /*: any*/ ,
                            "action": "THROW",
                            "path": "issueDeleted.emailChannel"
                        },
                        v4 /*: any*/ 
                    ]
                },
                "action": "THROW",
                "path": "issueDeleted"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "commentCreated",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "commentCreated.id"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v1 /*: any*/ ,
                            "action": "THROW",
                            "path": "commentCreated.type"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v3 /*: any*/ ,
                            "action": "THROW",
                            "path": "commentCreated.emailChannel"
                        },
                        v4 /*: any*/ 
                    ]
                },
                "action": "THROW",
                "path": "commentCreated"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "commentEdited",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "commentEdited.id"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v1 /*: any*/ ,
                            "action": "THROW",
                            "path": "commentEdited.type"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v3 /*: any*/ ,
                            "action": "THROW",
                            "path": "commentEdited.emailChannel"
                        },
                        v4 /*: any*/ 
                    ]
                },
                "action": "THROW",
                "path": "commentEdited"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "commentDeleted",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "commentDeleted.id"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v1 /*: any*/ ,
                            "action": "THROW",
                            "path": "commentDeleted.type"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v3 /*: any*/ ,
                            "action": "THROW",
                            "path": "commentDeleted.emailChannel"
                        },
                        v4 /*: any*/ 
                    ]
                },
                "action": "THROW",
                "path": "commentDeleted"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "issueCreated",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "issueCreated.id"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v1 /*: any*/ ,
                            "action": "THROW",
                            "path": "issueCreated.type"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v3 /*: any*/ ,
                            "action": "THROW",
                            "path": "issueCreated.emailChannel"
                        },
                        v4 /*: any*/ 
                    ]
                },
                "action": "THROW",
                "path": "issueCreated"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "issueMoved",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "issueMoved.id"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v1 /*: any*/ ,
                            "action": "THROW",
                            "path": "issueMoved.type"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v3 /*: any*/ ,
                            "action": "THROW",
                            "path": "issueMoved.emailChannel"
                        },
                        v4 /*: any*/ 
                    ]
                },
                "action": "THROW",
                "path": "issueMoved"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "mentionsCombined",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "mentionsCombined.id"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v1 /*: any*/ ,
                            "action": "THROW",
                            "path": "mentionsCombined.type"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v3 /*: any*/ ,
                            "action": "THROW",
                            "path": "mentionsCombined.emailChannel"
                        },
                        v4 /*: any*/ 
                    ]
                },
                "action": "THROW",
                "path": "mentionsCombined"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "worklogCombined",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "worklogCombined.id"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v1 /*: any*/ ,
                            "action": "THROW",
                            "path": "worklogCombined.type"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v3 /*: any*/ ,
                            "action": "THROW",
                            "path": "worklogCombined.emailChannel"
                        },
                        v4 /*: any*/ 
                    ]
                },
                "action": "THROW",
                "path": "worklogCombined"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "miscellaneousIssueEventCombined",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "miscellaneousIssueEventCombined.id"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v1 /*: any*/ ,
                            "action": "THROW",
                            "path": "miscellaneousIssueEventCombined.type"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v3 /*: any*/ ,
                            "action": "THROW",
                            "path": "miscellaneousIssueEventCombined.emailChannel"
                        },
                        v4 /*: any*/ 
                    ]
                },
                "action": "THROW",
                "path": "miscellaneousIssueEventCombined"
            }
        ],
        "type": "JiraNotificationPreferences"
    };
}();
$064b705795aaa361$var$node.hash = "8eed95541810aa897f0456826e1da5af";
var $064b705795aaa361$export$2e2bcd8739ae039 = $064b705795aaa361$var$node;

});

parcelRegister("8FNLZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $11158ad4dd809ce8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7206ff7a7b87c06764316c70e9f26f83>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $11158ad4dd809ce8$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "notificationsConfigHead_personalSettingsNotificationsConfigTable_HeadCheckbox_enabledDataFragment",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraNotificationOptions",
                "kind": "LinkedField",
                "name": "options",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isEmailNotificationEnabled"
                    }
                ]
            },
            "action": "THROW",
            "path": "options"
        }
    ],
    "type": "JiraNotificationGlobalPreference"
};
$11158ad4dd809ce8$var$node.hash = "3725cb0cf5e9b9557ce7e2c77f6b03fa";
var $11158ad4dd809ce8$export$2e2bcd8739ae039 = $11158ad4dd809ce8$var$node;

});


parcelRegister("dxt1X", function(module, exports) {

$parcel$export(module.exports, "HeadCellCheckboxContainer", () => $b9931c6f33ecb333$export$3a671d2a5863c1ad);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $jeTJ6 = parcelRequire("jeTJ6");
const $b9931c6f33ecb333$export$3a671d2a5863c1ad = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $jeTJ6.HeadCellContainer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1ul953f4",
            __cmplp.className
        ])
    });
});

});

parcelRegister("1rVbx", function(module, exports) {

$parcel$export(module.exports, "NotificationsConfigRow", () => $1ac16794cf2abdab$export$9ea27a385922f0da);

var $dXQTX = parcelRequire("dXQTX");

var $78u48 = parcelRequire("78u48");

var $adhBu = parcelRequire("adhBu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $2NMNM = parcelRequire("2NMNM");

var $8zOmE = parcelRequire("8zOmE");


var $9PRJl = parcelRequire("9PRJl");

var $jeTJ6 = parcelRequire("jeTJ6");
const $1ac16794cf2abdab$var$ATTRIBUTES_FOR_SINGLE_ROW_UPDATE = {
    type: 'row',
    issueAssigned: 'unchanged',
    issueUpdated: 'unchanged',
    issueDeleted: 'unchanged',
    commentCreated: 'unchanged',
    commentEdited: 'unchanged',
    commentDeleted: 'unchanged',
    issueCreated: 'unchanged',
    issueMoved: 'unchanged',
    mentionsCombined: 'unchanged',
    worklogCombined: 'unchanged',
    miscellaneousIssueEventCombined: 'unchanged'
};
const $1ac16794cf2abdab$var$snakeToCamelCase = (str)=>str.toLowerCase().replace(/([-_]\w)/g, (g)=>g[1].toUpperCase());
const $1ac16794cf2abdab$export$9ea27a385922f0da = ({ label: label, id: id, headCheckboxIds: headCheckboxIds, preference: preference, allPreferences: allPreferences, commitMutation: commitMutation, enabledDataFragment: enabledDataFragment })=>{
    const enabledData = (0, $8Uumt.useFragment)((0, $adhBu.default), enabledDataFragment);
    const data = (0, $8Uumt.useFragment)((0, $78u48.default), preference);
    const allData = (0, $8Uumt.useFragment)((0, $dXQTX.default), allPreferences);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const createJiraNotificationPreference = (0, $5uXOq.useCallback)((notificationType, isEnabled, channel)=>{
        const retVal = {
            type: allData[notificationType]?.type,
            id: allData[notificationType]?.id ?? '',
            emailChannel: {
                channel: allData[notificationType]?.emailChannel.channel,
                isEnabled: data.type === allData[notificationType]?.type && channel === (0, $e7aa8280669c3543$export$61171c632678b12e) ? isEnabled : allData[notificationType]?.emailChannel.isEnabled,
                isEditable: allData[notificationType]?.emailChannel.isEditable
            }
        };
        const inProductChannelName = allData[notificationType]?.inProductChannel;
        if (inProductChannelName) retVal.inProductChannel = {
            channel: inProductChannelName.channel,
            isEnabled: data.type === allData[notificationType]?.type && channel === (0, $e7aa8280669c3543$export$201863d4c54f4831) ? isEnabled : inProductChannelName.isEnabled,
            isEditable: inProductChannelName.isEditable
        };
        return retVal;
    }, [
        allData,
        data
    ]);
    const onCheckboxChange = (0, $5uXOq.useCallback)((event, channel)=>{
        const isEnabled = event.target.checked;
        const newPreferences = {
            issueAssigned: createJiraNotificationPreference('issueAssigned', isEnabled, channel),
            issueUpdated: createJiraNotificationPreference('issueUpdated', isEnabled, channel),
            issueDeleted: createJiraNotificationPreference('issueDeleted', isEnabled, channel),
            commentCreated: createJiraNotificationPreference('commentCreated', isEnabled, channel),
            commentEdited: createJiraNotificationPreference('commentEdited', isEnabled, channel),
            commentDeleted: createJiraNotificationPreference('commentDeleted', isEnabled, channel),
            issueCreated: createJiraNotificationPreference('issueCreated', isEnabled, channel),
            issueMoved: createJiraNotificationPreference('issueMoved', isEnabled, channel),
            mentionsCombined: createJiraNotificationPreference('mentionsCombined', isEnabled, channel),
            worklogCombined: createJiraNotificationPreference('worklogCombined', isEnabled, channel),
            miscellaneousIssueEventCombined: createJiraNotificationPreference('miscellaneousIssueEventCombined', isEnabled, channel)
        }; // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        commitMutation(channel, isEnabled, newPreferences, data.type);
        const camelType = $1ac16794cf2abdab$var$snakeToCamelCase(data.type);
        const trackAnalyticsAttributes = $1ac16794cf2abdab$var$ATTRIBUTES_FOR_SINGLE_ROW_UPDATE;
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'checkbox updated', 'notificationCheckbox', {
            channel: channel,
            ...trackAnalyticsAttributes,
            [camelType]: isEnabled ? 'checked' : 'unchecked'
        });
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'checkbox clicked', camelType, {
            channel: channel,
            value: isEnabled ? 'checked' : 'unchecked'
        });
    }, [
        commitMutation,
        createAnalyticsEvent,
        data,
        createJiraNotificationPreference
    ]);
    const emailCheckboxId = `email-${id}`;
    const inProductCheckboxId = `inProduct-${id}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1ac16794cf2abdab$var$TableRowContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jeTJ6.CellContainer), {
        id: id
    }, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jeTJ6.CellContainer), null, data.inProductChannel?.isEditable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9PRJl.NotificationsConfigCheckbox), {
        "aria-labelledby": `${id} ${headCheckboxIds.IN_PRODUCT}`,
        id: inProductCheckboxId,
        name: inProductCheckboxId,
        testId: `personal-settings-notifications-config-table.ui.notifications-config-row.${inProductCheckboxId}`,
        isChecked: !!data.inProductChannel?.isEnabled,
        onChange: (ev)=>onCheckboxChange(ev, (0, $e7aa8280669c3543$export$201863d4c54f4831))
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jeTJ6.CellContainer), null, data.emailChannel?.isEditable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9PRJl.NotificationsConfigCheckbox), {
        "aria-labelledby": `${id} ${headCheckboxIds.EMAIL}`,
        id: emailCheckboxId,
        isDisabled: enabledData.options.isEmailNotificationEnabled === false,
        name: emailCheckboxId,
        testId: `personal-settings-notifications-config-table.ui.notifications-config-row.${emailCheckboxId}`,
        isChecked: !!data.emailChannel.isEnabled,
        onChange: (ev)=>onCheckboxChange(ev, (0, $e7aa8280669c3543$export$61171c632678b12e))
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1ac16794cf2abdab$var$TableRowContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "tr", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3ioahv _irr3166n",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dXQTX", function(module, exports) {

$parcel$export(module.exports, "default", () => $e22c4ae3313cdc70$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<09ae8c2b32ec126f60109b9d6e6ba4c3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e22c4ae3313cdc70$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "type"
    }, v2 = [
        {
            "kind": "ScalarField",
            "name": "channel"
        },
        {
            "kind": "ScalarField",
            "name": "isEnabled"
        },
        {
            "kind": "ScalarField",
            "name": "isEditable"
        }
    ], v3 = {
        "concreteType": "JiraNotificationChannel",
        "kind": "LinkedField",
        "name": "emailChannel",
        "plural": false,
        "selections": v2 /*: any*/ 
    }, v4 = {
        "concreteType": "JiraNotificationChannel",
        "kind": "LinkedField",
        "name": "inProductChannel",
        "plural": false,
        "selections": v2 /*: any*/ 
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "__relay_internal__pv__atlassianjirarelayprovidersrcincludemiscellaneouseventscombinedtyperelayprovider"
            }
        ],
        "kind": "Fragment",
        "name": "notificationsConfigRow_personalSettingsNotificationsConfigTable_allPreferences",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "issueAssigned",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "issueAssigned.id"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v1 /*: any*/ ,
                            "action": "THROW",
                            "path": "issueAssigned.type"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v3 /*: any*/ ,
                            "action": "THROW",
                            "path": "issueAssigned.emailChannel"
                        },
                        v4 /*: any*/ 
                    ]
                },
                "action": "THROW",
                "path": "issueAssigned"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "issueUpdated",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "issueUpdated.id"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v1 /*: any*/ ,
                            "action": "THROW",
                            "path": "issueUpdated.type"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v3 /*: any*/ ,
                            "action": "THROW",
                            "path": "issueUpdated.emailChannel"
                        },
                        v4 /*: any*/ 
                    ]
                },
                "action": "THROW",
                "path": "issueUpdated"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "issueDeleted",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "issueDeleted.id"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v1 /*: any*/ ,
                            "action": "THROW",
                            "path": "issueDeleted.type"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v3 /*: any*/ ,
                            "action": "THROW",
                            "path": "issueDeleted.emailChannel"
                        },
                        v4 /*: any*/ 
                    ]
                },
                "action": "THROW",
                "path": "issueDeleted"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "commentCreated",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "commentCreated.id"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v1 /*: any*/ ,
                            "action": "THROW",
                            "path": "commentCreated.type"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v3 /*: any*/ ,
                            "action": "THROW",
                            "path": "commentCreated.emailChannel"
                        },
                        v4 /*: any*/ 
                    ]
                },
                "action": "THROW",
                "path": "commentCreated"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "commentEdited",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "commentEdited.id"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v1 /*: any*/ ,
                            "action": "THROW",
                            "path": "commentEdited.type"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v3 /*: any*/ ,
                            "action": "THROW",
                            "path": "commentEdited.emailChannel"
                        },
                        v4 /*: any*/ 
                    ]
                },
                "action": "THROW",
                "path": "commentEdited"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "commentDeleted",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "commentDeleted.id"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v1 /*: any*/ ,
                            "action": "THROW",
                            "path": "commentDeleted.type"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v3 /*: any*/ ,
                            "action": "THROW",
                            "path": "commentDeleted.emailChannel"
                        },
                        v4 /*: any*/ 
                    ]
                },
                "action": "THROW",
                "path": "commentDeleted"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "issueCreated",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "issueCreated.id"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v1 /*: any*/ ,
                            "action": "THROW",
                            "path": "issueCreated.type"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v3 /*: any*/ ,
                            "action": "THROW",
                            "path": "issueCreated.emailChannel"
                        },
                        v4 /*: any*/ 
                    ]
                },
                "action": "THROW",
                "path": "issueCreated"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "issueMoved",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "issueMoved.id"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v1 /*: any*/ ,
                            "action": "THROW",
                            "path": "issueMoved.type"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v3 /*: any*/ ,
                            "action": "THROW",
                            "path": "issueMoved.emailChannel"
                        },
                        v4 /*: any*/ 
                    ]
                },
                "action": "THROW",
                "path": "issueMoved"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "mentionsCombined",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "mentionsCombined.id"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v1 /*: any*/ ,
                            "action": "THROW",
                            "path": "mentionsCombined.type"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v3 /*: any*/ ,
                            "action": "THROW",
                            "path": "mentionsCombined.emailChannel"
                        },
                        v4 /*: any*/ 
                    ]
                },
                "action": "THROW",
                "path": "mentionsCombined"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraNotificationPreference",
                    "kind": "LinkedField",
                    "name": "worklogCombined",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "worklogCombined.id"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v1 /*: any*/ ,
                            "action": "THROW",
                            "path": "worklogCombined.type"
                        },
                        {
                            "kind": "RequiredField",
                            "field": v3 /*: any*/ ,
                            "action": "THROW",
                            "path": "worklogCombined.emailChannel"
                        },
                        v4 /*: any*/ 
                    ]
                },
                "action": "THROW",
                "path": "worklogCombined"
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcincludemiscellaneouseventscombinedtyperelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraNotificationPreference",
                            "kind": "LinkedField",
                            "name": "miscellaneousIssueEventCombined",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": v0 /*: any*/ ,
                                    "action": "THROW",
                                    "path": "miscellaneousIssueEventCombined.id"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": v1 /*: any*/ ,
                                    "action": "THROW",
                                    "path": "miscellaneousIssueEventCombined.type"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": v3 /*: any*/ ,
                                    "action": "THROW",
                                    "path": "miscellaneousIssueEventCombined.emailChannel"
                                },
                                v4 /*: any*/ 
                            ]
                        },
                        "action": "THROW",
                        "path": "miscellaneousIssueEventCombined"
                    }
                ]
            }
        ],
        "type": "JiraNotificationPreferences"
    };
}();
$e22c4ae3313cdc70$var$node.hash = "f02a106252a740c0cd3fe8e46087ae74";
var $e22c4ae3313cdc70$export$2e2bcd8739ae039 = $e22c4ae3313cdc70$var$node;

});

parcelRegister("78u48", function(module, exports) {

$parcel$export(module.exports, "default", () => $259090ddc3b3be05$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8baa082c884df3d2d0f3b8fc723beafe>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $259090ddc3b3be05$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "channel"
        },
        {
            "kind": "ScalarField",
            "name": "isEnabled"
        },
        {
            "kind": "ScalarField",
            "name": "isEditable"
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "notificationsConfigRow_personalSettingsNotificationsConfigTable_preference",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "id"
                },
                "action": "THROW",
                "path": "id"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "kind": "ScalarField",
                    "name": "type"
                },
                "action": "THROW",
                "path": "type"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraNotificationChannel",
                    "kind": "LinkedField",
                    "name": "emailChannel",
                    "plural": false,
                    "selections": v0 /*: any*/ 
                },
                "action": "THROW",
                "path": "emailChannel"
            },
            {
                "concreteType": "JiraNotificationChannel",
                "kind": "LinkedField",
                "name": "inProductChannel",
                "plural": false,
                "selections": v0 /*: any*/ 
            }
        ],
        "type": "JiraNotificationPreference"
    };
}();
$259090ddc3b3be05$var$node.hash = "d84558bbdfdbb5f7d4340d813b2e9bda";
var $259090ddc3b3be05$export$2e2bcd8739ae039 = $259090ddc3b3be05$var$node;

});

parcelRegister("adhBu", function(module, exports) {

$parcel$export(module.exports, "default", () => $4dfd05883df726de$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f3944c0385c7400d0bdffc94b5d3ec04>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4dfd05883df726de$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "notificationsConfigRow_personalSettingsNotificationsConfigTable_enabledDataFragment",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraNotificationOptions",
                "kind": "LinkedField",
                "name": "options",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isEmailNotificationEnabled"
                    }
                ]
            },
            "action": "THROW",
            "path": "options"
        }
    ],
    "type": "JiraNotificationGlobalPreference"
};
$4dfd05883df726de$var$node.hash = "ead6fa8e8311f72e06ac03f0265fbbb6";
var $4dfd05883df726de$export$2e2bcd8739ae039 = $4dfd05883df726de$var$node;

});


parcelRegister("aydym", function(module, exports) {

$parcel$export(module.exports, "useGlobalHeadMutation", () => $4e270fc1c013d2d5$export$8c4b6d1a5a28fd4);

var $8i6xJ = parcelRequire("8i6xJ");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $9InRy = parcelRequire("9InRy");

var $koeKL = parcelRequire("koeKL");

var $dCkE6 = parcelRequire("dCkE6");
const $4e270fc1c013d2d5$export$8c4b6d1a5a28fd4 = ({ channel: channel })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const { showErrorFlag: showErrorFlag } = (0, $9InRy.useShowErrorFlag)();
    const [commit] = (0, $8Uumt.useMutation)((0, $8i6xJ.default));
    return (0, $5uXOq.useCallback)((newPreferencesAsList, newPreferences)=>{
        commit({
            variables: {
                cloudId: cloudId,
                input: {
                    preferences: newPreferencesAsList
                }
            },
            onError: (error)=>{
                showErrorFlag();
                (0, $dCkE6.fireOnErrorAnalytics)(error, 'Column', 'global', channel);
            },
            onCompleted: (response)=>{
                const errors = response?.jira?.updateGlobalNotificationPreferences?.errors;
                if (errors && errors?.length > 0) {
                    showErrorFlag();
                    (0, $dCkE6.fireOnCompleteErrorAnalytics)(errors, 'Column', 'global', channel);
                }
            },
            optimisticResponse: {
                jira: {
                    updateGlobalNotificationPreferences: {
                        success: true,
                        errors: [],
                        preferences: {
                            ...newPreferences
                        }
                    }
                }
            }
        });
    }, [
        cloudId,
        commit,
        showErrorFlag,
        channel
    ]);
};

});
parcelRegister("8i6xJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $89aa1e6c74fcb9ff$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0f17430957319a950e3ed39946119a77>>
 * @relayHash f2ca726f801e136c279017d75f94f354
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c99df337881ad0bd838cfc9c883d111708944298487c6f13e76fc86b1fe58752
const $89aa1e6c74fcb9ff$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = [
        {
            "kind": "ScalarField",
            "name": "channel"
        },
        {
            "kind": "ScalarField",
            "name": "isEnabled"
        },
        {
            "kind": "ScalarField",
            "name": "isEditable"
        }
    ], v5 = [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "concreteType": "JiraNotificationChannel",
            "kind": "LinkedField",
            "name": "emailChannel",
            "plural": false,
            "selections": v4 /*: any*/ 
        },
        {
            "concreteType": "JiraNotificationChannel",
            "kind": "LinkedField",
            "name": "inProductChannel",
            "plural": false,
            "selections": v4 /*: any*/ 
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "globalNotificationsConfigHead_HeadCheckbox_updateGlobalPreferencesMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateGlobalPreferencesPayload",
                            "kind": "LinkedField",
                            "name": "updateGlobalNotificationPreferences",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraNotificationPreferences",
                                    "kind": "LinkedField",
                                    "name": "preferences",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "notificationsConfigHead_personalSettingsNotificationsConfigTable_HeadCheckbox_allPreferences"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "globalNotificationsConfigHead_HeadCheckbox_updateGlobalPreferencesMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateGlobalPreferencesPayload",
                            "kind": "LinkedField",
                            "name": "updateGlobalNotificationPreferences",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraNotificationPreferences",
                                    "kind": "LinkedField",
                                    "name": "preferences",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraNotificationPreference",
                                            "kind": "LinkedField",
                                            "name": "issueAssigned",
                                            "plural": false,
                                            "selections": v5 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraNotificationPreference",
                                            "kind": "LinkedField",
                                            "name": "issueUpdated",
                                            "plural": false,
                                            "selections": v5 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraNotificationPreference",
                                            "kind": "LinkedField",
                                            "name": "issueDeleted",
                                            "plural": false,
                                            "selections": v5 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraNotificationPreference",
                                            "kind": "LinkedField",
                                            "name": "commentCreated",
                                            "plural": false,
                                            "selections": v5 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraNotificationPreference",
                                            "kind": "LinkedField",
                                            "name": "commentEdited",
                                            "plural": false,
                                            "selections": v5 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraNotificationPreference",
                                            "kind": "LinkedField",
                                            "name": "commentDeleted",
                                            "plural": false,
                                            "selections": v5 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraNotificationPreference",
                                            "kind": "LinkedField",
                                            "name": "issueCreated",
                                            "plural": false,
                                            "selections": v5 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraNotificationPreference",
                                            "kind": "LinkedField",
                                            "name": "issueMoved",
                                            "plural": false,
                                            "selections": v5 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraNotificationPreference",
                                            "kind": "LinkedField",
                                            "name": "mentionsCombined",
                                            "plural": false,
                                            "selections": v5 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraNotificationPreference",
                                            "kind": "LinkedField",
                                            "name": "worklogCombined",
                                            "plural": false,
                                            "selections": v5 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraNotificationPreference",
                                            "kind": "LinkedField",
                                            "name": "miscellaneousIssueEventCombined",
                                            "plural": false,
                                            "selections": v5 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "c99df337881ad0bd838cfc9c883d111708944298487c6f13e76fc86b1fe58752",
            "metadata": {},
            "name": "globalNotificationsConfigHead_HeadCheckbox_updateGlobalPreferencesMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$89aa1e6c74fcb9ff$var$node.hash = "8675f86ca14bab97607ca1ee3141da84";
var $89aa1e6c74fcb9ff$export$2e2bcd8739ae039 = $89aa1e6c74fcb9ff$var$node;

});

parcelRegister("9InRy", function(module, exports) {

$parcel$export(module.exports, "useShowErrorFlag", () => $688f1fcbf2ebe50b$export$7b656ca20272d6d6);

var $5uXOq = parcelRequire("5uXOq");

var $7HGHK = parcelRequire("7HGHK");
var $pa9q9 = parcelRequire("pa9q9");


var $2N0ub = parcelRequire("2N0ub");
const $688f1fcbf2ebe50b$export$7b656ca20272d6d6 = ()=>{
    const { showFlag: showFlag } = (0, $pa9q9.useFlagService)();
    const showErrorFlag = (0, $5uXOq.useCallback)((errorMessageDescription)=>showFlag({
            key: (0, $7HGHK.toFlagId)((0, $de5881e58df3bf21$export$f5e4c120ac01b615)),
            testId: 'personal-settings-notifications-config-table.common.error-flag',
            type: 'error',
            title: (0, $2N0ub.default).errorFlagTitleNonFinal,
            description: errorMessageDescription || (0, $2N0ub.default).errorFlagDescriptionNonFinal,
            isAutoDismiss: true,
            messageId: 'personal-settings-error-flag.ui.show-flag.error',
            messageType: 'transactional'
        }), [
        showFlag
    ]);
    return {
        showErrorFlag: showErrorFlag
    };
};

});
const $de5881e58df3bf21$export$f5e4c120ac01b615 = 'NOTIFICATIONS_CONFIG_ERROR_FLAG';

parcelRegister("2N0ub", function(module, exports) {

$parcel$export(module.exports, "default", () => $47987370824ce994$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $47987370824ce994$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorFlagTitleNonFinal: {
        "id": "personal-settings-error-flag.error-flag-title-non-final",
        "defaultMessage": "Something went wrong"
    },
    errorFlagDescriptionNonFinal: {
        "id": "personal-settings-error-flag.error-flag-description-non-final",
        "defaultMessage": "There was an issue updating your notifications preference, we're working on fixing it, please try again later."
    }
});

});


parcelRegister("dCkE6", function(module, exports) {

$parcel$export(module.exports, "fireOnCompleteErrorAnalytics", () => $1528f84d96bb47bc$export$64d9f1c03877c5f4);
$parcel$export(module.exports, "fireOnErrorAnalytics", () => $1528f84d96bb47bc$export$e919fd52a36bedfe);

var $jcw0u = parcelRequire("jcw0u");
function $1528f84d96bb47bc$export$2fc59efc98eee175(channelsEnabled) {
    return [
        ...channelsEnabled || []
    ].reduce((acc, channel)=>{
        acc[channel] = true;
        return acc;
    }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    {});
}
function $1528f84d96bb47bc$export$64d9f1c03877c5f4(errors, mutationLocation, configType, channel) {
    errors.forEach((error)=>{
        (0, $jcw0u.default)({
            meta: {
                id: `mutateNotificationsConfig${mutationLocation}CompletedError`,
                packageName: 'jiraPersonalSettingsNotificationsConfigTable',
                teamName: 'jira-notifications-platform'
            },
            error: new Error(error?.message || 'Unknown Error'),
            sendToPrivacyUnsafeSplunk: true,
            attributes: {
                configType: configType,
                channel: channel
            }
        });
    });
}
function $1528f84d96bb47bc$export$e919fd52a36bedfe(error, mutationLocation, configType, channel) {
    (0, $jcw0u.default)({
        meta: {
            id: `mutateNotificationsConfig${mutationLocation}`,
            packageName: 'jiraPersonalSettingsNotificationsConfigTable',
            teamName: 'jira-notifications-platform'
        },
        error: error,
        sendToPrivacyUnsafeSplunk: true,
        attributes: {
            configType: configType,
            channel: channel
        }
    });
}

});


parcelRegister("iDjms", function(module, exports) {

$parcel$export(module.exports, "useGlobalRowMutation", () => $e8a56f59b0f7f035$export$47da3e0e9cc98997);

var $ieaBS = parcelRequire("ieaBS");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $9InRy = parcelRequire("9InRy");

var $koeKL = parcelRequire("koeKL");

var $dCkE6 = parcelRequire("dCkE6");
const $e8a56f59b0f7f035$export$47da3e0e9cc98997 = ()=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const { showErrorFlag: showErrorFlag } = (0, $9InRy.useShowErrorFlag)();
    const [commit] = (0, $8Uumt.useMutation)((0, $ieaBS.default));
    return (0, $5uXOq.useCallback)((channel, isEnabled, newPreferences, type)=>{
        commit({
            variables: {
                cloudId: cloudId,
                input: {
                    preferences: [
                        {
                            channel: channel,
                            isEnabled: isEnabled,
                            type: type
                        }
                    ]
                }
            },
            onError: (error)=>{
                showErrorFlag();
                (0, $dCkE6.fireOnErrorAnalytics)(error, 'Row', 'global', channel);
            },
            onCompleted: (response)=>{
                const errors = response?.jira?.updateGlobalNotificationPreferences?.errors;
                if (errors && errors?.length > 0) {
                    showErrorFlag();
                    (0, $dCkE6.fireOnCompleteErrorAnalytics)(errors, 'Row', 'global', channel);
                }
            },
            optimisticResponse: {
                jira: {
                    updateGlobalNotificationPreferences: {
                        success: true,
                        errors: [],
                        preferences: {
                            ...newPreferences
                        }
                    }
                }
            }
        });
    }, [
        cloudId,
        commit,
        showErrorFlag
    ]);
};

});
parcelRegister("ieaBS", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e166381b2861db4$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bd1242a7c88b1a5c1f8494ffa70dfea0>>
 * @relayHash 144a3e02cd51285aa0d86b9dff43b671
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c04c40710e4bc72f2404c4f03f62d0185d1d8c192aed3c549a97c9ec5d5fb2de

var $jA1kf = parcelRequire("jA1kf");
const $4e166381b2861db4$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "success"
    }, v4 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v5 = [
        {
            "kind": "FragmentSpread",
            "name": "notificationsConfigRow_personalSettingsNotificationsConfigTable_preference"
        }
    ], v6 = [
        {
            "kind": "ScalarField",
            "name": "channel"
        },
        {
            "kind": "ScalarField",
            "name": "isEnabled"
        },
        {
            "kind": "ScalarField",
            "name": "isEditable"
        }
    ], v7 = [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "concreteType": "JiraNotificationChannel",
            "kind": "LinkedField",
            "name": "emailChannel",
            "plural": false,
            "selections": v6 /*: any*/ 
        },
        {
            "concreteType": "JiraNotificationChannel",
            "kind": "LinkedField",
            "name": "inProductChannel",
            "plural": false,
            "selections": v6 /*: any*/ 
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "globalNotificationsConfigRow_updateGlobalPreferencesMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraUpdateGlobalPreferencesPayload",
                            "kind": "LinkedField",
                            "name": "updateGlobalNotificationPreferences",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "JiraNotificationPreferences",
                                    "kind": "LinkedField",
                                    "name": "preferences",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "notificationsConfigRow_personalSettingsNotificationsConfigTable_allPreferences"
                                        },
                                        {
                                            "concreteType": "JiraNotificationPreference",
                                            "kind": "LinkedField",
                                            "name": "issueAssigned",
                                            "plural": false,
                                            "selections": v5 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraNotificationPreference",
                                            "kind": "LinkedField",
                                            "name": "issueUpdated",
                                            "plural": false,
                                            "selections": v5 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraNotificationPreference",
                                            "kind": "LinkedField",
                                            "name": "issueDeleted",
                                            "plural": false,
                                            "selections": v5 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraNotificationPreference",
                                            "kind": "LinkedField",
                                            "name": "commentCreated",
                                            "plural": false,
                                            "selections": v5 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraNotificationPreference",
                                            "kind": "LinkedField",
                                            "name": "commentEdited",
                                            "plural": false,
                                            "selections": v5 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraNotificationPreference",
                                            "kind": "LinkedField",
                                            "name": "commentDeleted",
                                            "plural": false,
                                            "selections": v5 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcincludemiscellaneouseventscombinedtyperelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "globalNotificationsConfigRow_updateGlobalPreferencesMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraUpdateGlobalPreferencesPayload",
                            "kind": "LinkedField",
                            "name": "updateGlobalNotificationPreferences",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "JiraNotificationPreferences",
                                    "kind": "LinkedField",
                                    "name": "preferences",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraNotificationPreference",
                                            "kind": "LinkedField",
                                            "name": "issueAssigned",
                                            "plural": false,
                                            "selections": v7 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraNotificationPreference",
                                            "kind": "LinkedField",
                                            "name": "issueUpdated",
                                            "plural": false,
                                            "selections": v7 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraNotificationPreference",
                                            "kind": "LinkedField",
                                            "name": "issueDeleted",
                                            "plural": false,
                                            "selections": v7 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraNotificationPreference",
                                            "kind": "LinkedField",
                                            "name": "commentCreated",
                                            "plural": false,
                                            "selections": v7 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraNotificationPreference",
                                            "kind": "LinkedField",
                                            "name": "commentEdited",
                                            "plural": false,
                                            "selections": v7 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraNotificationPreference",
                                            "kind": "LinkedField",
                                            "name": "commentDeleted",
                                            "plural": false,
                                            "selections": v7 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraNotificationPreference",
                                            "kind": "LinkedField",
                                            "name": "issueCreated",
                                            "plural": false,
                                            "selections": v7 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraNotificationPreference",
                                            "kind": "LinkedField",
                                            "name": "issueMoved",
                                            "plural": false,
                                            "selections": v7 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraNotificationPreference",
                                            "kind": "LinkedField",
                                            "name": "mentionsCombined",
                                            "plural": false,
                                            "selections": v7 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraNotificationPreference",
                                            "kind": "LinkedField",
                                            "name": "worklogCombined",
                                            "plural": false,
                                            "selections": v7 /*: any*/ 
                                        },
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcincludemiscellaneouseventscombinedtyperelayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraNotificationPreference",
                                                    "kind": "LinkedField",
                                                    "name": "miscellaneousIssueEventCombined",
                                                    "plural": false,
                                                    "selections": v7 /*: any*/ 
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "c04c40710e4bc72f2404c4f03f62d0185d1d8c192aed3c549a97c9ec5d5fb2de",
            "metadata": {},
            "name": "globalNotificationsConfigRow_updateGlobalPreferencesMutation",
            "operationKind": "mutation",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcincludemiscellaneouseventscombinedtyperelayprovider": (0, $jA1kf.default)
            }
        }
    };
}();
$4e166381b2861db4$var$node.hash = "b219f196d29e1eb0cec5ccc48752d004";
var $4e166381b2861db4$export$2e2bcd8739ae039 = $4e166381b2861db4$var$node;

});



parcelRegister("lGrfI", function(module, exports) {

$parcel$export(module.exports, "ProjectNotificationsConfig", () => $9b30d2ec4b85cbd7$export$426c6e7c17c70743);

var $32ZzH = parcelRequire("32ZzH");

var $6YOiE = parcelRequire("6YOiE");

var $cRwxw = parcelRequire("cRwxw");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $bU3PY = parcelRequire("bU3PY");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");

var $92Z2l = parcelRequire("92Z2l");

var $koVbs = parcelRequire("koVbs");

var $ccNZn = parcelRequire("ccNZn");

var $dcT9d = parcelRequire("dcT9d");

var $lfTZh = parcelRequire("lfTZh");

var $jgJNO = parcelRequire("jgJNO");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $2RREg = parcelRequire("2RREg");

var $a94gn = parcelRequire("a94gn");

var $ieDtd = parcelRequire("ieDtd");

var $aNXq7 = parcelRequire("aNXq7");

var $3WipV = parcelRequire("3WipV");

var $h7nzM = parcelRequire("h7nzM");

var $gElwb = parcelRequire("gElwb");

var $64VXR = parcelRequire("64VXR");
const $9b30d2ec4b85cbd7$var$ProjectNotificationsConfigInner = ({ projects: projects, projectsPaginatedFragment: projectsPaginatedFragment })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { open: open } = (0, $aNXq7.useAccordions)();
    const [isWarningPopUpOpen, setIsWarningPopUpOpen] = (0, $5uXOq.useState)(false);
    const fragment = (0, $8Uumt.useFragment)((0, $cRwxw.default), projects);
    const { data: paginatedProjects } = (0, $8Uumt.usePaginationFragment)((0, $6YOiE.default), projectsPaginatedFragment);
    const notificationPreferences = paginatedProjects?.jira?.allNotificationProjectPreferences;
    const paginatedPreferences = notificationPreferences?.edges;
    const totalConfiguredProjects = notificationPreferences?.totalCount;
    const handleNewProject = (0, $5uXOq.useCallback)((projectId)=>{
        open(projectId);
    }, [
        open
    ]);
    const projectNotifModalProps = {
        onClose: ()=>{
            const analyticsEvent = createAnalyticsEvent({
                action: 'close',
                actionSubject: 'modalDialog'
            });
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'projectNotificationConfirmationEntryPointModal');
        },
        connectionId: paginatedProjects.jira.allNotificationProjectPreferences.__id,
        onProjectAdditionSuccess: (value)=>{
            const analyticsEvent = createAnalyticsEvent({
                action: 'submitted',
                actionSubject: 'modalDialog'
            });
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'projectNotificationConfirmationEntryPointModal');
            handleNewProject(value);
        },
        jiraQueryFragment: fragment
    };
    const onOpen = ()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'open',
            actionSubject: 'modalDialog'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'projectNotificationConfirmationEntryPointModal');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dcT9d.FieldWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        justifyContent: "space-between",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9b30d2ec4b85cbd7$var$SectionHeading, null, formatMessage((0, $gElwb.default).notificationProjectSettingsHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        alignItems: "center"
    }, totalConfiguredProjects >= 45 && totalConfiguredProjects < 50 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        placement: "left-start",
        messageId: "personal-settings-notifications-config-table.ui.project-notifications-config.popup",
        messageType: "transactional",
        isOpen: isWarningPopUpOpen,
        onClose: ()=>setIsWarningPopUpOpen(false),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                padding: "space.200"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9b30d2ec4b85cbd7$var$WarningPopUpTitle, null, formatMessage((0, $gElwb.default).notificationProjectSettingsHardLimitWarningPopUpTextTitle)), ' ', formatMessage((0, $gElwb.default).notificationProjectSettingsHardLimitWarningPopUpText)),
        trigger: ({ 'aria-expanded': _, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9b30d2ec4b85cbd7$var$WarningPopUpButtonContainer, {
                onMouseEnter: ()=>setIsWarningPopUpOpen(true),
                "data-testid": "personal-settings-notifications-config-table.ui.project-notifications-config.warning-pop-up-button-container",
                ...triggerProps
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bU3PY))), {
                spacing: "spacious",
                label: "warning",
                color: "var(--ds-icon-warning, #E56910)"
            }))
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ccNZn.ModalEntryPointButtonTrigger), {
        entryPoint: (0, $2RREg.projectNotificationConfirmationEntryPoint),
        entryPointProps: projectNotifModalProps,
        isDisabled: totalConfiguredProjects >= 50,
        interactionName: "open-add-project-notification-modal",
        testId: "personal-settings-notifications-config-table.ui.project-notifications-config.button",
        onClick: onOpen,
        useInternalModal: true
    }, formatMessage((0, $gElwb.default).notificationProjectSettingsAddProjectNotificationsButtonText)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9b30d2ec4b85cbd7$var$ProjectSectionDescription, null, formatMessage((0, $gElwb.default).notificationProjectSettingsDescription)), totalConfiguredProjects >= 50 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
        appearance: "warning",
        "data-testId": "personal-settings-notifications-config-table.ui.project-notifications-config.section-message"
    }, formatMessage((0, $gElwb.default).notificationProjectSettingsHardLimitWarningBannerText)) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3WipV.ConnectionContext).Provider, {
        value: paginatedProjects.jira.allNotificationProjectPreferences.__id
    }, paginatedPreferences.length ? paginatedPreferences.map((edge)=>edge?.node?.project?.id ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $64VXR.ProjectNotificationConfigTableNew), {
            key: `${edge.node.project.id}`,
            projectPreferencesData: edge.node,
            enabledPreferenceFragment: fragment
        }) : null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h7nzM.ProjectNotificationsEmptyState), null))));
};
const $9b30d2ec4b85cbd7$export$426c6e7c17c70743 = ({ projects: projects })=>{
    const [projectIds] = (0, $ieDtd.useQueryParam)('projectIds');
    const data = (0, $8Uumt.useFragment)((0, $32ZzH.default), projects);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "project-notifications-accordion",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a94gn.ProjectNotificationAccordionSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "personalSettingsProjectNotifications",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aNXq7.AccordionContainer), {
        initial: (projectIds || '').split(',').reduce((acc, id)=>{
            acc[id] = {
                isOpen: true
            };
            return acc; // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        }, {})
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9b30d2ec4b85cbd7$var$ProjectNotificationsConfigInner, {
        projects: data,
        projectsPaginatedFragment: data
    }))));
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9b30d2ec4b85cbd7$var$ProjectSectionDescription = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulppxbi _1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9b30d2ec4b85cbd7$var$SectionHeading = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "h5", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulppxbi _1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9b30d2ec4b85cbd7$var$WarningPopUpButtonContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2hwxpxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9b30d2ec4b85cbd7$var$WarningPopUpTitle = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_k48pmoej",
            __cmplp.className
        ])
    });
});

});
parcelRegister("32ZzH", function(module, exports) {

$parcel$export(module.exports, "default", () => $f98e9c8b6fda2a1b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8fa1595308bd202841cb3d3319c7bdd5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f98e9c8b6fda2a1b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "projectNotificationsConfig_personalSettingsNotificationsConfigTable_projects",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "projectNotificationsConfig_personalSettingsNotificationsConfigTable_ProjectNotificationsConfigInner_projectsPaginatedFragment"
        },
        {
            "kind": "FragmentSpread",
            "name": "projectNotificationsConfig_personalSettingsNotificationsConfigTable_ProjectNotificationsConfigInner_projects"
        }
    ],
    "type": "Query"
};
$f98e9c8b6fda2a1b$var$node.hash = "de9361a54574487f8c76041f7fbf96eb";
var $f98e9c8b6fda2a1b$export$2e2bcd8739ae039 = $f98e9c8b6fda2a1b$var$node;

});

parcelRegister("6YOiE", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e0dde4e54480eec$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<11ccc61a4a1db73c75720faaaa93d9ba>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $cMU5i = parcelRequire("cMU5i");
const $8e0dde4e54480eec$var$node = function() {
    var v0 = [
        "jira",
        "allNotificationProjectPreferences"
    ];
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "after"
            },
            {
                "kind": "RootArgument",
                "name": "cloudId"
            },
            {
                "defaultValue": 50,
                "kind": "LocalArgument",
                "name": "first"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": "first",
                    "cursor": "after",
                    "direction": "forward",
                    "path": v0 /*: any*/ 
                }
            ],
            "refetch": {
                "connection": {
                    "forward": {
                        "count": "first",
                        "cursor": "after"
                    },
                    "backward": null,
                    "path": v0 /*: any*/ 
                },
                "fragmentPathInResult": [],
                "operation": (0, $cMU5i.default)
            }
        },
        "name": "projectNotificationsConfig_personalSettingsNotificationsConfigTable_ProjectNotificationsConfigInner_projectsPaginatedFragment",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "alias": "allNotificationProjectPreferences",
                                "args": [
                                    {
                                        "kind": "Variable",
                                        "name": "cloudId",
                                        "variableName": "cloudId"
                                    }
                                ],
                                "concreteType": "JiraNotificationProjectPreferenceConnection",
                                "kind": "LinkedField",
                                "name": "__projects_allNotificationProjectPreferences_connection",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "concreteType": "JiraProjectNotificationPreferenceEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraNotificationProjectPreferences",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "projectNotificationsConfigTable_personalSettingsNotificationsConfigTable_ProjectNotificationConfigTableNew_projectPreferencesData"
                                                        },
                                                        {
                                                            "concreteType": "JiraProject",
                                                            "kind": "LinkedField",
                                                            "name": "project",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": {
                                                                        "kind": "ScalarField",
                                                                        "name": "id"
                                                                    },
                                                                    "action": "THROW",
                                                                    "path": "jira.allNotificationProjectPreferences.edges.node.project.id"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__typename"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "cursor"
                                                }
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "jira.allNotificationProjectPreferences.edges"
                                    },
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "kind": "ScalarField",
                                            "name": "totalCount"
                                        },
                                        "action": "THROW",
                                        "path": "jira.allNotificationProjectPreferences.totalCount"
                                    },
                                    {
                                        "concreteType": "PageInfo",
                                        "kind": "LinkedField",
                                        "name": "pageInfo",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "endCursor"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "hasNextPage"
                                            }
                                        ]
                                    },
                                    {
                                        "kind": "ClientExtension",
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "kind": "ScalarField",
                                                    "name": "__id"
                                                },
                                                "action": "THROW",
                                                "path": "jira.allNotificationProjectPreferences.__id"
                                            }
                                        ]
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "jira.allNotificationProjectPreferences"
                        }
                    ]
                },
                "action": "THROW",
                "path": "jira"
            }
        ],
        "type": "Query"
    };
}();
$8e0dde4e54480eec$var$node.hash = "94e7b6ce63a63c0a232c230663f65475";
var $8e0dde4e54480eec$export$2e2bcd8739ae039 = $8e0dde4e54480eec$var$node;

});
parcelRegister("cMU5i", function(module, exports) {

$parcel$export(module.exports, "default", () => $b22ef21e49629d4d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<782fa4d80667329ece0b683bdb7e8bb2>>
 * @relayHash 7a23fe81e7b14f964e63fef81c222e2e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID dbaa3af35baaeff3cc2847ceadb949f870b84e731635d9759c865bd563f5d78e

var $jA1kf = parcelRequire("jA1kf");
const $b22ef21e49629d4d$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": 50,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "kind": "Variable",
        "name": "after",
        "variableName": "after"
    }, v4 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
    }, v5 = [
        v3 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        v4 /*: any*/ 
    ], v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = [
        {
            "kind": "ScalarField",
            "name": "channel"
        },
        {
            "kind": "ScalarField",
            "name": "isEnabled"
        },
        {
            "kind": "ScalarField",
            "name": "isEditable"
        }
    ], v8 = [
        v6 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "concreteType": "JiraNotificationChannel",
            "kind": "LinkedField",
            "name": "emailChannel",
            "plural": false,
            "selections": v7 /*: any*/ 
        },
        {
            "concreteType": "JiraNotificationChannel",
            "kind": "LinkedField",
            "name": "inProductChannel",
            "plural": false,
            "selections": v7 /*: any*/ 
        },
        {
            "kind": "ScalarField",
            "name": "category"
        }
    ], v9 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ProjectNotificationsPaginationQuery",
            "selections": [
                {
                    "args": [
                        v3 /*: any*/ ,
                        v4 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "projectNotificationsConfig_personalSettingsNotificationsConfigTable_ProjectNotificationsConfigInner_projectsPaginatedFragment"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcincludemiscellaneouseventscombinedtyperelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "ProjectNotificationsPaginationQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "JiraNotificationProjectPreferenceConnection",
                            "kind": "LinkedField",
                            "name": "allNotificationProjectPreferences",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraProjectNotificationPreferenceEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraNotificationProjectPreferences",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraProject",
                                                    "kind": "LinkedField",
                                                    "name": "project",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        {
                                                            "concreteType": "JiraAvatar",
                                                            "kind": "LinkedField",
                                                            "name": "avatar",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "xsmall"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "JiraNotificationPreferences",
                                                    "kind": "LinkedField",
                                                    "name": "preferences",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraNotificationPreference",
                                                            "kind": "LinkedField",
                                                            "name": "issueAssigned",
                                                            "plural": false,
                                                            "selections": v8 /*: any*/ 
                                                        },
                                                        {
                                                            "concreteType": "JiraNotificationPreference",
                                                            "kind": "LinkedField",
                                                            "name": "issueUpdated",
                                                            "plural": false,
                                                            "selections": v8 /*: any*/ 
                                                        },
                                                        {
                                                            "concreteType": "JiraNotificationPreference",
                                                            "kind": "LinkedField",
                                                            "name": "issueDeleted",
                                                            "plural": false,
                                                            "selections": v8 /*: any*/ 
                                                        },
                                                        {
                                                            "concreteType": "JiraNotificationPreference",
                                                            "kind": "LinkedField",
                                                            "name": "commentCreated",
                                                            "plural": false,
                                                            "selections": v8 /*: any*/ 
                                                        },
                                                        {
                                                            "concreteType": "JiraNotificationPreference",
                                                            "kind": "LinkedField",
                                                            "name": "commentEdited",
                                                            "plural": false,
                                                            "selections": v8 /*: any*/ 
                                                        },
                                                        {
                                                            "concreteType": "JiraNotificationPreference",
                                                            "kind": "LinkedField",
                                                            "name": "commentDeleted",
                                                            "plural": false,
                                                            "selections": v8 /*: any*/ 
                                                        },
                                                        {
                                                            "concreteType": "JiraNotificationPreference",
                                                            "kind": "LinkedField",
                                                            "name": "issueCreated",
                                                            "plural": false,
                                                            "selections": v8 /*: any*/ 
                                                        },
                                                        {
                                                            "concreteType": "JiraNotificationPreference",
                                                            "kind": "LinkedField",
                                                            "name": "issueMoved",
                                                            "plural": false,
                                                            "selections": v8 /*: any*/ 
                                                        },
                                                        {
                                                            "concreteType": "JiraNotificationPreference",
                                                            "kind": "LinkedField",
                                                            "name": "mentionsCombined",
                                                            "plural": false,
                                                            "selections": v8 /*: any*/ 
                                                        },
                                                        {
                                                            "concreteType": "JiraNotificationPreference",
                                                            "kind": "LinkedField",
                                                            "name": "worklogCombined",
                                                            "plural": false,
                                                            "selections": v8 /*: any*/ 
                                                        },
                                                        {
                                                            "concreteType": "JiraNotificationPreference",
                                                            "kind": "LinkedField",
                                                            "name": "miscellaneousIssueEventCombined",
                                                            "plural": false,
                                                            "selections": v8 /*: any*/ 
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v9 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "cursor"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "totalCount"
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "endCursor"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                },
                                v9 /*: any*/ 
                            ]
                        },
                        {
                            "args": v5 /*: any*/ ,
                            "filters": [
                                "cloudId"
                            ],
                            "handle": "connection",
                            "key": "projects_allNotificationProjectPreferences",
                            "kind": "LinkedHandle",
                            "name": "allNotificationProjectPreferences"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "dbaa3af35baaeff3cc2847ceadb949f870b84e731635d9759c865bd563f5d78e",
            "metadata": {},
            "name": "ProjectNotificationsPaginationQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcincludemiscellaneouseventscombinedtyperelayprovider": (0, $jA1kf.default)
            }
        }
    };
}();
$b22ef21e49629d4d$var$node.hash = "94e7b6ce63a63c0a232c230663f65475";
var $b22ef21e49629d4d$export$2e2bcd8739ae039 = $b22ef21e49629d4d$var$node;

});


parcelRegister("cRwxw", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa3e25c8ed0c0457$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2d900ebfbff7df7a3722aa8c581cb13c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $aa3e25c8ed0c0457$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "projectNotificationsConfig_personalSettingsNotificationsConfigTable_ProjectNotificationsConfigInner_projects",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "projectNotificationsConfigTable_personalSettingsNotificationsConfigTable_ProjectNotificationConfigTableNew_enabledPreferenceFragment"
        },
        {
            "kind": "FragmentSpread",
            "name": "ui_projectNotificationsModal_ProjectNotificationsModal"
        }
    ],
    "type": "Query"
};
$aa3e25c8ed0c0457$var$node.hash = "1a4f4da7c189163bef79a5b3dda3d45f";
var $aa3e25c8ed0c0457$export$2e2bcd8739ae039 = $aa3e25c8ed0c0457$var$node;

});

parcelRegister("ccNZn", function(module, exports) {

$parcel$export(module.exports, "ModalEntryPointButtonTrigger", () => $eadd31beb792ab12$export$a0d6030c4f504341);

var $5uXOq = parcelRequire("5uXOq");

var $eCeGD = parcelRequire("eCeGD");

var $2KAtx = parcelRequire("2KAtx");
function $eadd31beb792ab12$export$a0d6030c4f504341({ children: children, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, errorAttributes: errorAttributes, Fallback: Fallback, modalTitle: modalTitle, modalProps: modalProps, useInternalModal: useInternalModal, ...buttonProps }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2KAtx.ModalEntryPointPressableTrigger), {
        entryPoint: entryPoint,
        entryPointParams: entryPointParams,
        entryPointProps: entryPointProps,
        errorAttributes: errorAttributes,
        Fallback: Fallback,
        modalTitle: modalTitle,
        modalProps: modalProps,
        useInternalModal: useInternalModal
    }, ({ ref: ref })=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
            ref: ref,
            ...buttonProps
        }, children));
}

});

parcelRegister("2RREg", function(module, exports) {

$parcel$export(module.exports, "projectNotificationConfirmationEntryPoint", () => $499a5fbdce9a8f98$export$d1c1bbaab0ca63f5);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $499a5fbdce9a8f98$export$d1c1bbaab0ca63f5 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("g6PPJ")).then((module)=>module.ProjectNotificationsModal), {
        moduleId: "c97742fe"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("g6PPJ", function(module, exports) {

let $bba569e533a5b7ac$var$load = (parcelRequire("28QjX"))(4);
module.exports = $bba569e533a5b7ac$var$load("8HqcI").then(()=>parcelRequire('9KI7c'));

});


parcelRegister("aNXq7", function(module, exports) {

$parcel$export(module.exports, "AccordionContainer", () => $3b56e38494a21c4d$export$c5db0d123d7c6491);
$parcel$export(module.exports, "useAccordions", () => $3b56e38494a21c4d$export$dbb4cd4ee94ac902);
$parcel$export(module.exports, "Accordion", () => $3b56e38494a21c4d$export$a766cd26d0d69044);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ujWmd = parcelRequire("ujWmd");

var $l1N8i = parcelRequire("l1N8i");

var $c8Oei = parcelRequire("c8Oei");

var $cEqbp = parcelRequire("cEqbp");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");

var $bFdF6 = parcelRequire("bFdF6");
const $3b56e38494a21c4d$export$c5db0d123d7c6491 = (0, $gg7kZ.createContainer)();
const $3b56e38494a21c4d$var$AccordionStore = (0, $iXqE5.createStore)({
    containedBy: $3b56e38494a21c4d$export$c5db0d123d7c6491,
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    initialState: {},
    actions: {
        open: (id)=>({ setState: setState })=>{
                setState({
                    [id]: {
                        isOpen: true
                    }
                });
            },
        close: (id)=>({ setState: setState })=>{
                setState({
                    [id]: {
                        isOpen: false
                    }
                });
            }
    },
    handlers: {
        onInit: ()=>({ setState: setState }, { initial: initial })=>{
                setState(initial);
            }
    }
});
const $3b56e38494a21c4d$var$getAccordionFromId = (state, id)=>state[id] || {
        isOpen: false
    };
const $3b56e38494a21c4d$export$35e88b08325f7140 = (0, $3sQ5x.createHook)($3b56e38494a21c4d$var$AccordionStore, {
    selector: $3b56e38494a21c4d$var$getAccordionFromId
});
const $3b56e38494a21c4d$export$dbb4cd4ee94ac902 = (0, $3sQ5x.createActionsHook)($3b56e38494a21c4d$var$AccordionStore);
const $3b56e38494a21c4d$export$a766cd26d0d69044 = ({ children: children, projectName: projectName, projectAvatar: projectAvatar, id: id })=>{
    const [state, { open: open, close: close }] = $3b56e38494a21c4d$export$35e88b08325f7140(id);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onToggle = (0, $5uXOq.useCallback)((event)=>{
        if (event.currentTarget.open && !state.isOpen) open(id);
        else if (!event.currentTarget.open && state.isOpen) close(id);
    }, [
        open,
        id,
        state.isOpen,
        close
    ]);
    const { isOpen: isOpen } = state;
    const onClick = (0, $5uXOq.useCallback)(()=>{
        if (!isOpen) (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'accordion toggled', 'projectAccordionExpanded');
        else (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'accordion toggled', 'projectAccordionCollapsed');
    }, [
        isOpen,
        createAnalyticsEvent
    ]);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const Chevron = isOpen ? (0, (/*@__PURE__*/$parcel$interopDefault($cEqbp))) : (0, (/*@__PURE__*/$parcel$interopDefault($c8Oei)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3b56e38494a21c4d$var$AccordionWrapper, {
        "data-testid": `personal-settings-notifications-config-table.common.ui.accordion.accordion-wrapper-${id}`,
        onToggle: onToggle,
        open: isOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3b56e38494a21c4d$var$AccordionHeader, {
        // event is on click so that it isn't fired when opened from the search box
        onClick: onClick,
        "data-testid": `personal-settings-notifications-config-table.common.ui.accordion.accordion-header-${id}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        gap: "space.100",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Chevron, {
        color: "var(--ds-icon, #44546F)",
        LEGACY_primaryColor: "var(--ds-icon, #44546F)",
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        gap: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        weight: "medium",
        color: "color.text.subtle"
    }, formatMessage((0, $bFdF6.default).notificationColumnHeaderPrefix)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
        borderColor: "transparent",
        size: "xsmall",
        appearance: "square",
        src: projectAvatar
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "small",
        color: "color.text"
    }, projectName)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $3b56e38494a21c4d$var$accordionBodyStyles
    }, children));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3b56e38494a21c4d$var$AccordionWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "details", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1b66",
            __cmplp?.open ? "_11q7fg4m" : "_11q7qbzx",
            __cmplp.className
        ])
    });
});
const $3b56e38494a21c4d$var$accordionBodyStyles = (0, $8CUq3.xcss)({
    paddingLeft: 'space.200',
    paddingRight: 'space.200',
    paddingBottom: 'space.200'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3b56e38494a21c4d$var$AccordionHeader = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "summary", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _2rko1b66 _qtt8glyw _v5641vyf _1dqoglyw _1e0c1txw _4cvr1h6o _uiztglyw _syaz1kw7 _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _80omtlke",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cEqbp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e58b02424147679c6e4b17a279d99cac>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $935d87e1572638ec$var$_react = $935d87e1572638ec$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $935d87e1572638ec$var$_chevronUp = $935d87e1572638ec$var$_interopRequireDefault((parcelRequire("jj3Gi")));

var $935d87e1572638ec$var$_chevronUp2 = $935d87e1572638ec$var$_interopRequireDefault((parcelRequire("6Pmud")));
function $935d87e1572638ec$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronUpIcon.
 * This component is ChevronUpIcon, with `UNSAFE_fallbackIcon` set to "ChevronUpIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for accordions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $935d87e1572638ec$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $935d87e1572638ec$var$_react.default.createElement($935d87e1572638ec$var$_chevronUp.default, Object.assign({
        LEGACY_fallbackIcon: $935d87e1572638ec$var$_chevronUp2.default
    }, props));
$935d87e1572638ec$var$ChevronUpIcon.Name = 'ChevronUpIconMigration';
var $935d87e1572638ec$var$_default = module.exports.default = $935d87e1572638ec$var$ChevronUpIcon;

});
parcelRegister("6Pmud", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4f88f2d3e506ed12$var$_react = $4f88f2d3e506ed12$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $4f88f2d3e506ed12$var$_chevronUp = $4f88f2d3e506ed12$var$_interopRequireDefault((parcelRequire("dVd7B")));
function $4f88f2d3e506ed12$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4f88f2d3e506ed12$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $4f88f2d3e506ed12$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m11.221 9.322-2.929 2.955a1.01 1.01 0 0 0 0 1.419.986.986 0 0 0 1.405 0l2.298-2.317 2.307 2.327a.99.99 0 0 0 1.407 0 1.01 1.01 0 0 0 0-1.419l-2.94-2.965A1.1 1.1 0 0 0 11.991 9c-.279 0-.557.107-.77.322"/></svg>`
    }, props, {
        newIcon: $4f88f2d3e506ed12$var$_chevronUp.default
    }));
$4f88f2d3e506ed12$var$ChevronUpIcon.displayName = 'ChevronUpIcon';
var $4f88f2d3e506ed12$var$_default = module.exports.default = $4f88f2d3e506ed12$var$ChevronUpIcon;

});


parcelRegister("bFdF6", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff73deee6ef21693$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ff73deee6ef21693$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    notificationColumnHeaderPrefix: {
        "id": "personal-settings-notifications-config-table.common.accordion.notification-column-header-prefix",
        "defaultMessage": "Notifications for"
    }
});

});


parcelRegister("3WipV", function(module, exports) {

$parcel$export(module.exports, "ConnectionContext", () => $ef5cca5987d9b1ec$export$af54d3055d90c64e);
$parcel$export(module.exports, "useConnection", () => $ef5cca5987d9b1ec$export$985e8768c0e91dbc);

var $5uXOq = parcelRequire("5uXOq");
const $ef5cca5987d9b1ec$export$af54d3055d90c64e = /*#__PURE__*/ (0, $5uXOq.createContext)('');
const $ef5cca5987d9b1ec$export$985e8768c0e91dbc = ()=>(0, $5uXOq.useContext)($ef5cca5987d9b1ec$export$af54d3055d90c64e);

});

parcelRegister("h7nzM", function(module, exports) {

$parcel$export(module.exports, "ProjectNotificationsEmptyState", () => $c5de355f340dcf75$export$8d9a1aa9388ec390);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $dCLgq = parcelRequire("dCLgq");
parcelRequire("j5BZI");
var $e0P8p = parcelRequire("e0P8p");
var $2eEg4 = parcelRequire("2eEg4");

var $koVbs = parcelRequire("koVbs");

var $hL6Gi = parcelRequire("hL6Gi");
const $c5de355f340dcf75$export$8d9a1aa9388ec390 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $c5de355f340dcf75$var$emptyProjectsBoxStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dCLgq.Illustration), {
        width: "100",
        srcLight: (0, (/*@__PURE__*/$parcel$interopDefault($2eEg4))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($e0P8p))),
        alt: "Choose a project to get started"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $c5de355f340dcf75$var$emptyProjectsBoxDescriptionStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c5de355f340dcf75$var$SectionHeading, null, formatMessage((0, $hL6Gi.default).notificationProjectSettingsEmptyProjectsBannerTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c5de355f340dcf75$var$ProjectSectionDescription, null, formatMessage((0, $hL6Gi.default).notificationProjectSettingsEmptyProjectsBannerBodyText)))));
};
const $c5de355f340dcf75$var$emptyProjectsBoxStyles = (0, $8CUq3.xcss)({
    borderColor: 'color.border',
    borderStyle: 'solid',
    borderRadius: 'border.radius',
    borderWidth: 'border.width',
    padding: 'space.200',
    paddingInline: 'space.400',
    backgroundColor: 'elevation.surface.sunken'
});
const $c5de355f340dcf75$var$emptyProjectsBoxDescriptionStyles = (0, $8CUq3.xcss)({
    marginLeft: 'space.500',
    marginTop: 'space.400'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c5de355f340dcf75$var$ProjectSectionDescription = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_otyr1ejb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c5de355f340dcf75$var$SectionHeading = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "h5", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_otyrpxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("j5BZI", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f83d823841fe42d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("2eEg4")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("e0P8p")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = gjrhpn3wqf4zmpvx9sfz2r
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/gjrhpn3wqf4zmpvx9sfz2r

var $dCLgq = parcelRequire("dCLgq");

var $e0P8p = parcelRequire("e0P8p");

var $2eEg4 = parcelRequire("2eEg4");
const $4f83d823841fe42d$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($2eEg4)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($e0P8p))
});
var $4f83d823841fe42d$export$2e2bcd8739ae039 = $4f83d823841fe42d$var$Illustration;
// for advanced use only
const $4f83d823841fe42d$export$a179c88182cb9d56 = [
    0,
    0,
    224,
    150
];

});
parcelRegister("e0P8p", function(module, exports) {
module.exports = new URL("folder-darkmode.55dfee70.svg", import.meta.url).toString();

});

parcelRegister("2eEg4", function(module, exports) {
module.exports = new URL("folder.025da90c.svg", import.meta.url).toString();

});


parcelRegister("hL6Gi", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef251e3af095a816$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ef251e3af095a816$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    notificationProjectSettingsEmptyProjectsBannerTitle: {
        "id": "personal-settings-notifications-config-table.project-notifications-config.empty-state.notification-project-settings-empty-projects-banner-title",
        "defaultMessage": "Choose a project to get started"
    },
    notificationProjectSettingsEmptyProjectsBannerBodyText: {
        "id": "personal-settings-notifications-config-table.project-notifications-config.empty-state.notification-project-settings-empty-projects-banner-body-text",
        "defaultMessage": "Don't want to apply default notifications to all your projects? Customize their notification settings."
    }
});

});


parcelRegister("gElwb", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba48c3dff73e0075$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ba48c3dff73e0075$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    notificationProjectSettingsHeading: {
        "id": "personal-settings-notifications-config-table.project-notifications-config.notification-project-settings-heading",
        "defaultMessage": "Customize project notifications"
    },
    notificationProjectSettingsDescription: {
        "id": "personal-settings-notifications-config-table.project-notifications-config.notification-project-settings-description",
        "defaultMessage": "Make your notifications specific to your project needs. Choose a project to set customized notifications."
    },
    notificationProjectSettingsAddProjectNotificationsButtonText: {
        "id": "personal-settings-notifications-config-table.project-notifications-config.notification-project-settings-add-project-notifications-button-text",
        "defaultMessage": "Add project notifications"
    },
    notificationProjectSettingsHardLimitWarningBannerText: {
        "id": "personal-settings-notifications-config-table.project-notifications-config.notification-project-settings-hard-limit-warning-banner-text",
        "defaultMessage": "You can\u2019t add more than 50 projects. In order to customize a new project, you\u2019ll need to remove an existing one."
    },
    notificationProjectSettingsHardLimitWarningPopUpTextTitle: {
        "id": "personal-settings-notifications-config-table.project-notifications-config.notification-project-settings-hard-limit-warning-pop-up-text-title",
        "defaultMessage": "Maximum 50 projects."
    },
    notificationProjectSettingsHardLimitWarningPopUpText: {
        "id": "personal-settings-notifications-config-table.project-notifications-config.notification-project-settings-hard-limit-warning-pop-up-text",
        "defaultMessage": "You\u2019re approaching the maximum number of projects you can create custom notifications for."
    }
});

});

parcelRegister("64VXR", function(module, exports) {

$parcel$export(module.exports, "ProjectNotificationConfigTableNew", () => $691195f794e0e2d4$export$c8551b1924596510);

var $3bsPy = parcelRequire("3bsPy");

var $bQPDq = parcelRequire("bQPDq");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $6tRzQ = parcelRequire("6tRzQ");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $jgJNO = parcelRequire("jgJNO");

var $iXVV6 = parcelRequire("iXVV6");

var $4R6GH = parcelRequire("4R6GH");


var $alXN4 = parcelRequire("alXN4");

var $1pLvM = parcelRequire("1pLvM");

var $hShCB = parcelRequire("hShCB");

var $dxt1X = parcelRequire("dxt1X");

var $1rVbx = parcelRequire("1rVbx");

var $jeTJ6 = parcelRequire("jeTJ6");

var $a5anj = parcelRequire("a5anj");

var $llINF = parcelRequire("llINF");

var $bfmvx = parcelRequire("bfmvx");

var $jt9Fb = parcelRequire("jt9Fb");
const $691195f794e0e2d4$export$c8551b1924596510 = ({ projectPreferencesData: projectPreferencesData, enabledPreferenceFragment: enabledPreferenceFragment })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isInfoPanelOpen, setIsInfoPanelOpen] = (0, $5uXOq.useState)(false);
    const enabledPreference = (0, $8Uumt.useFragment)((0, $bQPDq.default), enabledPreferenceFragment);
    const projectPreferences = (0, $8Uumt.useFragment)((0, $3bsPy.default), projectPreferencesData);
    const allPreferences = projectPreferences.preferences;
    const { project: project } = projectPreferences;
    const projectId = project?.id;
    const projectHeadMutationInProduct = (0, $llINF.useProjectHeadMutation)({
        projectId: projectId,
        channel: (0, $e7aa8280669c3543$export$201863d4c54f4831)
    });
    const projectHeadMutationEmail = (0, $llINF.useProjectHeadMutation)({
        projectId: projectId,
        channel: (0, $e7aa8280669c3543$export$61171c632678b12e)
    });
    const projectRowMutation = (0, $bfmvx.useProjectRowMutation)({
        projectId: projectId
    });
    const emailProjectHeadCheckboxId = `email-${projectId}`;
    const inProductProjectHeadCheckboxId = `inProduct-${projectId}`;
    const headCheckboxIds = {
        EMAIL: emailProjectHeadCheckboxId,
        IN_PRODUCT: inProductProjectHeadCheckboxId
    };
    if (!allPreferences || !projectId) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "personalSettingsProjectNotifications",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        attributes: {
            projectId: projectId
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $691195f794e0e2d4$var$projectContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a5anj.ProjectNotificationsAccordion), {
        project: project
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $691195f794e0e2d4$var$tableWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jeTJ6.Table), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jeTJ6.TableHeadContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jeTJ6.TableHeadRowContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jeTJ6.HeadCellContainer), null, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $alXN4.default).notificationColumnHeaderAllIssuesIssueTermRefresh : (0, $alXN4.default).notificationColumnHeaderAllIssues)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dxt1X.HeadCellCheckboxContainer), null, allPreferences && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hShCB.HeadCheckbox), {
        id: `all-issues-${inProductProjectHeadCheckboxId}`,
        commitMutation: projectHeadMutationInProduct,
        channel: (0, $e7aa8280669c3543$export$201863d4c54f4831),
        label: formatMessage((0, $alXN4.default).inProductColumnHeader),
        allPreferences: allPreferences,
        enabledDataFragment: enabledPreference.jira.notificationGlobalPreference,
        categories: [
            'ISSUE_ASSIGNED',
            'ISSUE_MENTIONED'
        ]
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dxt1X.HeadCellCheckboxContainer), null, allPreferences && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hShCB.HeadCheckbox), {
        id: `all-issues-${emailProjectHeadCheckboxId}`,
        commitMutation: projectHeadMutationEmail,
        channel: (0, $e7aa8280669c3543$export$61171c632678b12e),
        label: formatMessage((0, $alXN4.default).emailColumnHeader),
        allPreferences: allPreferences,
        enabledDataFragment: enabledPreference.jira.notificationGlobalPreference,
        categories: [
            'ISSUE_ASSIGNED',
            'ISSUE_MENTIONED'
        ]
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jeTJ6.TBody), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rVbx.NotificationsConfigRow), {
        preference: allPreferences.issueAssigned,
        allPreferences: allPreferences,
        label: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $alXN4.default).issueAssignedTypeIssueTermRefresh : (0, $alXN4.default).issueAssignedType),
        id: `issueAssigned-${projectId}`,
        commitMutation: projectRowMutation,
        headCheckboxIds: headCheckboxIds,
        enabledDataFragment: enabledPreference.jira.notificationGlobalPreference
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rVbx.NotificationsConfigRow), {
        preference: allPreferences.mentionsCombined,
        allPreferences: allPreferences,
        label: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $alXN4.default).mentionsCombinedTypeIssueTermRefresh : (0, $alXN4.default).mentionsCombinedType),
        id: `mentionsCombined-${projectId}`,
        commitMutation: projectRowMutation,
        headCheckboxIds: headCheckboxIds,
        enabledDataFragment: enabledPreference.jira.notificationGlobalPreference
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $691195f794e0e2d4$var$tableWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jeTJ6.Table), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jeTJ6.TableHeadContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jeTJ6.TableHeadRowContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jeTJ6.HeadCellContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center"
    }, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $alXN4.default).notificationColumnHeaderRelevantIssuesIssueTermRefresh : (0, $alXN4.default).notificationColumnHeaderRelevantIssues), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        placement: "right-start",
        messageId: "personal-settings-notifications-config-table.ui.project-notifications-config.project-notifications-config-table.popup",
        messageType: "transactional",
        isOpen: isInfoPanelOpen,
        onClose: ()=>{
            setIsInfoPanelOpen(false);
        },
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                padding: "space.200"
            }, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $alXN4.default).relevantIssueNotificationTableInfoIconTextIssueTermRefresh : (0, $alXN4.default).relevantIssueNotificationTableInfoIconText)),
        trigger: ({ 'aria-expanded': _, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                xcss: $691195f794e0e2d4$var$infoIconStyles,
                onMouseEnter: ()=>{
                    setIsInfoPanelOpen(true);
                },
                onMouseLeave: ()=>{
                    setIsInfoPanelOpen(false);
                },
                testId: "personal-settings-notifications-config-table.ui.project-notifications-config.project-notifications-config-table.warning-pop-up-button-container",
                ...triggerProps
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6tRzQ))), {
                spacing: "spacious",
                label: "warning",
                color: "var(--ds-icon-accent-gray, #758195)"
            }))
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dxt1X.HeadCellCheckboxContainer), null, allPreferences && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hShCB.HeadCheckbox), {
        id: `relevant-issues-${inProductProjectHeadCheckboxId}`,
        commitMutation: projectHeadMutationInProduct,
        channel: (0, $e7aa8280669c3543$export$201863d4c54f4831),
        label: formatMessage((0, $alXN4.default).inProductColumnHeader),
        allPreferences: allPreferences,
        enabledDataFragment: enabledPreference.jira.notificationGlobalPreference,
        categories: [
            'ISSUE_CHANGES',
            'COMMENT_CHANGES',
            'ISSUE_WORKLOG_CHANGES',
            'ISSUE_MISCELLANEOUS'
        ]
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dxt1X.HeadCellCheckboxContainer), null, allPreferences && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hShCB.HeadCheckbox), {
        id: `relevant-issues-${emailProjectHeadCheckboxId}`,
        commitMutation: projectHeadMutationEmail,
        channel: (0, $e7aa8280669c3543$export$61171c632678b12e),
        label: formatMessage((0, $alXN4.default).emailColumnHeader),
        allPreferences: allPreferences,
        enabledDataFragment: enabledPreference.jira.notificationGlobalPreference,
        categories: [
            'ISSUE_CHANGES',
            'COMMENT_CHANGES',
            'ISSUE_WORKLOG_CHANGES',
            'ISSUE_MISCELLANEOUS'
        ]
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jeTJ6.TBody), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1pLvM.NotificationsConfigRow), {
        allPreferences: allPreferences,
        label: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $alXN4.default).issueChangesCategoryTypeIssueTermRefresh : (0, $alXN4.default).issueChangesCategoryType),
        id: `issueChanges-${projectId}`,
        onRowMutation: projectRowMutation,
        headCheckboxIds: headCheckboxIds,
        enabledDataFragment: enabledPreference.jira.notificationGlobalPreference,
        onEmailHeadMutation: projectHeadMutationEmail,
        onInProductHeadMutation: projectHeadMutationInProduct,
        category: "ISSUE_CHANGES",
        projectId: projectId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1pLvM.NotificationsConfigRow), {
        allPreferences: allPreferences,
        label: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $alXN4.default).commentChangesCategoryTypeIssueTermRefresh : (0, $alXN4.default).commentChangesCategoryType),
        id: `commentChanges-${projectId}`,
        onRowMutation: projectRowMutation,
        headCheckboxIds: headCheckboxIds,
        enabledDataFragment: enabledPreference.jira.notificationGlobalPreference,
        onEmailHeadMutation: projectHeadMutationEmail,
        onInProductHeadMutation: projectHeadMutationInProduct,
        category: "COMMENT_CHANGES",
        projectId: projectId
    }), allPreferences.worklogCombined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rVbx.NotificationsConfigRow), {
        preference: allPreferences.worklogCombined,
        allPreferences: allPreferences,
        label: formatMessage((0, $alXN4.default).worklogCombinedType),
        id: `worklogCombined-${projectId}`,
        commitMutation: projectRowMutation,
        headCheckboxIds: headCheckboxIds,
        enabledDataFragment: enabledPreference.jira.notificationGlobalPreference
    }), allPreferences.miscellaneousIssueEventCombined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rVbx.NotificationsConfigRow), {
        preference: allPreferences.miscellaneousIssueEventCombined,
        allPreferences: allPreferences,
        label: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $alXN4.default).miscellaneousIssueEventCombinedIssueTermRefresh : (0, $alXN4.default).miscellaneousIssueEventCombined),
        id: `miscellaneousIssueEventCombined-${projectId}`,
        commitMutation: projectRowMutation,
        headCheckboxIds: headCheckboxIds,
        enabledDataFragment: enabledPreference.jira.notificationGlobalPreference
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $691195f794e0e2d4$var$removeButtonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jt9Fb.RemoveButton), {
        project: projectPreferences
    })))));
};
const $691195f794e0e2d4$var$removeButtonStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.200'
});
const $691195f794e0e2d4$var$projectContainerStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.150'
});
const $691195f794e0e2d4$var$infoIconStyles = (0, $8CUq3.xcss)({
    marginLeft: 'space.100',
    marginTop: 'space.025'
});
const $691195f794e0e2d4$var$tableWrapperStyles = (0, $8CUq3.xcss)({
    borderWidth: 'border.width',
    borderStyle: 'solid',
    borderColor: 'color.border',
    backgroundColor: 'elevation.surface.raised',
    borderRadius: 'border.radius.050',
    marginBottom: 'space.200',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':last-of-type': {
        marginBottom: 'space.0'
    }
});

});
parcelRegister("3bsPy", function(module, exports) {

$parcel$export(module.exports, "default", () => $dbe8d06524124f18$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5f7a27231d5fb1fb10fa3408afaf9625>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $dbe8d06524124f18$var$node = function() {
    var v0 = [
        {
            "kind": "FragmentSpread",
            "name": "notificationsConfigRow_personalSettingsNotificationsConfigTable_preference"
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "projectNotificationsConfigTable_personalSettingsNotificationsConfigTable_ProjectNotificationConfigTableNew_projectPreferencesData",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "projectNotificationsRemoveButton_personalSettingsNotificationsConfigTable_RemoveButton"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "project",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "kind": "ScalarField",
                                "name": "id"
                            },
                            "action": "THROW",
                            "path": "project.id"
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "projectNotificationsAccordion_personalSettingsNotificationsConfigTable"
                        }
                    ]
                },
                "action": "THROW",
                "path": "project"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraNotificationPreferences",
                    "kind": "LinkedField",
                    "name": "preferences",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "notificationsConfigHead_personalSettingsNotificationsConfigTable_HeadCheckbox_allPreferences"
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "notificationsAccordianRow_personalSettingsNotificationsConfigTable_NotificationsConfigRow_allPreferences"
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "notificationsConfigRow_personalSettingsNotificationsConfigTable_allPreferences"
                        },
                        {
                            "kind": "RequiredField",
                            "field": {
                                "concreteType": "JiraNotificationPreference",
                                "kind": "LinkedField",
                                "name": "issueAssigned",
                                "plural": false,
                                "selections": v0 /*: any*/ 
                            },
                            "action": "THROW",
                            "path": "preferences.issueAssigned"
                        },
                        {
                            "kind": "RequiredField",
                            "field": {
                                "concreteType": "JiraNotificationPreference",
                                "kind": "LinkedField",
                                "name": "mentionsCombined",
                                "plural": false,
                                "selections": v0 /*: any*/ 
                            },
                            "action": "THROW",
                            "path": "preferences.mentionsCombined"
                        },
                        {
                            "kind": "RequiredField",
                            "field": {
                                "concreteType": "JiraNotificationPreference",
                                "kind": "LinkedField",
                                "name": "worklogCombined",
                                "plural": false,
                                "selections": v0 /*: any*/ 
                            },
                            "action": "THROW",
                            "path": "preferences.worklogCombined"
                        },
                        {
                            "kind": "RequiredField",
                            "field": {
                                "concreteType": "JiraNotificationPreference",
                                "kind": "LinkedField",
                                "name": "miscellaneousIssueEventCombined",
                                "plural": false,
                                "selections": v0 /*: any*/ 
                            },
                            "action": "THROW",
                            "path": "preferences.miscellaneousIssueEventCombined"
                        }
                    ]
                },
                "action": "THROW",
                "path": "preferences"
            }
        ],
        "type": "JiraNotificationProjectPreferences"
    };
}();
$dbe8d06524124f18$var$node.hash = "5edc2e126ed0810c509c3f64b7d71d71";
var $dbe8d06524124f18$export$2e2bcd8739ae039 = $dbe8d06524124f18$var$node;

});

parcelRegister("bQPDq", function(module, exports) {

$parcel$export(module.exports, "default", () => $213c4948467dda2e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<00899e449cace05ed3882fe2a0c2aaeb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $213c4948467dda2e$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "cloudId"
        }
    ],
    "kind": "Fragment",
    "name": "projectNotificationsConfigTable_personalSettingsNotificationsConfigTable_ProjectNotificationConfigTableNew_enabledPreferenceFragment",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraQuery",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "cloudId",
                                    "variableName": "cloudId"
                                }
                            ],
                            "concreteType": "JiraNotificationGlobalPreference",
                            "kind": "LinkedField",
                            "name": "notificationGlobalPreference",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "notificationsConfigHead_personalSettingsNotificationsConfigTable_HeadCheckbox_enabledDataFragment"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "notificationsConfigRow_personalSettingsNotificationsConfigTable_enabledDataFragment"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "notificationsAccordianRow_personalSettingsNotificationsConfigTable_NotificationsConfigRow_enabledDataFragment"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "jira.notificationGlobalPreference"
                    }
                ]
            },
            "action": "THROW",
            "path": "jira"
        }
    ],
    "type": "Query"
};
$213c4948467dda2e$var$node.hash = "09d906c8b484e004b2b2e2fd2adf065a";
var $213c4948467dda2e$export$2e2bcd8739ae039 = $213c4948467dda2e$var$node;

});

parcelRegister("a5anj", function(module, exports) {

$parcel$export(module.exports, "ProjectNotificationsAccordion", () => $336ef704b56d2a31$export$a4bb921a729ea88d);

var $1DNFa = parcelRequire("1DNFa");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $aNXq7 = parcelRequire("aNXq7");
const $336ef704b56d2a31$export$a4bb921a729ea88d = ({ children: children, project: project })=>{
    const projectData = (0, $8Uumt.useFragment)((0, $1DNFa.default), project);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aNXq7.Accordion), {
        id: projectData.id,
        projectName: projectData.name,
        projectAvatar: projectData.avatar.xsmall
    }, children);
};

});
parcelRegister("1DNFa", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecfaf42c6af92f31$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4fc407496912e8a510d438293f8da28c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ecfaf42c6af92f31$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "projectNotificationsAccordion_personalSettingsNotificationsConfigTable",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        },
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraAvatar",
                "kind": "LinkedField",
                "name": "avatar",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "kind": "ScalarField",
                            "name": "xsmall"
                        },
                        "action": "THROW",
                        "path": "avatar.xsmall"
                    }
                ]
            },
            "action": "THROW",
            "path": "avatar"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "name"
            },
            "action": "THROW",
            "path": "name"
        }
    ],
    "type": "JiraProject"
};
$ecfaf42c6af92f31$var$node.hash = "dfd510bee0fd10776f8f0d1854818db2";
var $ecfaf42c6af92f31$export$2e2bcd8739ae039 = $ecfaf42c6af92f31$var$node;

});


parcelRegister("llINF", function(module, exports) {

$parcel$export(module.exports, "useProjectHeadMutation", () => $f774af4ab12668d0$export$5267ec16d50eff44);

var $ekUhY = parcelRequire("ekUhY");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $9InRy = parcelRequire("9InRy");

var $koeKL = parcelRequire("koeKL");

var $dCkE6 = parcelRequire("dCkE6");
const $f774af4ab12668d0$export$5267ec16d50eff44 = ({ projectId: projectId, channel: channel })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const { showErrorFlag: showErrorFlag } = (0, $9InRy.useShowErrorFlag)();
    const [commit] = (0, $8Uumt.useMutation)((0, $ekUhY.default));
    return (0, $5uXOq.useCallback)((newPreferencesAsList, newPreferences)=>{
        if (!cloudId || !projectId) return;
        commit({
            variables: {
                cloudId: cloudId,
                input: {
                    projectId: projectId,
                    preferences: newPreferencesAsList
                }
            },
            onError: (error)=>{
                showErrorFlag();
                (0, $dCkE6.fireOnErrorAnalytics)(error, 'Column', 'project', channel);
            },
            onCompleted: (response)=>{
                const errors = response?.jira?.updateProjectNotificationPreferences?.errors;
                if (errors && errors?.length > 0) {
                    showErrorFlag();
                    (0, $dCkE6.fireOnCompleteErrorAnalytics)(errors, 'Column', 'project', channel);
                }
            },
            optimisticResponse: {
                jira: {
                    updateProjectNotificationPreferences: {
                        success: true,
                        errors: [],
                        preferences: {
                            ...newPreferences
                        }
                    }
                }
            }
        });
    }, [
        cloudId,
        commit,
        projectId,
        showErrorFlag,
        channel
    ]);
};

});
parcelRegister("ekUhY", function(module, exports) {

$parcel$export(module.exports, "default", () => $9dcc1143eac86736$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cc0f1822c45163ae9e0a70e36fed4ab4>>
 * @relayHash 40641bb3e28814da75e7a2ef44a3a696
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1484947807387ce99021a50116c181e9dda21bf126c1582a6f11d6b77de0473b
const $9dcc1143eac86736$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v4 = [
        {
            "kind": "ScalarField",
            "name": "channel"
        },
        {
            "kind": "ScalarField",
            "name": "isEnabled"
        },
        {
            "kind": "ScalarField",
            "name": "isEditable"
        }
    ], v5 = [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "concreteType": "JiraNotificationChannel",
            "kind": "LinkedField",
            "name": "emailChannel",
            "plural": false,
            "selections": v4 /*: any*/ 
        },
        {
            "concreteType": "JiraNotificationChannel",
            "kind": "LinkedField",
            "name": "inProductChannel",
            "plural": false,
            "selections": v4 /*: any*/ 
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "projectNotificationsConfigHead_HeadCheckbox_updateProjectPreferencesMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateProjectNotificationPreferencesPayload",
                            "kind": "LinkedField",
                            "name": "updateProjectNotificationPreferences",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraNotificationPreferences",
                                    "kind": "LinkedField",
                                    "name": "preferences",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "notificationsConfigHead_personalSettingsNotificationsConfigTable_HeadCheckbox_allPreferences"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "projectNotificationsConfigHead_HeadCheckbox_updateProjectPreferencesMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateProjectNotificationPreferencesPayload",
                            "kind": "LinkedField",
                            "name": "updateProjectNotificationPreferences",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraNotificationPreferences",
                                    "kind": "LinkedField",
                                    "name": "preferences",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraNotificationPreference",
                                            "kind": "LinkedField",
                                            "name": "issueAssigned",
                                            "plural": false,
                                            "selections": v5 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraNotificationPreference",
                                            "kind": "LinkedField",
                                            "name": "issueUpdated",
                                            "plural": false,
                                            "selections": v5 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraNotificationPreference",
                                            "kind": "LinkedField",
                                            "name": "issueDeleted",
                                            "plural": false,
                                            "selections": v5 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraNotificationPreference",
                                            "kind": "LinkedField",
                                            "name": "commentCreated",
                                            "plural": false,
                                            "selections": v5 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraNotificationPreference",
                                            "kind": "LinkedField",
                                            "name": "commentEdited",
                                            "plural": false,
                                            "selections": v5 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraNotificationPreference",
                                            "kind": "LinkedField",
                                            "name": "commentDeleted",
                                            "plural": false,
                                            "selections": v5 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraNotificationPreference",
                                            "kind": "LinkedField",
                                            "name": "issueCreated",
                                            "plural": false,
                                            "selections": v5 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraNotificationPreference",
                                            "kind": "LinkedField",
                                            "name": "issueMoved",
                                            "plural": false,
                                            "selections": v5 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraNotificationPreference",
                                            "kind": "LinkedField",
                                            "name": "mentionsCombined",
                                            "plural": false,
                                            "selections": v5 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraNotificationPreference",
                                            "kind": "LinkedField",
                                            "name": "worklogCombined",
                                            "plural": false,
                                            "selections": v5 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraNotificationPreference",
                                            "kind": "LinkedField",
                                            "name": "miscellaneousIssueEventCombined",
                                            "plural": false,
                                            "selections": v5 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "1484947807387ce99021a50116c181e9dda21bf126c1582a6f11d6b77de0473b",
            "metadata": {},
            "name": "projectNotificationsConfigHead_HeadCheckbox_updateProjectPreferencesMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$9dcc1143eac86736$var$node.hash = "3aa6007c01d7a3f03378110552b2cc76";
var $9dcc1143eac86736$export$2e2bcd8739ae039 = $9dcc1143eac86736$var$node;

});


parcelRegister("bfmvx", function(module, exports) {

$parcel$export(module.exports, "useProjectRowMutation", () => $b93366bb17b79a87$export$bd926d32f49366ad);

var $e6VFC = parcelRequire("e6VFC");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $9InRy = parcelRequire("9InRy");

var $koeKL = parcelRequire("koeKL");

var $dCkE6 = parcelRequire("dCkE6");
const $b93366bb17b79a87$export$bd926d32f49366ad = ({ projectId: projectId })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const { showErrorFlag: showErrorFlag } = (0, $9InRy.useShowErrorFlag)();
    const [commit] = (0, $8Uumt.useMutation)((0, $e6VFC.default));
    return (0, $5uXOq.useCallback)((channel, isEnabled, newPreferences, type)=>{
        if (!cloudId || !projectId) return;
        commit({
            variables: {
                cloudId: cloudId,
                input: {
                    projectId: projectId,
                    preferences: [
                        {
                            channel: channel,
                            isEnabled: isEnabled,
                            type: type
                        }
                    ]
                }
            },
            onError: (error)=>{
                showErrorFlag();
                (0, $dCkE6.fireOnErrorAnalytics)(error, 'Row', 'project', channel);
            },
            onCompleted: (response)=>{
                const errors = response?.jira?.updateProjectNotificationPreferences?.errors;
                if (errors && errors?.length > 0) {
                    showErrorFlag();
                    (0, $dCkE6.fireOnCompleteErrorAnalytics)(errors, 'Row', 'project', channel);
                }
            },
            optimisticResponse: {
                jira: {
                    updateProjectNotificationPreferences: {
                        success: true,
                        errors: [],
                        preferences: {
                            ...newPreferences
                        }
                    }
                }
            }
        });
    }, [
        cloudId,
        commit,
        projectId,
        showErrorFlag
    ]);
};

});
parcelRegister("e6VFC", function(module, exports) {

$parcel$export(module.exports, "default", () => $67f8f103b5929e3c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a16c3090947e6ae3a39798a0e27994eb>>
 * @relayHash 52ed301e4f005d4b36e632a7296990c3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 62a57993d6ab1aaa47ba4974eb21026e8dba6668b0677e0530c29d10149efba1

var $jA1kf = parcelRequire("jA1kf");
const $67f8f103b5929e3c$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "success"
    }, v4 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    }, v5 = [
        {
            "kind": "FragmentSpread",
            "name": "notificationsConfigRow_personalSettingsNotificationsConfigTable_preference"
        }
    ], v6 = [
        {
            "kind": "ScalarField",
            "name": "channel"
        },
        {
            "kind": "ScalarField",
            "name": "isEnabled"
        },
        {
            "kind": "ScalarField",
            "name": "isEditable"
        }
    ], v7 = [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "type"
        },
        {
            "concreteType": "JiraNotificationChannel",
            "kind": "LinkedField",
            "name": "emailChannel",
            "plural": false,
            "selections": v6 /*: any*/ 
        },
        {
            "concreteType": "JiraNotificationChannel",
            "kind": "LinkedField",
            "name": "inProductChannel",
            "plural": false,
            "selections": v6 /*: any*/ 
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "projectNotificationsConfigRow_updateProjectPreferencesMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraUpdateProjectNotificationPreferencesPayload",
                            "kind": "LinkedField",
                            "name": "updateProjectNotificationPreferences",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "JiraNotificationPreferences",
                                    "kind": "LinkedField",
                                    "name": "preferences",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "notificationsConfigRow_personalSettingsNotificationsConfigTable_allPreferences"
                                        },
                                        {
                                            "concreteType": "JiraNotificationPreference",
                                            "kind": "LinkedField",
                                            "name": "issueAssigned",
                                            "plural": false,
                                            "selections": v5 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraNotificationPreference",
                                            "kind": "LinkedField",
                                            "name": "issueUpdated",
                                            "plural": false,
                                            "selections": v5 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraNotificationPreference",
                                            "kind": "LinkedField",
                                            "name": "issueDeleted",
                                            "plural": false,
                                            "selections": v5 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraNotificationPreference",
                                            "kind": "LinkedField",
                                            "name": "commentCreated",
                                            "plural": false,
                                            "selections": v5 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraNotificationPreference",
                                            "kind": "LinkedField",
                                            "name": "commentEdited",
                                            "plural": false,
                                            "selections": v5 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraNotificationPreference",
                                            "kind": "LinkedField",
                                            "name": "commentDeleted",
                                            "plural": false,
                                            "selections": v5 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcincludemiscellaneouseventscombinedtyperelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "projectNotificationsConfigRow_updateProjectPreferencesMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraUpdateProjectNotificationPreferencesPayload",
                            "kind": "LinkedField",
                            "name": "updateProjectNotificationPreferences",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "JiraNotificationPreferences",
                                    "kind": "LinkedField",
                                    "name": "preferences",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraNotificationPreference",
                                            "kind": "LinkedField",
                                            "name": "issueAssigned",
                                            "plural": false,
                                            "selections": v7 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraNotificationPreference",
                                            "kind": "LinkedField",
                                            "name": "issueUpdated",
                                            "plural": false,
                                            "selections": v7 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraNotificationPreference",
                                            "kind": "LinkedField",
                                            "name": "issueDeleted",
                                            "plural": false,
                                            "selections": v7 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraNotificationPreference",
                                            "kind": "LinkedField",
                                            "name": "commentCreated",
                                            "plural": false,
                                            "selections": v7 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraNotificationPreference",
                                            "kind": "LinkedField",
                                            "name": "commentEdited",
                                            "plural": false,
                                            "selections": v7 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraNotificationPreference",
                                            "kind": "LinkedField",
                                            "name": "commentDeleted",
                                            "plural": false,
                                            "selections": v7 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraNotificationPreference",
                                            "kind": "LinkedField",
                                            "name": "issueCreated",
                                            "plural": false,
                                            "selections": v7 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraNotificationPreference",
                                            "kind": "LinkedField",
                                            "name": "issueMoved",
                                            "plural": false,
                                            "selections": v7 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraNotificationPreference",
                                            "kind": "LinkedField",
                                            "name": "mentionsCombined",
                                            "plural": false,
                                            "selections": v7 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "JiraNotificationPreference",
                                            "kind": "LinkedField",
                                            "name": "worklogCombined",
                                            "plural": false,
                                            "selections": v7 /*: any*/ 
                                        },
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcincludemiscellaneouseventscombinedtyperelayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraNotificationPreference",
                                                    "kind": "LinkedField",
                                                    "name": "miscellaneousIssueEventCombined",
                                                    "plural": false,
                                                    "selections": v7 /*: any*/ 
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "62a57993d6ab1aaa47ba4974eb21026e8dba6668b0677e0530c29d10149efba1",
            "metadata": {},
            "name": "projectNotificationsConfigRow_updateProjectPreferencesMutation",
            "operationKind": "mutation",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcincludemiscellaneouseventscombinedtyperelayprovider": (0, $jA1kf.default)
            }
        }
    };
}();
$67f8f103b5929e3c$var$node.hash = "c6d1b008957d0d915fa6547117558a1a";
var $67f8f103b5929e3c$export$2e2bcd8739ae039 = $67f8f103b5929e3c$var$node;

});


parcelRegister("jt9Fb", function(module, exports) {

$parcel$export(module.exports, "RemoveButton", () => $e9e276e4af5aa0bb$export$4e9d5ce1e6c22a94);

var $6HYZi = parcelRequire("6HYZi");

var $2fPdd = parcelRequire("2fPdd");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $fVnbM = parcelRequire("fVnbM");

var $a1X0L = parcelRequire("a1X0L");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $9InRy = parcelRequire("9InRy");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $koeKL = parcelRequire("koeKL");

var $ieDtd = parcelRequire("ieDtd");

var $dCkE6 = parcelRequire("dCkE6");

var $3WipV = parcelRequire("3WipV");

var $79lHa = parcelRequire("79lHa");
const $e9e276e4af5aa0bb$export$d12f3b39ffe9620d = 'project-notifications-removed-flag';
const $e9e276e4af5aa0bb$export$4e9d5ce1e6c22a94 = ({ project: project })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const connectionId = (0, $3WipV.useConnection)();
    const cloudId = (0, $koeKL.useCloudId)();
    const [projectIds, setProjectIds] = (0, $ieDtd.useQueryParam)('projectIds');
    const { showErrorFlag: showErrorFlag } = (0, $9InRy.useShowErrorFlag)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const projectData = (0, $8Uumt.useFragment)((0, $2fPdd.default), project);
    const [commit] = (0, $8Uumt.useMutation)((0, $6HYZi.default));
    const onClick = (0, $5uXOq.useCallback)(()=>{
        const projectId = projectData.project.id;
        const projectName = projectData.project.name;
        const projectIdArray = (projectIds || '')?.split(',').filter((id)=>id);
        const isProjectIdInArray = projectIdArray.includes(projectId);
        const updater = (store)=>{
            const connection = store.get(connectionId);
            if (connection != null) {
                (0, $8Uumt.ConnectionHandler).deleteNode(connection, projectData.__id);
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const projectCount = connection.getValue('totalCount') || 0;
                connection.setValue(projectCount - 1, 'totalCount');
            }
        };
        commit({
            variables: {
                cloudId: cloudId,
                input: {
                    projectId: projectData.project.id
                }
            },
            optimisticUpdater: updater,
            updater: updater,
            onError: (error)=>{
                showErrorFlag();
                if (isProjectIdInArray) setProjectIds(projectIdArray.join(','));
                (0, $dCkE6.fireOnErrorAnalytics)(error, 'Remove', 'project');
            },
            onCompleted: (response)=>{
                const errors = response?.jira?.deleteProjectNotificationPreferences?.errors;
                if (errors && errors?.length > 0) {
                    showErrorFlag();
                    if (isProjectIdInArray) setProjectIds(projectIdArray.join(','));
                    (0, $dCkE6.fireOnCompleteErrorAnalytics)(errors, 'Remove', 'project');
                } else {
                    showFlag({
                        id: $e9e276e4af5aa0bb$export$d12f3b39ffe9620d,
                        type: 'info',
                        isAutoDismiss: true,
                        title: formatMessage((0, $79lHa.default).projectNotificationsRemoveUndoFlagTitle, {
                            projectName: projectName
                        }),
                        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a1X0L))), {
                            spacing: "spacious",
                            label: ""
                        }),
                        actions: [],
                        testId: 'personal-settings-notifications-config-table.ui.project-notifications-config.project-notifications-config-table.project-notifications-undo-flag',
                        messageId: 'personal-settings-notifications-config-table.ui.project-notifications-config.project-notifications-config-table.project-notifications-remove-button.show-flag.info',
                        messageType: 'transactional'
                    });
                    (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'flag viewed', 'removeProjectConfigurationFlagViewed');
                    (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'projectNotifications deleted');
                }
            }
        });
        if (isProjectIdInArray) setProjectIds(projectIdArray.filter((id)=>id !== projectId).join(','));
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'projectConfigurationRemoveClicked');
    }, [
        projectData.project.id,
        projectData.project.name,
        projectData.__id,
        projectIds,
        commit,
        cloudId,
        createAnalyticsEvent,
        connectionId,
        showErrorFlag,
        setProjectIds,
        showFlag,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        onClick: onClick,
        testId: `personal-settings-notifications-config-table.ui.project-notifications-config.project-notifications-config-table.project-notifications-remove-button-${projectData?.project?.id}`
    }, formatMessage((0, $79lHa.default).projectNotificationsRemoveButton));
};

});
parcelRegister("6HYZi", function(module, exports) {

$parcel$export(module.exports, "default", () => $65170cfff4c20c27$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b87f0ffd38e621b2742d655307924f63>>
 * @relayHash 8387e0661b8b019d099befa3c97fa9a6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5e6f628c5ed79ed0d7e1206f7545ec83f24e5978f77bba20dedeacfb9bbe4511
const $65170cfff4c20c27$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Variable",
                            "name": "input",
                            "variableName": "input"
                        }
                    ],
                    "concreteType": "JiraDeleteProjectNotificationPreferencesPayload",
                    "kind": "LinkedField",
                    "name": "deleteProjectNotificationPreferences",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "success"
                        },
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "message"
                                }
                            ]
                        },
                        {
                            "concreteType": "JiraNotificationProjectPreferences",
                            "kind": "LinkedField",
                            "name": "projectPreferences",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "projectNotificationsRemoveButton_removeMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "projectNotificationsRemoveButton_removeMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "5e6f628c5ed79ed0d7e1206f7545ec83f24e5978f77bba20dedeacfb9bbe4511",
            "metadata": {},
            "name": "projectNotificationsRemoveButton_removeMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$65170cfff4c20c27$var$node.hash = "33cec3d8a7498cc5f2bcb6a1f9673b71";
var $65170cfff4c20c27$export$2e2bcd8739ae039 = $65170cfff4c20c27$var$node;

});

parcelRegister("2fPdd", function(module, exports) {

$parcel$export(module.exports, "default", () => $aed7f9654b33f4d9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<148e399b10ba798b0ef676af8e278862>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $aed7f9654b33f4d9$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "projectNotificationsRemoveButton_personalSettingsNotificationsConfigTable_RemoveButton",
        "selections": [
            {
                "kind": "RequiredField",
                "field": v0 /*: any*/ ,
                "action": "THROW",
                "path": "id"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "project",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": v0 /*: any*/ ,
                            "action": "THROW",
                            "path": "project.id"
                        },
                        {
                            "kind": "RequiredField",
                            "field": {
                                "kind": "ScalarField",
                                "name": "name"
                            },
                            "action": "THROW",
                            "path": "project.name"
                        }
                    ]
                },
                "action": "THROW",
                "path": "project"
            },
            {
                "kind": "ClientExtension",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "__id"
                    }
                ]
            }
        ],
        "type": "JiraNotificationProjectPreferences"
    };
}();
$aed7f9654b33f4d9$var$node.hash = "cb31c96fe2fdc342b82f1c11e02a88d6";
var $aed7f9654b33f4d9$export$2e2bcd8739ae039 = $aed7f9654b33f4d9$var$node;

});

parcelRegister("79lHa", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bc7526bc538f9b3$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $6bc7526bc538f9b3$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    projectNotificationsRemoveButton: {
        "id": "personal-settings-notifications-config-table.project-notifications-config.project-notifications-config-table.project-notifications-remove-button.project-notifications-remove-button",
        "defaultMessage": "Remove"
    },
    projectNotificationsRemoveUndoFlagTitle: {
        "id": "personal-settings-notifications-config-table.project-notifications-config.project-notifications-config-table.project-notifications-remove-button.project-notifications-remove-undo-flag-title",
        "defaultMessage": "Custom notifications removed.\nYou'll still receive default notifications for {projectName}."
    },
    projectNotificationsRemoveUndoFlagActionNonFinal: {
        "id": "personal-settings-notifications-config-table.project-notifications-config.project-notifications-config-table.project-notifications-remove-button.project-notifications-remove-undo-flag-action-non-final",
        "defaultMessage": "Undo"
    }
});

});




parcelRegister("8DBQC", function(module, exports) {

$parcel$export(module.exports, "NotificationPreferencesOptions", () => $20727fc1d408d9b6$export$26e685c6b2b3244e);

var $cChVI = parcelRequire("cChVI");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $ei65k = parcelRequire("ei65k");

var $7iJGJ = parcelRequire("7iJGJ");

var $gi6aq = parcelRequire("gi6aq");

var $3LGU6 = parcelRequire("3LGU6");

var $4aN0x = parcelRequire("4aN0x");

var $55i55 = parcelRequire("55i55");

var $lTuLD = parcelRequire("lTuLD");
const $20727fc1d408d9b6$export$26e685c6b2b3244e = ({ emailEnabledFragment: emailEnabledFragment })=>{
    const data = (0, $8Uumt.useFragment)((0, $cChVI.default), emailEnabledFragment);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $20727fc1d408d9b6$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $20727fc1d408d9b6$var$headerWrapperStyles,
            data.isEmailNotificationEnabled ? $20727fc1d408d9b6$var$enabledHeaderWrapperStyles : undefined
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7iJGJ.EmailEnabledPreferenceField), {
        emailEnabledFragment: data
    })), data.isEmailNotificationEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        testId: "personal-settings-preference-fields.ui.notification-preferences-options-wrapper.box",
        xcss: [
            $20727fc1d408d9b6$var$contentWrapperStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $20727fc1d408d9b6$var$preferenceRowStyles
    }, formatMessage((0, $lTuLD.default).wrapperNote)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $20727fc1d408d9b6$var$preferenceRowStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ei65k.NotifyWhenRoleIsAssignee), {
        assigneeRolePreferenceFragment: data
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $20727fc1d408d9b6$var$preferenceRowStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $55i55.NotifyWhenRoleIsReporter), {
        reporterRolePreferenceFragment: data
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $20727fc1d408d9b6$var$preferenceRowStyles,
            $20727fc1d408d9b6$var$preferenceRowLastStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4aN0x.NotifyOwnChangesPreferenceField), {
        notifyOwnChangesEnabledFragment: data
    }))) : null), data.isEmailNotificationEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gi6aq.GroupNotificationEmailsWrapper), {
        groupNotificationEmailsFragment: data
    }) : null, data.isEmailNotificationEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $20727fc1d408d9b6$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $20727fc1d408d9b6$var$headerWrapperStyles,
            $20727fc1d408d9b6$var$headerTextStyles,
            $20727fc1d408d9b6$var$emailFormatterWrapperStyles,
            $20727fc1d408d9b6$var$enabledHeaderWrapperStyles
        ]
    }, formatMessage((0, $lTuLD.default).emailFormatHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        testId: "personal-settings-preference-fields.ui.notification-preferences-options-wrapper.box-email-format",
        xcss: [
            $20727fc1d408d9b6$var$headerWrapperStyles,
            $20727fc1d408d9b6$var$contentWrapperStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $20727fc1d408d9b6$var$preferenceRowStyles
    }, formatMessage((0, $lTuLD.default).emailFormatNote)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3LGU6.default), {
        mimeTypeFragment: data
    }))) : null);
};
const $20727fc1d408d9b6$var$containerStyles = (0, $8CUq3.xcss)({
    boxSizing: 'border-box',
    marginTop: 'space.100',
    borderRadius: 'border.radius.075'
});
const $20727fc1d408d9b6$var$headerWrapperStyles = (0, $8CUq3.xcss)({
    borderWidth: 'border.width',
    borderStyle: 'solid',
    borderColor: 'color.border',
    borderRadius: 'border.radius.100',
    paddingRight: 'space.150',
    paddingLeft: 'space.200',
    paddingTop: 'space.100',
    paddingBottom: 'space.100'
});
const $20727fc1d408d9b6$var$headerTextStyles = (0, $8CUq3.xcss)({
    color: 'color.text',
    fontWeight: "var(--ds-font-weight-medium, 500)"
});
const $20727fc1d408d9b6$var$enabledHeaderWrapperStyles = (0, $8CUq3.xcss)({
    borderBottomLeftRadius: '0px',
    borderBottomRightRadius: '0px',
    backgroundColor: 'elevation.surface.sunken'
});
const $20727fc1d408d9b6$var$contentWrapperStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'elevation.surface',
    borderWidth: 'border.width',
    borderStyle: 'solid',
    borderColor: 'color.border',
    borderRadius: 'border.radius.100',
    borderTop: 'none',
    borderTopLeftRadius: '0px',
    borderTopRightRadius: '0px',
    paddingRight: 'space.200',
    paddingLeft: 'space.200',
    paddingTop: 'space.150',
    paddingBottom: 'space.150'
});
const $20727fc1d408d9b6$var$preferenceRowStyles = (0, $8CUq3.xcss)({
    marginBottom: 'space.100'
});
const $20727fc1d408d9b6$var$emailFormatterWrapperStyles = (0, $8CUq3.xcss)({
    paddingTop: 'space.150',
    paddingBottom: 'space.150'
});
const $20727fc1d408d9b6$var$preferenceRowLastStyles = (0, $8CUq3.xcss)({
    marginBottom: 'space.0'
});

});
parcelRegister("cChVI", function(module, exports) {

$parcel$export(module.exports, "default", () => $cdfafdbf5e4f548e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<90b77166c7728825a42128815fd11158>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $cdfafdbf5e4f548e$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "notificationPreferencesOptionsWrapper_personalSettingsPreferenceFields_NotificationPreferencesOptions",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "isEmailNotificationEnabled"
        },
        {
            "kind": "FragmentSpread",
            "name": "emailEnabled_personalSettingsPreferenceFields_EmailEnabledPreferenceField"
        },
        {
            "kind": "FragmentSpread",
            "name": "assigneeRole_personalSettingsPreferenceFields_NotifyWhenRoleIsAssignee"
        },
        {
            "kind": "FragmentSpread",
            "name": "reporterRole_personalSettingsPreferenceFields_NotifyWhenRoleIsReporter"
        },
        {
            "kind": "FragmentSpread",
            "name": "notifyOwnChanges_personalSettingsPreferenceFields_NotifyOwnChangesPreferenceField"
        },
        {
            "kind": "FragmentSpread",
            "name": "groupNotificationEmailsWrapper_personalSettingsPreferenceFields"
        },
        {
            "kind": "FragmentSpread",
            "name": "mimeType_personalSettingsPreferenceFields_MimeTypePreferenceField"
        }
    ],
    "type": "JiraNotificationOptions"
};
$cdfafdbf5e4f548e$var$node.hash = "ef652be75b6f5f833184a5938356d9dc";
var $cdfafdbf5e4f548e$export$2e2bcd8739ae039 = $cdfafdbf5e4f548e$var$node;

});

parcelRegister("ei65k", function(module, exports) {

$parcel$export(module.exports, "NotifyWhenRoleIsAssignee", () => $22c8524b50ac084d$export$3fe48b03aaf1509d);

var $cxB3a = parcelRequire("cxB3a");

var $4YY43 = parcelRequire("4YY43");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $2NMNM = parcelRequire("2NMNM");

var $kkJfY = parcelRequire("kkJfY");

var $2x3Cb = parcelRequire("2x3Cb");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $jcw0u = parcelRequire("jcw0u");

var $koVbs = parcelRequire("koVbs");

var $9InRy = parcelRequire("9InRy");

var $8zOmE = parcelRequire("8zOmE");

var $koeKL = parcelRequire("koeKL");

var $fEfww = parcelRequire("fEfww");
const $22c8524b50ac084d$export$3fe48b03aaf1509d = ({ assigneeRolePreferenceFragment: assigneeRolePreferenceFragment })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const cloudId = (0, $koeKL.useCloudId)();
    const { showErrorFlag: showErrorFlag } = (0, $9InRy.useShowErrorFlag)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const data = (0, $8Uumt.useFragment)((0, $4YY43.default), assigneeRolePreferenceFragment);
    const [commit] = (0, $8Uumt.useMutation)((0, $cxB3a.default));
    const handleOnChange = (option)=>{
        if (option) commit({
            variables: {
                cloudId: cloudId,
                input: {
                    notifyWhenRoleAssigneeEnabled: option.currentTarget.checked
                }
            },
            optimisticResponse: {
                jira: {
                    updateGlobalNotificationOptions: {
                        success: true,
                        errors: [],
                        options: {
                            id: data.id,
                            notifyWhenRoleAssigneeEnabled: option.currentTarget.checked
                        }
                    }
                }
            },
            onError: (error)=>{
                showErrorFlag();
                (0, $jcw0u.default)({
                    meta: {
                        id: 'mutateNotifyWhenRoleAssigneeEnabled',
                        packageName: 'jiraPersonalSettingsPreferenceFields',
                        teamName: 'jira-notifications-platform'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            },
            onCompleted: (response)=>{
                const errors = response?.jira?.updateGlobalNotificationOptions?.errors;
                if (errors && errors?.length > 0) {
                    showErrorFlag();
                    errors.forEach((error)=>{
                        (0, $jcw0u.default)({
                            meta: {
                                id: 'mutateNotifyWhenRoleAssigneeEnabledPreferenceCompletedError',
                                packageName: 'jiraPersonalSettingsPreferenceFields',
                                teamName: 'jira-notifications-platform'
                            },
                            error: new Error(error?.message || 'Unknown Error'),
                            sendToPrivacyUnsafeSplunk: true
                        });
                    });
                } else (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'mutateNotifyWhenRoleAssigneeEnabledPreference success');
            }
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2x3Cb.Label), {
        htmlFor: "notify-when-role-assignee-enabled-checkbox"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kkJfY.default), {
        id: "notify-when-role-assignee-enabled-checkbox",
        isChecked: !!data.notifyWhenRoleAssigneeEnabled,
        onChange: handleOnChange,
        testId: "personal-settings-preference-fields.common.ui.assignee-role.checkbox"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingInlineStart: "space.100",
        testId: "personal-settings-preference-fields.common.ui.assignee-role.toggle",
        xcss: $22c8524b50ac084d$var$labelStyles
    }, formatMessage((0, $fEfww.default).checkboxLabel))));
};
const $22c8524b50ac084d$var$labelStyles = (0, $8CUq3.xcss)({
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    marginRight: 'space.100'
});

});
parcelRegister("cxB3a", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddcc26ce5734b0b1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5926e2673028e43d3bf197887fd7fc06>>
 * @relayHash b1117842594715ac212169b79eb442d9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ace14734dad9021f1798d9022d653043461eb5e0d46cb8000a4e520aa0fa9879
const $ddcc26ce5734b0b1$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "assigneeRole_personalSettingsPreferenceFields_NotifyWhenRoleIsAssigneeFieldMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateNotificationOptionsPayload",
                            "kind": "LinkedField",
                            "name": "updateGlobalNotificationOptions",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraNotificationOptions",
                                    "kind": "LinkedField",
                                    "name": "options",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "assigneeRole_personalSettingsPreferenceFields_NotifyWhenRoleIsAssignee"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "assigneeRole_personalSettingsPreferenceFields_NotifyWhenRoleIsAssigneeFieldMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateNotificationOptionsPayload",
                            "kind": "LinkedField",
                            "name": "updateGlobalNotificationOptions",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraNotificationOptions",
                                    "kind": "LinkedField",
                                    "name": "options",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "notifyWhenRoleAssigneeEnabled"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "ace14734dad9021f1798d9022d653043461eb5e0d46cb8000a4e520aa0fa9879",
            "metadata": {},
            "name": "assigneeRole_personalSettingsPreferenceFields_NotifyWhenRoleIsAssigneeFieldMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$ddcc26ce5734b0b1$var$node.hash = "d62f697263af97ce9f06d3b92aeacea7";
var $ddcc26ce5734b0b1$export$2e2bcd8739ae039 = $ddcc26ce5734b0b1$var$node;

});

parcelRegister("4YY43", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a621900fa073b07$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<91da30109ed390efecd21f0a6443e91b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5a621900fa073b07$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "assigneeRole_personalSettingsPreferenceFields_NotifyWhenRoleIsAssignee",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        },
        {
            "kind": "ScalarField",
            "name": "notifyWhenRoleAssigneeEnabled"
        }
    ],
    "type": "JiraNotificationOptions"
};
$5a621900fa073b07$var$node.hash = "9f7680926b28a65e720c5553ad6818fb";
var $5a621900fa073b07$export$2e2bcd8739ae039 = $5a621900fa073b07$var$node;

});

parcelRegister("fEfww", function(module, exports) {

$parcel$export(module.exports, "default", () => $d28e3cc553039997$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d28e3cc553039997$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    checkboxLabel: {
        "id": "personal-settings-preference-fields.common.assignee-role.checkbox-label",
        "defaultMessage": "You're the assignee"
    }
});

});


parcelRegister("7iJGJ", function(module, exports) {

$parcel$export(module.exports, "EmailEnabledPreferenceField", () => $bb4f145b4a9ab5e9$export$102cc8ead7c8767d);

var $1y8mU = parcelRequire("1y8mU");

var $40Wjy = parcelRequire("40Wjy");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $2NMNM = parcelRequire("2NMNM");

var $2x3Cb = parcelRequire("2x3Cb");

var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $dTlW6 = parcelRequire("dTlW6");

var $jcw0u = parcelRequire("jcw0u");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $9InRy = parcelRequire("9InRy");

var $8zOmE = parcelRequire("8zOmE");

var $koeKL = parcelRequire("koeKL");

var $16NLf = parcelRequire("16NLf");
const $bb4f145b4a9ab5e9$export$102cc8ead7c8767d = ({ emailEnabledFragment: emailEnabledFragment })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const cloudId = (0, $koeKL.useCloudId)();
    const { showErrorFlag: showErrorFlag } = (0, $9InRy.useShowErrorFlag)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const data = (0, $8Uumt.useFragment)((0, $40Wjy.default), emailEnabledFragment);
    const [commit] = (0, $8Uumt.useMutation)((0, $1y8mU.default));
    const handleOnChange = (0, $5uXOq.useCallback)((option)=>{
        if (option) commit({
            variables: {
                cloudId: cloudId,
                input: {
                    isEmailNotificationEnabled: option.currentTarget.checked
                }
            },
            optimisticResponse: {
                jira: {
                    updateGlobalNotificationOptions: {
                        success: true,
                        errors: [],
                        options: {
                            id: data.id,
                            isEmailNotificationEnabled: option.currentTarget.checked
                        }
                    }
                }
            },
            onError: (error)=>{
                showErrorFlag();
                (0, $jcw0u.default)({
                    meta: {
                        id: 'mutateEmailEnabledPreference',
                        packageName: 'jiraPersonalSettingsPreferenceFields',
                        teamName: 'jira-notifications-platform'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            },
            onCompleted: (response)=>{
                const errors = response?.jira?.updateGlobalNotificationOptions?.errors;
                if (errors && errors?.length > 0) {
                    showErrorFlag();
                    errors.forEach((error)=>{
                        (0, $jcw0u.default)({
                            meta: {
                                id: 'mutateEmailEnabledPreferenceCompletedError',
                                packageName: 'jiraPersonalSettingsPreferenceFields',
                                teamName: 'jira-notifications-platform'
                            },
                            error: new Error(error?.message || 'Unknown Error'),
                            sendToPrivacyUnsafeSplunk: true
                        });
                    });
                } else (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'mutateEmailEnabledPreference success');
            }
        });
    }, [
        commit,
        cloudId,
        data.id,
        showErrorFlag,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        spread: "space-between",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2x3Cb.Label), {
        htmlFor: "email-enabled"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center",
        xcss: $bb4f145b4a9ab5e9$var$labelHolderStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        testId: "personal-settings-preference-fields.common.ui.email-enabled.toggle",
        xcss: $bb4f145b4a9ab5e9$var$labelStyles,
        alignBlock: "center"
    }, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $16NLf.default).emailEnabledToggleLabelIssueTermRefresh : (0, $16NLf.default).emailEnabledToggleLabel)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dTlW6.default), {
        id: "email-enabled",
        isChecked: !!data.isEmailNotificationEnabled,
        onChange: handleOnChange
    }));
};
const $bb4f145b4a9ab5e9$var$labelHolderStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.050',
    gap: 'space.100'
});
const $bb4f145b4a9ab5e9$var$labelStyles = (0, $8CUq3.xcss)({
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    color: 'color.text'
});

});
parcelRegister("1y8mU", function(module, exports) {

$parcel$export(module.exports, "default", () => $941fa1ec33f632fe$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7ee7466519c7d35c59f819e29f670159>>
 * @relayHash 6d22545c12674c5f64ce480bf0e39655
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e6448dd5f450d68e88b5308f3e6569a4736e837c8cb8b869311113f2e47d7740
const $941fa1ec33f632fe$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "emailEnabled_personalSettingsPreferenceFields_EmailEnabledPreferenceFieldMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateNotificationOptionsPayload",
                            "kind": "LinkedField",
                            "name": "updateGlobalNotificationOptions",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraNotificationOptions",
                                    "kind": "LinkedField",
                                    "name": "options",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "emailEnabled_personalSettingsPreferenceFields_EmailEnabledPreferenceField"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "emailEnabled_personalSettingsPreferenceFields_EmailEnabledPreferenceFieldMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateNotificationOptionsPayload",
                            "kind": "LinkedField",
                            "name": "updateGlobalNotificationOptions",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraNotificationOptions",
                                    "kind": "LinkedField",
                                    "name": "options",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isEmailNotificationEnabled"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "e6448dd5f450d68e88b5308f3e6569a4736e837c8cb8b869311113f2e47d7740",
            "metadata": {},
            "name": "emailEnabled_personalSettingsPreferenceFields_EmailEnabledPreferenceFieldMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$941fa1ec33f632fe$var$node.hash = "852b87f7a5afd54294d7dfeb99fbd827";
var $941fa1ec33f632fe$export$2e2bcd8739ae039 = $941fa1ec33f632fe$var$node;

});

parcelRegister("40Wjy", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd6ecc0b5eb3f3f6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ceb6293d64bd098a700ed60fa2dc4f2a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $fd6ecc0b5eb3f3f6$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "emailEnabled_personalSettingsPreferenceFields_EmailEnabledPreferenceField",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        },
        {
            "kind": "ScalarField",
            "name": "isEmailNotificationEnabled"
        }
    ],
    "type": "JiraNotificationOptions"
};
$fd6ecc0b5eb3f3f6$var$node.hash = "9d23ef43bd914d6b881dc6b1dadf6bdf";
var $fd6ecc0b5eb3f3f6$export$2e2bcd8739ae039 = $fd6ecc0b5eb3f3f6$var$node;

});

parcelRegister("dTlW6", function(module, exports) {

$parcel$export(module.exports, "default", () => $3db77843cf29c460$export$2e2bcd8739ae039);
/* toggle.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $6QvkM = parcelRequire("6QvkM");

var $eGmKJ = parcelRequire("eGmKJ");

var $9KnKW = parcelRequire("9KnKW");

var $7fA4P = parcelRequire("7fA4P");

var $aFYTH = parcelRequire("aFYTH");

var $VSDnB = parcelRequire("VSDnB");

var $lahQ6 = parcelRequire("lahQ6");
const $3db77843cf29c460$var$basicStyles = null;
const $3db77843cf29c460$var$borderStyles = null;
const $3db77843cf29c460$var$iconStyles = null;
const $3db77843cf29c460$var$sizeStyles = {
    regular: "_2rkopxbi _4t3ipxbi _1bsbxy5q _kfgtutpp _1mp41crf _p9c41fbe",
    large: "_2rkov47k _4t3iv47k _1bsb1jfw _kfgtpxbi _1mp47vkz _p9c4w12q"
};
const $3db77843cf29c460$var$noop = (0, $eGmKJ.default);
const $3db77843cf29c460$var$analyticsAttributes = {
    componentName: 'toggle',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $3db77843cf29c460$var$iconSizeMap = {
    regular: 'small',
    large: 'medium'
}; /**
    * __Toggle__
    *
    * A toggle is used to view or switch between enabled or disabled states.
    *
    * - [Examples](https://atlassian.design/components/toggle/examples)
    * - [Code](https://atlassian.design/components/toggle/code)
    * - [Usage](https://atlassian.design/components/toggle/usage)
    */ 
const $3db77843cf29c460$var$Toggle = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { defaultChecked: defaultChecked = false, isDisabled: isDisabled = false, onBlur: providedOnBlur = $3db77843cf29c460$var$noop, onChange: providedChange = $3db77843cf29c460$var$noop, onFocus: providedFocus = $3db77843cf29c460$var$noop, size: size = 'regular', name: name = '', value: value = '', isChecked: isChecked, analyticsContext: analyticsContext, id: id, testId: testId, label: label, descriptionId: descriptionId } = props;
    const isControlled = typeof isChecked === 'undefined';
    const [checked, setChecked] = (0, $5uXOq.useState)(defaultChecked);
    const [isKeyboardUsed, setIsKeyboardUsed] = (0, $5uXOq.useState)(true);
    const wrapperRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        if (id && wrapperRef.current && wrapperRef.current.parentElement) {
            /*
      	DSP-21524 Handling the click on <label> that is linked via "for" attribute.
      	By default click on the label fires absolutely same onclick event as click on the input element.
      	To differentiate keyboard click from mouse we need this additional listener.
      */ const linkedLabel = wrapperRef.current.parentElement.querySelector(`label[for="${id}"]`);
            if (linkedLabel) {
                const unbind = (0, $cBeZP.bindAll)(linkedLabel, [
                    {
                        type: 'click',
                        listener: (event)=>{
                            setIsKeyboardUsed(false);
                            if (event?.detail > 1) /*
              DSP-21524 double or triple click on label initiating the text selection for label text and adds additional step to tab order.
              So here we set the isKeyboardUsed to true, to display focus ring on next Tab press
              */ setIsKeyboardUsed(true);
                        }
                    }
                ]);
                return unbind;
            }
        }
    }, [
        id,
        wrapperRef,
        isKeyboardUsed
    ]);
    const handleBlur = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (!isKeyboardUsed) setIsKeyboardUsed(true);
            providedOnBlur(event, analyticsEvent);
        },
        action: 'blur',
        analyticsData: analyticsContext,
        ...$3db77843cf29c460$var$analyticsAttributes
    });
    const handleFocus = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: providedFocus,
        action: 'focus',
        analyticsData: analyticsContext,
        ...$3db77843cf29c460$var$analyticsAttributes
    });
    const handleChange = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (isControlled) setChecked((checked)=>!checked);
            return providedChange(event, analyticsEvent);
        },
        action: 'change',
        analyticsData: analyticsContext,
        ...$3db77843cf29c460$var$analyticsAttributes
    });
    const onLabelKeyDown = (event)=>{
        if ([
            ' ',
            'Tab',
            'Space'
        ].includes(event.key)) setIsKeyboardUsed(true);
    };
    const shouldChecked = isControlled ? checked : isChecked;
    const controlProps = {
        'data-checked': shouldChecked ? shouldChecked : undefined,
        'data-disabled': isDisabled ? isDisabled : undefined,
        'data-size': size,
        'data-testid': testId ? testId : undefined,
        // DSP-21524 Because label gets focus ring via focus-within and focus-within also triggers by mouse click we have to manually control the ring appearance.
        onKeyDown: onLabelKeyDown,
        onMouseDown: ()=>{
            setIsKeyboardUsed(false);
        }
    };
    const legacyIconSize = $3db77843cf29c460$var$iconSizeMap[size];
    const labelId = (0, $9KnKW.useId)();
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("label", {
        ...controlProps,
        ref: wrapperRef,
        className: (0, $bwpsq.default)([
            "_v564kete _1h6d3acm _1dqonqa1 _189eyh40 _1e0c1o8l _vchh18uv _kqswh2mm _1y1m1ntv _bfhk76s1 _syaz5w2r _6rthv77o _1pfhv77o _12l2v77o _ahbqv77o _85i5v77o _1q51v77o _y4tiv77o _bozgv77o _1i2uidpf _1i3tidpf _se28idpf _3tunidpf _1423idpf _1hrtidpf _1bz2idpf _rqfvidpf _1yc0glyw _onsr1snc _1vgmagmp _1av610yn _1ulhidpf _rfx31q5u _pdykkete _1cs8stnw _1rus5w2r _1kt9b3bt _1fkr1y44 _z5wt1y44 _7dwzglyw _1bki1y1w _1flt1y1w _3xv21y1w _9471g4a2 _ucab5w2r _mqf815t7 _3dj215t7 _1dl915t7 _1div5w2r _1il8kb7n _y54d5w2r _irr353wy _d0altlke _19ja13gf _8muf13gf _1k1q13gf _1plud4ly _1uo853wy _178c1y1w _16rslghj _ogf41r31 _1rtbnqa1 _5gg9t94y",
            isKeyboardUsed && "_jyzf194a _1r4mnqa1 _1t9pyh40",
            size === 'large' && !(0, $VSDnB.fg)('platform-visual-refresh-icons') && "_1n82gktf _19vpgktf",
            $3db77843cf29c460$var$sizeStyles[size]
        ]),
        children: [
            label ? /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                id: labelId,
                hidden: true,
                children: label
            }) : null,
            /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                ref: ref,
                checked: shouldChecked,
                disabled: isDisabled,
                id: id,
                name: name,
                onBlur: handleBlur,
                onChange: handleChange,
                onFocus: handleFocus,
                type: "checkbox",
                value: value,
                "data-testid": testId && `${testId}--input`,
                "aria-labelledby": label ? labelId : undefined,
                "aria-describedby": descriptionId
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lahQ6.default), {
                size: size,
                isHidden: !shouldChecked,
                position: "left",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7fA4P))), {
                    label: "",
                    color: "currentColor",
                    LEGACY_size: legacyIconSize,
                    testId: testId && `${testId}--toggle-check-icon`
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lahQ6.default), {
                size: size,
                isHidden: shouldChecked,
                position: "right",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aFYTH))), {
                    label: "",
                    color: "currentColor",
                    LEGACY_size: legacyIconSize,
                    testId: testId && `${testId}--toggle-cross-icon`
                })
            })
        ]
    });
}));
$3db77843cf29c460$var$Toggle.displayName = 'Toggle';
var $3db77843cf29c460$export$2e2bcd8739ae039 = $3db77843cf29c460$var$Toggle;

});
parcelRegister("7fA4P", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::90a6c328ce4531920c578790d71561aa>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5475eb3f94e0b044$var$_react = $5475eb3f94e0b044$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $5475eb3f94e0b044$var$_checkMark = $5475eb3f94e0b044$var$_interopRequireDefault((parcelRequire("f22iM")));

var $5475eb3f94e0b044$var$_done = $5475eb3f94e0b044$var$_interopRequireDefault((parcelRequire("4DXCl")));
function $5475eb3f94e0b044$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CheckMarkIcon.
 * This component is CheckMarkIcon, with `UNSAFE_fallbackIcon` set to "EditorDoneIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: 📦 @atlaskit/icon/utility/check-mark
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5475eb3f94e0b044$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $5475eb3f94e0b044$var$_react.default.createElement($5475eb3f94e0b044$var$_checkMark.default, Object.assign({
        LEGACY_fallbackIcon: $5475eb3f94e0b044$var$_done.default
    }, props));
$5475eb3f94e0b044$var$CheckMarkIcon.Name = 'CheckMarkIconMigration';
var $5475eb3f94e0b044$var$_default = module.exports.default = $5475eb3f94e0b044$var$CheckMarkIcon;

});
parcelRegister("f22iM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4f681ccdbe722d68d6bd374c0928f0bd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $af18d40ba5b744b4$var$_react = $af18d40ba5b744b4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $af18d40ba5b744b4$var$_baseNew = $af18d40ba5b744b4$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $af18d40ba5b744b4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckMark".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: 📦 @atlaskit/icon/utility/check-mark
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $af18d40ba5b744b4$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $af18d40ba5b744b4$var$_react.default.createElement($af18d40ba5b744b4$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m11.06 3-6.25 7a.75.75 0 0 1-1.15-.037l-2.75-3.5 1.18-.926 2.197 2.796L9.94 2z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$af18d40ba5b744b4$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $af18d40ba5b744b4$var$_default = module.exports.default = $af18d40ba5b744b4$var$CheckMarkIcon;

});

parcelRegister("4DXCl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $36190cbd288fec69$var$_react = $36190cbd288fec69$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $36190cbd288fec69$var$_checkMark = $36190cbd288fec69$var$_interopRequireDefault((parcelRequire("bjo8S")));
function $36190cbd288fec69$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $36190cbd288fec69$var$EditorDoneIcon = (props)=>/*#__PURE__*/ $36190cbd288fec69$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M7.356 10.942a.497.497 0 0 0-.713 0l-.7.701a.5.5 0 0 0-.003.71l3.706 3.707a.5.5 0 0 0 .705.003l7.712-7.712a.493.493 0 0 0-.006-.708l-.7-.7a.504.504 0 0 0-.714 0l-6.286 6.286a.506.506 0 0 1-.713 0z"/></svg>`
    }, props, {
        newIcon: $36190cbd288fec69$var$_checkMark.default
    }));
$36190cbd288fec69$var$EditorDoneIcon.displayName = 'EditorDoneIcon';
var $36190cbd288fec69$var$_default = module.exports.default = $36190cbd288fec69$var$EditorDoneIcon;

});
parcelRegister("bjo8S", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a3e71f4112aeb66b16fbd284cc49bbc6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $83c43234bc70a485$var$_react = $83c43234bc70a485$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $83c43234bc70a485$var$_baseNew = $83c43234bc70a485$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $83c43234bc70a485$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $83c43234bc70a485$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $83c43234bc70a485$var$_react.default.createElement($83c43234bc70a485$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m15.076 3.23-8.75 10.5a.75.75 0 0 1-1.159-.008l-4.25-5.25 1.166-.944 3.675 4.54 8.166-9.798z" clip-rule="evenodd"/>`
    }, props));
$83c43234bc70a485$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $83c43234bc70a485$var$_default = module.exports.default = $83c43234bc70a485$var$CheckMarkIcon;

});



parcelRegister("lahQ6", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca1cdaa1eb34599d$export$2e2bcd8739ae039);
/* icon-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3JT92 = parcelRequire("3JT92");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");
const $ca1cdaa1eb34599d$var$styles = {
    iconContainer: "_v5641hrg _1e0c116y _4cvr1h6o _1bah1h6o _kqswstnw _152tv77o",
    iconContainerRegular: "_1bsb7vkz _4t3i7vkz",
    iconContainerLarge: "_1bsbgktf _4t3igktf",
    hidden: "_tzy4idpf",
    left: "_1e021l7b",
    right: "_rjxp1l7b"
};
/**
 * __Icon container__
 *
 * Positions a toggle's check and close icons.
 */ const $ca1cdaa1eb34599d$var$IconContainer = ({ children: children, size: size, isHidden: isHidden, position: position })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        as: "span",
        xcss: (0, $3JT92.cx)($ca1cdaa1eb34599d$var$styles.iconContainer, isHidden && (0, $VSDnB.fg)('platform-visual-refresh-icons') && $ca1cdaa1eb34599d$var$styles.hidden, size === 'regular' && $ca1cdaa1eb34599d$var$styles.iconContainerRegular, size === 'large' && $ca1cdaa1eb34599d$var$styles.iconContainerLarge, position === 'left' && $ca1cdaa1eb34599d$var$styles.left, position === 'right' && $ca1cdaa1eb34599d$var$styles.right),
        children: children
    });
};
var $ca1cdaa1eb34599d$export$2e2bcd8739ae039 = $ca1cdaa1eb34599d$var$IconContainer;

});


parcelRegister("16NLf", function(module, exports) {

$parcel$export(module.exports, "default", () => $0af6a33a1319d6e3$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0af6a33a1319d6e3$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    toggleLabel: {
        "id": "personal-settings-preference-fields.common.email-enabled.toggle-label",
        "defaultMessage": "Allow emails for issue activity"
    },
    emailEnabledToggleLabel: {
        "id": "personal-settings-preference-fields.common.email-enabled.email-enabled-toggle-label",
        "defaultMessage": "Send me emails for issue activity"
    },
    toggleLabelIssueTermRefresh: {
        "id": "personal-settings-preference-fields.common.email-enabled.toggle-label-issue-term-refresh",
        "defaultMessage": "Allow emails for work item activity"
    },
    emailEnabledToggleLabelIssueTermRefresh: {
        "id": "personal-settings-preference-fields.common.email-enabled.email-enabled-toggle-label-issue-term-refresh",
        "defaultMessage": "Send me emails for work item activity"
    }
});

});


parcelRegister("gi6aq", function(module, exports) {

$parcel$export(module.exports, "GroupNotificationEmailsWrapper", () => $34bb1b180957fa15$export$1dffc6e9c3bbd126);

var $kLJA2 = parcelRequire("kLJA2");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $e8TEn = parcelRequire("e8TEn");

var $5rZRJ = parcelRequire("5rZRJ");

var $dt9Hd = parcelRequire("dt9Hd");
const $34bb1b180957fa15$export$1dffc6e9c3bbd126 = ({ groupNotificationEmailsFragment: groupNotificationEmailsFragment })=>{
    const data = (0, $8Uumt.useFragment)((0, $kLJA2.default), groupNotificationEmailsFragment);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $34bb1b180957fa15$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $34bb1b180957fa15$var$headerWrapperStyles,
            data.batchWindow === 'NO_BATCHING' ? undefined : $34bb1b180957fa15$var$enabledHeaderWrapperStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5rZRJ.EnableBatchingPreferenceField), {
        enableBatchingFragment: data
    })), data.batchWindow === 'NO_BATCHING' ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        testId: "personal-settings-preference-fields.common.ui.group-notification-emails-wrapper.box",
        xcss: $34bb1b180957fa15$var$contentWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $34bb1b180957fa15$var$preferenceRowStyles,
        id: "select-batch-notification-duration-label"
    }, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $dt9Hd.default).wrapperNoteIssueTermRefresh : (0, $dt9Hd.default).wrapperNote)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e8TEn.BatchWindowPreferenceField), {
        batchWindowFragment: data
    })));
};
const $34bb1b180957fa15$var$containerStyles = (0, $8CUq3.xcss)({
    boxSizing: 'border-box',
    marginTop: 'space.100',
    borderRadius: 'border.radius.075'
});
const $34bb1b180957fa15$var$headerWrapperStyles = (0, $8CUq3.xcss)({
    borderWidth: 'border.width',
    borderStyle: 'solid',
    borderColor: 'color.border',
    borderRadius: 'border.radius.100',
    paddingRight: 'space.150',
    paddingLeft: 'space.200',
    paddingTop: 'space.050',
    paddingBottom: 'space.050'
});
const $34bb1b180957fa15$var$enabledHeaderWrapperStyles = (0, $8CUq3.xcss)({
    borderBottomLeftRadius: '0px',
    borderBottomRightRadius: '0px',
    backgroundColor: 'elevation.surface.sunken'
});
const $34bb1b180957fa15$var$contentWrapperStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'elevation.surface',
    borderWidth: 'border.width',
    borderStyle: 'solid',
    borderColor: 'color.border',
    borderRadius: 'border.radius.100',
    borderTop: 'none',
    borderTopLeftRadius: '0px',
    borderTopRightRadius: '0px',
    paddingRight: 'space.200',
    paddingLeft: 'space.200',
    paddingTop: 'space.150',
    paddingBottom: 'space.150'
});
const $34bb1b180957fa15$var$preferenceRowStyles = (0, $8CUq3.xcss)({
    marginBottom: 'space.100'
});

});
parcelRegister("kLJA2", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ae17fad9d3e053d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<77ac735dbc09b1c07f41dc37afe98a16>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3ae17fad9d3e053d$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "groupNotificationEmailsWrapper_personalSettingsPreferenceFields",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "batchWindow"
        },
        {
            "kind": "FragmentSpread",
            "name": "enableBatching_personalSettingsPreferenceFields_EnableBatchingPreferenceField"
        },
        {
            "kind": "FragmentSpread",
            "name": "batchWindow_personalSettingsPreferenceFields_BatchWindowPreferenceField"
        }
    ],
    "type": "JiraNotificationOptions"
};
$3ae17fad9d3e053d$var$node.hash = "ac2b3ff4ea89fc141ba6bef05d683069";
var $3ae17fad9d3e053d$export$2e2bcd8739ae039 = $3ae17fad9d3e053d$var$node;

});

parcelRegister("e8TEn", function(module, exports) {

$parcel$export(module.exports, "BatchWindowPreferenceField", () => $ad03196666e41f1f$export$2d1e6a71e63dacee);

var $02hNH = parcelRequire("02hNH");

var $iuPgR = parcelRequire("iuPgR");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $2NMNM = parcelRequire("2NMNM");

var $jdTq6 = parcelRequire("jdTq6");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $7K5PP = parcelRequire("7K5PP");

var $jcw0u = parcelRequire("jcw0u");

var $koVbs = parcelRequire("koVbs");

var $9InRy = parcelRequire("9InRy");

var $8zOmE = parcelRequire("8zOmE");

var $koeKL = parcelRequire("koeKL");

var $cye6V = parcelRequire("cye6V");
const $ad03196666e41f1f$export$2d1e6a71e63dacee = ({ batchWindowFragment: batchWindowFragment })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const cloudId = (0, $koeKL.useCloudId)();
    const { showErrorFlag: showErrorFlag } = (0, $9InRy.useShowErrorFlag)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const data = (0, $8Uumt.useFragment)((0, $iuPgR.default), batchWindowFragment);
    const [commit] = (0, $8Uumt.useMutation)((0, $02hNH.default));
    const batchWindowOptions = (0, $5uXOq.useMemo)(()=>[
            {
                label: formatMessage((0, $cye6V.default).optionTextDef),
                value: 'DEFAULT_BATCHING'
            },
            {
                label: formatMessage((0, $cye6V.default).optionTextTenMins),
                value: 'TEN_MINUTES'
            },
            {
                label: formatMessage((0, $cye6V.default).optionTextThirtyMins),
                value: 'THIRTY_MINUTES'
            },
            {
                label: formatMessage((0, $cye6V.default).optionTextSixtyMins),
                value: 'ONE_HOUR'
            },
            {
                label: formatMessage((0, $cye6V.default).optionTextOncePerDayAt),
                value: 'ONCE_PER_DAY'
            }
        ], [
        formatMessage
    ]);
    const handleDailyBatchLocalTimeChange = (optionValue)=>{
        commit({
            variables: {
                cloudId: cloudId,
                input: {
                    batchWindow: 'ONCE_PER_DAY',
                    dailyBatchLocalTime: optionValue
                }
            },
            optimisticResponse: {
                jira: {
                    updateGlobalNotificationOptions: {
                        success: true,
                        errors: [],
                        options: {
                            id: data.id,
                            batchWindow: 'ONCE_PER_DAY',
                            dailyBatchLocalTime: optionValue
                        }
                    }
                }
            },
            onError: (error)=>{
                showErrorFlag();
                (0, $jcw0u.default)({
                    meta: {
                        id: 'mutateDailyBatchLocalTimePreference',
                        packageName: 'jiraPersonalSettingsPreferenceFields',
                        teamName: 'jira-notifications-platform'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            },
            onCompleted: (response)=>{
                const errors = response?.jira?.updateGlobalNotificationOptions?.errors;
                if (errors && errors?.length > 0) {
                    showErrorFlag();
                    errors.forEach((error)=>{
                        (0, $jcw0u.default)({
                            meta: {
                                id: 'mutateDailyBatchLocalTimeCompletedError',
                                packageName: 'jiraPersonalSettingsPreferenceFields',
                                teamName: 'jira-notifications-platform'
                            },
                            error: new Error(error?.message || 'Unknown Error'),
                            sendToPrivacyUnsafeSplunk: true
                        });
                    });
                } else {
                    (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'dailyBatchLocalTime changed', 'dailyBatchLocalTime', {
                        value: optionValue
                    });
                    (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'mutateDailyBatchLocalTimePreference success', {
                        value: optionValue
                    });
                }
            }
        });
    };
    const selectedBatchWindowOption = batchWindowOptions.find((option)=>option.value === data.batchWindow);
    const selectedDailyBatchLocalTimeOption = data.dailyBatchLocalTime ? data.dailyBatchLocalTime : '09:00';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        testId: "personal-settings-preference-fields.common.ui.batch-window.select"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $ad03196666e41f1f$var$selectWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
        label: formatMessage((0, $cye6V.default).selectBatchWindowLabel),
        labelId: "select-batch-notification-duration-label",
        inputId: "batch-window",
        options: batchWindowOptions,
        value: selectedBatchWindowOption,
        onChange: (option)=>{
            if (option) commit({
                variables: {
                    cloudId: cloudId,
                    input: {
                        batchWindow: option.value,
                        dailyBatchLocalTime: option.value === 'ONCE_PER_DAY' ? '09:00' : null
                    }
                },
                optimisticResponse: {
                    jira: {
                        updateGlobalNotificationOptions: {
                            success: true,
                            errors: [],
                            options: {
                                id: data.id,
                                batchWindow: option.value,
                                dailyBatchLocalTime: option.value === 'ONCE_PER_DAY' ? '09:00' : null
                            }
                        }
                    }
                },
                onError: (error)=>{
                    showErrorFlag();
                    (0, $jcw0u.default)({
                        meta: {
                            id: 'mutateBatchWindowPreference',
                            packageName: 'jiraPersonalSettingsPreferenceFields',
                            teamName: 'jira-notifications-platform'
                        },
                        error: error,
                        sendToPrivacyUnsafeSplunk: true
                    });
                },
                onCompleted: (response)=>{
                    const errors = response?.jira?.updateGlobalNotificationOptions?.errors;
                    if (errors && errors?.length > 0) {
                        showErrorFlag();
                        errors.forEach((error)=>{
                            (0, $jcw0u.default)({
                                meta: {
                                    id: 'mutateBatchWindowPreferenceCompletedError',
                                    packageName: 'jiraPersonalSettingsPreferenceFields',
                                    teamName: 'jira-notifications-platform'
                                },
                                error: new Error(error?.message || 'Unknown Error'),
                                sendToPrivacyUnsafeSplunk: true
                            });
                        });
                    } else {
                        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'batchWindow changed', 'batchWindow', {
                            value: option.value
                        });
                        (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'mutateBatchWindowPreference success', {
                            value: option.value
                        });
                    }
                }
            });
        }
    })), data.batchWindow === 'ONCE_PER_DAY' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $ad03196666e41f1f$var$selectWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jdTq6.default), {
        label: formatMessage((0, $cye6V.default).timePickerLabel),
        timeIsEditable: true,
        value: selectedDailyBatchLocalTimeOption,
        selectProps: {
            isClearable: false
        },
        onChange: handleDailyBatchLocalTimeChange,
        id: "once-per-day-scheduling-time"
    }))));
};
const $ad03196666e41f1f$var$selectWrapperStyles = (0, $8CUq3.xcss)({
    maxWidth: '260px',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    marginRight: 'space.100'
});

});
parcelRegister("02hNH", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0a21d22e408b74d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9f15763135896cfb2d51406dd84b2a26>>
 * @relayHash 9d0533890762d730a9350f01835deb68
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b16f23a7b1e6ccac95bdbff4b38bfaf94ee7be8cd69983257c0caf95ac7f0b60
const $a0a21d22e408b74d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "batchWindow_personalSettingsPreferenceFields_BatchWindowPreferenceFieldMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateNotificationOptionsPayload",
                            "kind": "LinkedField",
                            "name": "updateGlobalNotificationOptions",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraNotificationOptions",
                                    "kind": "LinkedField",
                                    "name": "options",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "batchWindow_personalSettingsPreferenceFields_BatchWindowPreferenceField"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "batchWindow_personalSettingsPreferenceFields_BatchWindowPreferenceFieldMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateNotificationOptionsPayload",
                            "kind": "LinkedField",
                            "name": "updateGlobalNotificationOptions",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraNotificationOptions",
                                    "kind": "LinkedField",
                                    "name": "options",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "dailyBatchLocalTime"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "batchWindow"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "b16f23a7b1e6ccac95bdbff4b38bfaf94ee7be8cd69983257c0caf95ac7f0b60",
            "metadata": {},
            "name": "batchWindow_personalSettingsPreferenceFields_BatchWindowPreferenceFieldMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$a0a21d22e408b74d$var$node.hash = "86d3b2d15625f4fa9ccb4a97247580ee";
var $a0a21d22e408b74d$export$2e2bcd8739ae039 = $a0a21d22e408b74d$var$node;

});

parcelRegister("iuPgR", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3e198923ace6977$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<de471f5ff0a4da4aae65ec94e49f080d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b3e198923ace6977$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "batchWindow_personalSettingsPreferenceFields_BatchWindowPreferenceField",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "dailyBatchLocalTime"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "batchWindow"
            },
            "action": "THROW",
            "path": "batchWindow"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        }
    ],
    "type": "JiraNotificationOptions"
};
$b3e198923ace6977$var$node.hash = "f8fbf1d8be26a73eb8fba69be6c7c617";
var $b3e198923ace6977$export$2e2bcd8739ae039 = $b3e198923ace6977$var$node;

});

parcelRegister("jdTq6", function(module, exports) {

$parcel$export(module.exports, "default", () => $420c0ce16dc216b4$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $k7m40 = parcelRequire("k7m40");
var $jovBr = parcelRequire("jovBr");

var $6QvkM = parcelRequire("6QvkM");

var $eGmKJ = parcelRequire("eGmKJ");

var $7qZ1x = parcelRequire("7qZ1x");

var $iOwNT = parcelRequire("iOwNT");
var $7K5PP = parcelRequire("7K5PP");
var $7VXAu = parcelRequire("7VXAu");

var $jHBnA = parcelRequire("jHBnA");

var $imOgG = parcelRequire("imOgG");

var $j537G = parcelRequire("j537G");

var $2ucUe = parcelRequire("2ucUe");

var $dBs4v = parcelRequire("dBs4v");
const $420c0ce16dc216b4$var$packageName = "platform-pkg";
const $420c0ce16dc216b4$var$packageVersion = "0.0.0-use.local";
const $420c0ce16dc216b4$var$menuStyles = {
    /* Need to remove default absolute positioning as that causes issues with position fixed */ position: 'static',
    /* Need to add overflow to the element with max-height, otherwise causes overflow issues in IE11 */ overflowY: 'auto',
    /* React-Popper has already offset the menu so we need to reset the margin, otherwise the offset value is doubled */ margin: 0
};
const $420c0ce16dc216b4$var$analyticsAttributes = {
    componentName: 'timePicker',
    packageName: $420c0ce16dc216b4$var$packageName,
    packageVersion: $420c0ce16dc216b4$var$packageVersion
};
/**
 * __Time picker__
 *
 * A time picker allows the user to select a specific time.
 *
 * - [Examples](https://atlassian.design/components/datetime-picker/time-picker/examples)
 * - [Code](https://atlassian.design/components/datetime-picker/time-picker/code)
 * - [Usage](https://atlassian.design/components/datetime-picker/time-picker/usage)
 */ const $420c0ce16dc216b4$var$TimePicker = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ 'aria-describedby': ariaDescribedBy, appearance: appearance = 'default', autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'clear timepicker', defaultIsOpen: defaultIsOpen = false, defaultValue: defaultValue = '', formatDisplayLabel: formatDisplayLabel, hideIcon: hideIcon = false, id: id = '', innerProps: innerProps = {}, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, isOpen: providedIsOpen, label: label = '', locale: locale = 'en-US', name: name = '', onBlur: providedOnBlur = (0, $eGmKJ.default), onChange: providedOnChange = (0, $eGmKJ.default), onFocus: providedOnFocus = (0, $eGmKJ.default), parseInputValue: parseInputValue = (time, _timeFormat)=>(0, $j537G.default)(time), placeholder: placeholder, selectProps: selectProps = {}, spacing: spacing = 'default', testId: testId, timeFormat: timeFormat, timeIsEditable: timeIsEditable = false, times: times = (0, $jHBnA.defaultTimes), value: providedValue }, ref)=>{
    const [containerRef, setContainerRef] = (0, $5uXOq.useState)(null);
    /**
   * When being cleared from the icon the TimePicker is blurred.
   * This variable defines whether the default onMenuOpen or onMenuClose
   * events should behave as normal
   */ const [clearingFromIcon, setClearingFromIcon] = (0, $5uXOq.useState)(false);
    // TODO: Remove isFocused? Does it do anything?
    const [_, setIsFocused] = (0, $5uXOq.useState)(false);
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(defaultIsOpen);
    const [value, setValue] = (0, $5uXOq.useState)(defaultValue);
    // Hack to force update: https://legacy.reactjs.org/docs/hooks-faq.html#is-there-something-like-forceupdate
    const [, forceUpdate] = (0, $5uXOq.useReducer)((x)=>x + 1, 0);
    const providedOnChangeWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: providedOnChange,
        action: 'selectedTime',
        ...$420c0ce16dc216b4$var$analyticsAttributes
    });
    (0, $5uXOq.useEffect)(()=>{
        if (providedValue) setValue(providedValue);
    }, [
        providedValue
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (providedIsOpen) setIsOpen(providedIsOpen);
    }, [
        providedIsOpen
    ]);
    const onChange = (0, $5uXOq.useCallback)((newValue, action)=>{
        const rawValue = newValue ? newValue.value || newValue : '';
        const finalValue = rawValue.toString();
        setValue(finalValue);
        if (action && action.action === 'clear') setClearingFromIcon(true);
        providedOnChangeWithAnalytics(finalValue);
    }, [
        providedOnChangeWithAnalytics
    ]);
    /**
   * Only allow custom times if timeIsEditable prop is true
   */ const onCreateOption = (inputValue)=>{
        if (timeIsEditable) {
            let sanitizedInput;
            try {
                sanitizedInput = parseInputValue(inputValue, timeFormat || (0, $jHBnA.defaultTimeFormat));
            } catch (e) {
                return; // do nothing, the main validation should happen in the form
            }
            const includesSeconds = !!(timeFormat && /[:.]?(s|ss)/.test(timeFormat));
            const formatFormat = includesSeconds ? 'HH:mm:ss' : 'HH:mm';
            const formattedValue = (0, $k7m40.default)(sanitizedInput, formatFormat) || '';
            setValue(formattedValue);
            providedOnChangeWithAnalytics(formattedValue);
        } else providedOnChangeWithAnalytics(inputValue);
    };
    const onMenuOpen = ()=>{
        // Don't open menu after the user has clicked clear
        if (clearingFromIcon) setClearingFromIcon(false);
        else setIsOpen(true);
    };
    const onMenuClose = ()=>{
        // Don't close menu after the user has clicked clear
        if (clearingFromIcon) setClearingFromIcon(false);
        else setIsOpen(false);
    };
    const setInternalContainerRef = (ref)=>{
        const oldRef = containerRef;
        setContainerRef(ref);
        // Cause a re-render if we're getting the container ref for the first time
        // as the layered menu requires it for dimension calculation
        if (oldRef === null && ref !== null) forceUpdate();
    };
    const onBlur = (event)=>{
        setIsFocused(false);
        providedOnBlur(event);
    };
    const onFocus = (event)=>{
        setIsFocused(true);
        providedOnFocus(event);
    };
    const onSelectKeyDown = (event)=>{
        const { key: key } = event;
        const keyPressed = key.toLowerCase();
        if (clearingFromIcon && (keyPressed === 'backspace' || keyPressed === 'delete')) // If being cleared from keyboard, don't change behaviour
        setClearingFromIcon(false);
    };
    const ICON_PADDING = 2;
    const GRID_SIZE = 8;
    const l10n = (0, $7qZ1x.createLocalizationProvider)(locale);
    const { styles: selectStyles = {}, ...otherSelectProps } = selectProps;
    const SelectComponent = timeIsEditable ? (0, $iOwNT.default) : (0, $7K5PP.default);
    /**
   * There are multiple props that can change how the time is formatted.
   * The priority of props used is:
   *   1. formatDisplayLabel
   *   2. timeFormat
   *   3. locale
   */ const formatTime = (time)=>{
        if (formatDisplayLabel) return formatDisplayLabel(time, timeFormat || (0, $jHBnA.defaultTimeFormat));
        const date = (0, $j537G.default)(time);
        if (!(date instanceof Date)) return '';
        if (!(0, $jovBr.default)(date)) return time;
        if (timeFormat) return (0, $k7m40.default)(date, (0, $2ucUe.convertTokens)(timeFormat));
        return l10n.formatTime(date);
    };
    const options = times.map((time)=>{
        return {
            label: formatTime(time),
            value: time
        };
    });
    let initialValue;
    if (providedValue !== null && providedValue !== undefined && providedValue !== '') initialValue = {
        label: formatTime(providedValue),
        value: providedValue
    };
    else if (providedValue !== '' && value) initialValue = {
        label: formatTime(value),
        value: value
    };
    else initialValue = null;
    const SingleValue = (0, $dBs4v.makeSingleValue)({
        lang: locale
    });
    const selectComponents = {
        DropdownIndicator: (0, $jHBnA.EmptyComponent),
        Menu: (0, $imOgG.FixedLayerMenu),
        SingleValue: SingleValue,
        ...hideIcon && {
            ClearIndicator: (0, $jHBnA.EmptyComponent)
        }
    };
    const renderIconContainer = Boolean(!hideIcon && value);
    // @ts-ignore -- Argument of type 'StylesConfig<OptionType, false, GroupBase<OptionType>>' is not assignable to parameter of type 'StylesConfig<OptionType, boolean, GroupBase<OptionType>>'.
    const mergedStyles = (0, $7VXAu.mergeStyles)(selectStyles, {
        control: (base)=>({
                ...base
            }),
        menu: (base)=>({
                ...base,
                ...$420c0ce16dc216b4$var$menuStyles,
                // Fixed positioned elements no longer inherit width from their parent, so we must explicitly set the
                // menu width to the width of our container
                width: containerRef ? containerRef.getBoundingClientRect().width : 'auto'
            }),
        indicatorsContainer: (base)=>({
                ...base,
                paddingLeft: renderIconContainer ? ICON_PADDING : 0,
                paddingRight: renderIconContainer ? GRID_SIZE - ICON_PADDING : 0
            })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        ...innerProps,
        ref: setInternalContainerRef,
        "data-testid": testId && `${testId}--container`,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                name: name,
                type: "hidden",
                value: value,
                "data-testid": testId && `${testId}--input`,
                onKeyDown: onSelectKeyDown
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)(SelectComponent, {
                "aria-describedby": ariaDescribedBy,
                "aria-label": label || undefined,
                appearance: appearance,
                autoFocus: autoFocus,
                clearControlLabel: clearControlLabel,
                components: selectComponents,
                inputId: id,
                isClearable: true,
                isDisabled: isDisabled,
                isRequired: isRequired,
                menuIsOpen: isOpen && !isDisabled,
                menuPlacement: "auto",
                openMenuOnFocus: true,
                onBlur: onBlur,
                onCreateOption: onCreateOption,
                onChange: onChange,
                options: options,
                onFocus: onFocus,
                onMenuOpen: onMenuOpen,
                onMenuClose: onMenuClose,
                placeholder: placeholder || l10n.formatTime((0, $jHBnA.placeholderDatetime)),
                styles: mergedStyles,
                value: initialValue,
                spacing: spacing,
                // We need this to get things to work, even though it's not supported.
                // @ts-ignore
                fixedLayerRef: containerRef,
                isInvalid: isInvalid,
                testId: testId,
                ...otherSelectProps
            })
        ]
    });
});
var $420c0ce16dc216b4$export$2e2bcd8739ae039 = $420c0ce16dc216b4$var$TimePicker;

});
parcelRegister("7qZ1x", function(module, exports) {

$parcel$export(module.exports, "createLocalizationProvider", () => $71bdd27445bf5301$export$ea56ca58f08ffa52);

var $lCAti = parcelRequire("lCAti");

var $is0Fy = parcelRequire("is0Fy");

var $1cWOp = parcelRequire("1cWOp");
const $71bdd27445bf5301$export$ea56ca58f08ffa52 = (locale, formatterOptions)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $lCAti.normalizeLocale)(locale);
    const formatDate = (date)=>Intl.DateTimeFormat(normalizedLocale).format(date);
    const formatTime = (date)=>Intl.DateTimeFormat(normalizedLocale, {
            hour: 'numeric',
            minute: 'numeric'
        }).format(date);
    const getDays = (weekStartDay = 0, length)=>{
        const dayFormatter = Intl.DateTimeFormat(normalizedLocale, {
            weekday: length
        });
        // Right now there is no way to find out first day of the week based on Intl (locale)
        // api. Check issue here: https://github.com/tc39/ecma402/issues/6
        // So we rotate the weekdays based on #weekStartDay parameter.
        const weekdays = [
            0,
            1,
            2,
            3,
            4,
            5,
            6
        ];
        const rotatedWeekdays = weekStartDay > 0 ? [
            ...weekdays.slice(weekStartDay),
            ...weekdays.slice(0, weekStartDay)
        ] : weekdays;
        return rotatedWeekdays.map((day)=>{
            // Some short days are longer than 3 characters but are unique if the first
            // three non-white characters are used.
            const result = dayFormatter// Date range chosen which has a Sun-Sat range so we can extract the names
            .format(new Date(2000, 9, day + 1, 12))// \u200E matches on the Left-to-Right Mark character in IE/Edge
            .replace(/[\s\u200E]/g, '');
            // If short days, only return first three characters. Else return whole thing
            if (length === 'short') return result.substring(0, 3);
            else return result;
        });
    };
    const getDaysShort = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'short');
    };
    const getDaysLong = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'long');
    };
    const getMonthsLong = ()=>{
        const monthFormatter = Intl.DateTimeFormat(normalizedLocale, {
            month: 'long'
        });
        return [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ].map((month)=>// Date chosen for no real reason, the only important part is the month
            // Using 2020 'cos Safari has a faulty implementation when we use the year 2000
            // Intl.DateTimeFormat("en-US", { month: 'long'}).format(new Date(2000, 3, 1))
            // should give "April" but gives "March" in Safari
            monthFormatter.format(new Date(2020, month, 1)));
    };
    const parseDate = (date, options = {})=>(0, $is0Fy.createDateParser)(normalizedLocale)(date, options);
    const formatToParts = (date = new Date())=>{
        const formatter = new Intl.DateTimeFormat(normalizedLocale, formatterOptions);
        /**
		 * Safari has a bug that returns the wrong month for years 2005 and before.
		 * The error occurs when the passed date has been created with numbers, like new Date(2000, 3, 1)
		 * Not all the months fail in each year. To ensure the correct output,
		 * we select 2020 as the base year for the whole date,
		 * then we replace in the result the original input year
		 */ const fixedDate = new Date(date);
        fixedDate.setFullYear(2020);
        const fixedParts = (0, $1cWOp.toFormattedParts)(formatter.formatToParts(fixedDate));
        const originalParts = (0, $1cWOp.toFormattedParts)(formatter.formatToParts(date));
        if (fixedParts.year) fixedParts.year = originalParts.year;
        /**
		 * Chrome has a bug that returns hour="00" when it's 12:00pm in certain languages
		 * We fix it by detecting the real time with getHours method
		 */ if (fixedParts.hour === '00' && fixedDate.getHours() === 12) fixedParts.hour = '12';
        return fixedParts;
    };
    return {
        getDaysShort: getDaysShort,
        getDaysLong: getDaysLong,
        getMonthsLong: getMonthsLong,
        formatDate: formatDate,
        formatTime: formatTime,
        parseDate: parseDate,
        formatToParts: formatToParts
    };
};

});
parcelRegister("lCAti", function(module, exports) {

$parcel$export(module.exports, "normalizeLocale", () => $13af55a9724edafd$export$dca0327c9b9c6498);
const $13af55a9724edafd$export$dca0327c9b9c6498 = (locale)=>locale.replace(/_/g, '-');

});

parcelRegister("is0Fy", function(module, exports) {

$parcel$export(module.exports, "createDateParser", () => $d8bb223589902df4$export$cfa2ef2687faeda2);

var $lCAti = parcelRequire("lCAti");

var $3wYKB = parcelRequire("3wYKB");
const $d8bb223589902df4$var$INVALID_DATE = new Date(NaN);
const $d8bb223589902df4$var$INVARIANT = {
    year: 1993,
    month: 2,
    day: 18
};
const $d8bb223589902df4$var$INVARIANT_DATE = (0, $3wYKB.toDate)($d8bb223589902df4$var$INVARIANT);
const $d8bb223589902df4$var$FORMAT_EXTRACTOR_REGEX = /(\d+)[^\d]+(\d+)[^\d]+(\d+)\.?/;
const $d8bb223589902df4$var$DATE_PARSER_REGEX = /(\d+)[^\d]*(\d+)?[^\d]*(\d+)?\.?/;
// Internet Explorer returns non-printing characters when formatting a date
const $d8bb223589902df4$var$stripExtras = (str)=>str.replace(/\u200E/g, '');
const $d8bb223589902df4$var$extractDateParts = (matchResult)=>{
    return matchResult// Get the 3 capture groups
    .splice(1, 4)// Convert them to numbers
    .map((datePart)=>parseInt(datePart, 10));
};
const $d8bb223589902df4$export$cfa2ef2687faeda2 = (locale)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $lCAti.normalizeLocale)(locale);
    const dateFormatter = Intl.DateTimeFormat(normalizedLocale);
    // Generate a date string from a hard coded date, this allows us to determine
    // the year/month/day position for the provided locale.
    const rawDateString = dateFormatter.format($d8bb223589902df4$var$INVARIANT_DATE);
    const shortDate = $d8bb223589902df4$var$stripExtras(rawDateString);
    // Extract the date pieces from the locale formatted date string
    const formatMatch = shortDate.match($d8bb223589902df4$var$FORMAT_EXTRACTOR_REGEX);
    if (!formatMatch) throw new Error('Unable to create DateParser');
    const formatParts = $d8bb223589902df4$var$extractDateParts(formatMatch);
    // Find the year/month/day positions of the locale formatted invariant date
    const yearPosition = formatParts.indexOf($d8bb223589902df4$var$INVARIANT.year);
    const monthPosition = formatParts.indexOf($d8bb223589902df4$var$INVARIANT.month);
    const dayPosition = formatParts.indexOf($d8bb223589902df4$var$INVARIANT.day);
    return (date, options = {})=>{
        const dateMatch = $d8bb223589902df4$var$stripExtras(date).match($d8bb223589902df4$var$DATE_PARSER_REGEX);
        if (!dateMatch) return $d8bb223589902df4$var$INVALID_DATE;
        const dateParts = $d8bb223589902df4$var$extractDateParts(dateMatch);
        // Use the previously extracted year/month/day positions to extract each
        // date piece.
        const extractedDate = {
            year: dateParts[yearPosition],
            month: dateParts[monthPosition],
            day: dateParts[dayPosition]
        };
        const normalizedDate = (0, $3wYKB.normalizeDate)(extractedDate, options?.defaultFirstDay);
        if (!(0, $3wYKB.isValid)(normalizedDate)) return $d8bb223589902df4$var$INVALID_DATE;
        return (0, $3wYKB.toDate)(normalizedDate);
    };
};

});
parcelRegister("3wYKB", function(module, exports) {

$parcel$export(module.exports, "toDate", () => $121d324fc62f760d$export$e67a095c620b86fe);
$parcel$export(module.exports, "isValid", () => $121d324fc62f760d$export$1ea939691cdc45b8);
$parcel$export(module.exports, "normalizeDate", () => $121d324fc62f760d$export$fcc71269590ba0a8);
/**
 * A numerical representation of a date:
 *  - year: any positive integer
 *  - month: 1 - 12 (Jan - Dec)
 *  - day: 1 - [28, 29, 30, 31] (depending on month)
 */ const $121d324fc62f760d$export$abe96da78d4f59dd = (date)=>({
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
    });
const $121d324fc62f760d$export$e67a095c620b86fe = (date)=>// The 'proper' month is stored in a DateObj but Date expects month index
    new Date(date.year, date.month - 1, date.day);
const $121d324fc62f760d$export$553d7fa8e3805fc0 = (year)=>{
    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
};
const $121d324fc62f760d$export$f645ddd439eb259d = (year, month)=>{
    // February depends on leap year
    if (month === 2 && $121d324fc62f760d$export$553d7fa8e3805fc0(year)) return 29;
    return [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][month - 1];
};
const $121d324fc62f760d$export$1ea939691cdc45b8 = (date)=>{
    const { year: year, month: month, day: day } = date;
    const daysInMonth = $121d324fc62f760d$export$f645ddd439eb259d(year, month);
    return 1 <= month && month <= 12 && 1 <= day && day <= daysInMonth;
};
const $121d324fc62f760d$export$fcc71269590ba0a8 = (date, defaultFirstDay = false)=>{
    const now = $121d324fc62f760d$export$abe96da78d4f59dd(new Date());
    const { year: year, month: month, day: day } = date;
    // 19 should evaluate to 2019
    const fullYear = year < 100 ? 2000 + year : year;
    // Missing date pieces are filled in with their current date values
    const normalizedYear = !isNaN(fullYear) ? fullYear : now.year;
    const normalizedMonth = !isNaN(month) && month !== 0 ? month : now.month;
    const normalizedDay = !isNaN(day) && day !== 0 ? day : month !== 0 && defaultFirstDay ? 1 : now.day;
    return {
        year: normalizedYear,
        month: normalizedMonth,
        day: normalizedDay
    };
};

});


parcelRegister("1cWOp", function(module, exports) {

$parcel$export(module.exports, "toFormattedParts", () => $56bd04270448c035$export$9b7ca29af37c192);
const $56bd04270448c035$export$9b7ca29af37c192 = (rawParts)=>rawParts.reduce((result, datePart)=>({
            ...result,
            [datePart.type]: datePart.value
        }), {});

});


parcelRegister("jHBnA", function(module, exports) {

$parcel$export(module.exports, "EmptyComponent", () => $91948b176ea23188$export$5e30e9a24d6c1203);
$parcel$export(module.exports, "placeholderDatetime", () => $91948b176ea23188$export$fff8babee5abe3e2);
$parcel$export(module.exports, "defaultTimes", () => $91948b176ea23188$export$b42ffb9f09b1861b);
$parcel$export(module.exports, "defaultTimeFormat", () => $91948b176ea23188$export$9e6d8fcf62256b85);
$parcel$export(module.exports, "defaultDateFormat", () => $91948b176ea23188$export$75032c84f56650eb);
$parcel$export(module.exports, "padToTwo", () => $91948b176ea23188$export$a7de57e5b672ccdb);
$parcel$export(module.exports, "formatDateTimeZoneIntoIso", () => $91948b176ea23188$export$2eeb05a2ecc2ce0a);
/**
 * This component is used to hide portions of Select component.
 */ const $91948b176ea23188$export$5e30e9a24d6c1203 = ()=>null;
const $91948b176ea23188$export$fff8babee5abe3e2 = new Date(1993, 1, 18, 13);
const $91948b176ea23188$export$b42ffb9f09b1861b = [
    '09:00',
    '09:30',
    '10:00',
    '10:30',
    '11:00',
    '11:30',
    '12:00',
    '12:30',
    '13:00',
    '13:30',
    '14:00',
    '14:30',
    '15:00',
    '15:30',
    '16:00',
    '16:30',
    '17:00',
    '17:30',
    '18:00'
];
const $91948b176ea23188$export$9e6d8fcf62256b85 = 'h:mma';
const $91948b176ea23188$export$75032c84f56650eb = 'YYYY/MM/DD';
function $91948b176ea23188$export$a7de57e5b672ccdb(number) {
    return number <= 99 ? `0${number}`.slice(-2) : `${number}`;
}
function $91948b176ea23188$export$2eeb05a2ecc2ce0a(date, time, zone) {
    // 12:00 => 12:00, 1:00 => 01:00
    const needsLeadingZero = /^\d:/;
    const sanitizedTime = needsLeadingZero.test(time) ? `0${time}` : time;
    return `${date}T${sanitizedTime}${zone}`;
}

});

parcelRegister("imOgG", function(module, exports) {

$parcel$export(module.exports, "FixedLayerMenu", () => $cf860f703ecf4b3d$export$982ad994195b4356);
/* fixed-layer-menu.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bChGW = parcelRequire("bChGW");

var $avHVh = parcelRequire("avHVh");
const $cf860f703ecf4b3d$export$982ad994195b4356 = ({ className: className, clearValue: clearValue, cx: cx, getStyles: getStyles, getValue: getValue, hasValue: hasValue, innerProps: innerProps, innerRef: innerRef, isLoading: isLoading, isMulti: isMulti, isRtl: isRtl, maxMenuHeight: maxMenuHeight, menuPlacement: menuPlacement, menuPosition: menuPosition, menuShouldScrollIntoView: menuShouldScrollIntoView, minMenuHeight: minMenuHeight, options: options, placement: placement, selectOption: selectOption, selectProps: selectProps, setValue: setValue, children: children, ...rest })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $avHVh.default), {
        inputValue: selectProps.inputValue,
        //@ts-ignore react-select unsupported props
        containerRef: selectProps.fixedLayerRef,
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bChGW.components).Menu, {
            ...rest,
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            clearValue: clearValue,
            cx: cx,
            getStyles: getStyles,
            getValue: getValue,
            hasValue: hasValue,
            innerProps: innerProps,
            innerRef: innerRef,
            isLoading: isLoading,
            isMulti: isMulti,
            isRtl: isRtl,
            maxMenuHeight: maxMenuHeight,
            menuPlacement: menuPlacement,
            menuPosition: menuPosition,
            menuShouldScrollIntoView: menuShouldScrollIntoView,
            minMenuHeight: minMenuHeight,
            options: options,
            placement: placement,
            selectOption: selectOption,
            selectProps: selectProps,
            setValue: setValue,
            children: children
        }),
        //@ts-ignore react-select unsupported props
        testId: selectProps.testId
    });

});
parcelRegister("avHVh", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac07968b7cb494a9$export$2e2bcd8739ae039);
/* fixed-layer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $eGmKJ = parcelRequire("eGmKJ");

var $5owSH = parcelRequire("5owSH");

var $gkD4s = parcelRequire("gkD4s");
var $4oNEb = parcelRequire("4oNEb");
var $1V7PR = parcelRequire("1V7PR");
const $ac07968b7cb494a9$var$styles = {
    root: "_bfhk18uv _kqswstnw _154ize3t",
    popperStyles: "_1pbyowjs"
};
class $ac07968b7cb494a9$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    componentDidUpdate(prevProps) {
        if (prevProps.inputValue !== this.props.inputValue) this.update();
    }
    render() {
        const { containerRef: containerRef, content: content, testId: testId } = this.props;
        // Wait for containerRef callback to cause a re-render
        if (!containerRef) return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {});
        const divStyles = {
            height: containerRef.getBoundingClientRect().height,
            // Don't block the clear button
            width: containerRef.getBoundingClientRect().width - parseInt((0, $5owSH.sizes).small.slice(0, -2)) - 8
        };
        return(/* Need to wrap layer in a fixed position div so that it will render its content as fixed
       * We need to set the intial top value to where the container is and zIndex so that it still
       * applies since we're creating a new stacking context. */ /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $gkD4s.Manager), {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1V7PR.Reference), {
                    children: ({ ref: ref })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                            ref: ref,
                            "data-layer-child": true,
                            style: divStyles,
                            className: (0, $bwpsq.default)([
                                $ac07968b7cb494a9$var$styles.root
                            ])
                        })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4oNEb.Popper), {
                    children: ({ ref: ref, style: style, update: update })=>{
                        this.update = update;
                        return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                            ref: ref,
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                            style: style,
                            "data-testid": testId && `${testId}--popper--container`,
                            className: (0, $bwpsq.default)([
                                $ac07968b7cb494a9$var$styles.popperStyles
                            ]),
                            children: content
                        });
                    }
                })
            ]
        }));
    }
    constructor(...args){
        super(...args), this.update = (0, $eGmKJ.default);
    }
}

});
parcelRegister("5owSH", function(module, exports) {

$parcel$export(module.exports, "sizes", () => $7ad0abb26ad673d7$export$c647cb0ee6e282fe);
const $7ad0abb26ad673d7$export$c647cb0ee6e282fe = {
    small: '16px',
    medium: '24px',
    large: '32px',
    xlarge: '48px'
};
const $7ad0abb26ad673d7$export$7bd66fc94c81bf84 = {
    small: 'small',
    medium: 'medium',
    large: 'large',
    xlarge: 'xlarge'
};
const $7ad0abb26ad673d7$export$62ad7b0c781000e9 = {
    small: {
        width: $7ad0abb26ad673d7$export$c647cb0ee6e282fe.small,
        height: $7ad0abb26ad673d7$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $7ad0abb26ad673d7$export$c647cb0ee6e282fe.medium,
        height: $7ad0abb26ad673d7$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $7ad0abb26ad673d7$export$c647cb0ee6e282fe.large,
        height: $7ad0abb26ad673d7$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $7ad0abb26ad673d7$export$c647cb0ee6e282fe.xlarge,
        height: $7ad0abb26ad673d7$export$c647cb0ee6e282fe.xlarge
    }
};

});



parcelRegister("j537G", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5e493719c30ce57$export$2e2bcd8739ae039);
const $b5e493719c30ce57$var$map24 = {
    '12': '12',
    '01': '13',
    '02': '14',
    '03': '15',
    '04': '16',
    '05': '17',
    '06': '18',
    '07': '19',
    '08': '20',
    '09': '21',
    '10': '22',
    '11': '23'
};
function $b5e493719c30ce57$export$1ea939691cdc45b8(timeString) {
    /**
	 * Regex match for `12:34`, `12:34:56`, `1:23:56 p`, `1:23:56PM`, and a bit more…
	 */ const time = timeString.trim().match(/([012]?[\d])(?::([0-5][\d]))?(?::([0-5][\d]))?\s*([ap]m?)?/i);
    /**
	 * Regex match for `1234`, `12:34`, `12.34`, `123456`, `12:34:56`, `12.34.56`
	 */ const time24hr = timeString.trim().match(/([012][\d])[:.]?([0-5][\d])([:.]?([0-5][\d]))?/);
    /**
	 * Convert `2:34:56 pm` down to `23456`
	 */ const num = timeString.replace(/[^0-9]/g, '');
    const includesSeconds = time && time[1] !== undefined && time[2] !== undefined && time[3] !== undefined || time24hr && time24hr[1] !== undefined && time24hr[2] !== undefined && time24hr[4] !== undefined;
    if (!time && !time24hr) return false;
    if (time && !time[1]) return false;
    if (num.length > 6) return false;
    if (num.length > 4 && !includesSeconds) return false;
    if (num.length === 2 && parseInt(num, 10) > 12) return false;
    return true;
}
function $b5e493719c30ce57$export$49c81d9f91c512ce(time) {
    return time.replace(/[:.]/g, '');
}
function $b5e493719c30ce57$var$formatSemi24(time) {
    if (time.length === 1) return `0${time}00`;
    if (time.length === 2) return `${time}00`;
    if (time.length === 3 || time.length === 5) return `0${time}`;
    return time;
}
function $b5e493719c30ce57$var$checkHour(hour, meridiem) {
    if (hour > '24') return null;
    if (hour === '12' && meridiem === 'a') return '00';
    if (hour < '12' && meridiem === 'p') return $b5e493719c30ce57$var$map24[hour];
    return hour;
}
function $b5e493719c30ce57$var$checkMinuteSecond(value) {
    if (value > '59') return null;
    return value;
}
function $b5e493719c30ce57$export$6137ce2c9c5166bb(time) {
    const timeArray = time.toLowerCase().split(/(p|a)/i);
    const meridiem = timeArray[1];
    const semi24 = $b5e493719c30ce57$var$formatSemi24(timeArray[0].trim());
    const hour = $b5e493719c30ce57$var$checkHour(semi24.substring(0, 2), meridiem);
    const minute = $b5e493719c30ce57$var$checkMinuteSecond(semi24.substring(2, 4));
    const seconds = semi24.length === 6 && $b5e493719c30ce57$var$checkMinuteSecond(semi24.substring(4, 6));
    if (!hour || !minute) return null;
    return {
        hour: parseInt(hour, 10),
        minute: parseInt(minute, 10),
        seconds: parseInt(seconds || '0', 10) || 0
    };
}
function $b5e493719c30ce57$var$assignToDate(time) {
    const dateTime = new Date();
    dateTime.setHours(time.hour);
    dateTime.setMinutes(time.minute);
    // milliseconds is not supported
    dateTime.setSeconds(time.seconds || 0, 0);
    return dateTime;
}
function $b5e493719c30ce57$export$2e2bcd8739ae039(time) {
    const trimmedTime = time.toString().trim();
    if (!$b5e493719c30ce57$export$1ea939691cdc45b8(trimmedTime)) throw RangeError('invalid time format');
    const time1 = $b5e493719c30ce57$export$49c81d9f91c512ce(trimmedTime);
    const time2 = $b5e493719c30ce57$export$6137ce2c9c5166bb(time1);
    if (!time2) throw RangeError('invalid time format');
    return $b5e493719c30ce57$var$assignToDate(time2);
}

});

parcelRegister("2ucUe", function(module, exports) {

$parcel$export(module.exports, "convertTokens", () => $ca6f20a476eda5dc$export$4d5430175be73d45);
// https://github.com/date-fns/date-fns-upgrade/blob/master/src/v2/convertTokens/index.ts
const $ca6f20a476eda5dc$var$tokensMap = {
    // 'D MMMM': '',
    // 'Do MMMM': '',
    // 'DD MMMM': '',
    M: 'L',
    Mo: 'Mo',
    MM: 'LL',
    MMM: 'LLL',
    MMMM: 'LLLL',
    Q: 'q',
    Qo: 'qo',
    D: 'd',
    Do: 'do',
    DD: 'dd',
    DDD: 'D',
    DDDo: 'Do',
    DDDD: 'DDD',
    d: 'i',
    do: 'io',
    dd: 'iiiiii',
    ddd: 'iii',
    dddd: 'iiii',
    A: 'a',
    a: 'a',
    aa: 'aaaa',
    E: 'i',
    W: 'I',
    Wo: 'Io',
    WW: 'II',
    YY: 'yy',
    YYYY: 'yyyy',
    GG: 'RR',
    GGGG: 'RRRR',
    H: 'H',
    HH: 'HH',
    h: 'h',
    hh: 'hh',
    m: 'm',
    mm: 'mm',
    s: 's',
    ss: 'ss',
    S: 'S',
    SS: 'SS',
    SSS: 'SSS',
    Z: 'xxx',
    ZZ: 'xx',
    X: 't',
    x: 'T'
};
const $ca6f20a476eda5dc$var$v1tokens = Object.keys($ca6f20a476eda5dc$var$tokensMap).sort().reverse();
const $ca6f20a476eda5dc$var$tokensRegExp = new RegExp(// v1 escape string (unsure the purpose of post-pipe capture group)
"(\\[[^\\[]*\\])|(\\\\)?('.+'|" + // All v1 tokens
$ca6f20a476eda5dc$var$v1tokens.join('|') + '|.)', 'g');
function $ca6f20a476eda5dc$export$4d5430175be73d45(format) {
    const tokensCaptures = format.match($ca6f20a476eda5dc$var$tokensRegExp);
    if (!tokensCaptures) return format;
    return tokensCaptures.reduce((parsed, tokenString, index)=>{
        const v2token = $ca6f20a476eda5dc$var$tokensMap[tokenString];
        if (!v2token) {
            const escapedCaptures = tokenString.match(/^\[(.+)\]$/);
            if (escapedCaptures) parsed.escapedTextBuffer.push(escapedCaptures[1]);
            else parsed.escapedTextBuffer.push(tokenString);
        }
        const endOfString = index === tokensCaptures.length - 1;
        if (parsed.escapedTextBuffer.length && (v2token || endOfString)) {
            // This allows double parentheses to be rendered correctly
            // according to date-fns's spec.
            // https://date-fns.org/v2.29.3/docs/format
            //
            // We have to keep the single quote and then remove it because
            // browser support for lookahead/behind is low and causes breaking
            // errors (HOT-104152)
            const filteredEscapedTextBuffer = parsed.escapedTextBuffer.map((token)=>token[0] === "'" && token.slice(-1) === "'" ? token.slice(1, -1) : token).filter((token)=>token !== "'").join('');
            parsed.formatBuffer.push(`'${filteredEscapedTextBuffer}'`);
            parsed.escapedTextBuffer = [];
        }
        if (v2token) parsed.formatBuffer.push(v2token);
        return parsed;
    }, {
        formatBuffer: [],
        escapedTextBuffer: []
    }).formatBuffer.join('');
}

});

parcelRegister("dBs4v", function(module, exports) {

$parcel$export(module.exports, "makeSingleValue", () => $9661917c82165ad2$export$6e30bf8cb1347b56);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bChGW = parcelRequire("bChGW");
const $9661917c82165ad2$export$6e30bf8cb1347b56 = ({ lang: lang })=>({ children: children, className: className, clearValue: clearValue, cx: cx, data: data, getStyles: getStyles, getValue: getValue, hasValue: hasValue, isDisabled: isDisabled, isMulti: isMulti, isRtl: isRtl, options: options, selectOption: selectOption, selectProps: selectProps, setValue: setValue, ...rest })=>{
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bChGW.components).SingleValue, {
            ...rest,
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            clearValue: clearValue,
            cx: cx,
            data: data,
            getStyles: getStyles,
            getValue: getValue,
            hasValue: hasValue,
            innerProps: {
                lang: lang
            },
            isDisabled: isDisabled,
            isMulti: isMulti,
            isRtl: isRtl,
            options: options,
            selectOption: selectOption,
            selectProps: selectProps,
            setValue: setValue,
            children: children
        });
    };

});


parcelRegister("cye6V", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7236b8d4f3556f3$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d7236b8d4f3556f3$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    dropdownTitle: {
        "id": "personal-settings-preference-fields.common.batch-window.dropdown-title",
        "defaultMessage": "Batch Window Preference"
    },
    optionTextDef: {
        "id": "personal-settings-preference-fields.common.batch-window.option-text-def",
        "defaultMessage": "Every 3 minutes"
    },
    optionTextTenMins: {
        "id": "personal-settings-preference-fields.common.batch-window.option-text-ten-mins",
        "defaultMessage": "Every 10 minutes"
    },
    optionTextThirtyMins: {
        "id": "personal-settings-preference-fields.common.batch-window.option-text-thirty-mins",
        "defaultMessage": "Every 30 minutes"
    },
    optionTextSixtyMins: {
        "id": "personal-settings-preference-fields.common.batch-window.option-text-sixty-mins",
        "defaultMessage": "Every 60 minutes"
    },
    optionTextOncePerDayAt: {
        "id": "personal-settings-preference-fields.common.batch-window.option-text-once-per-day-at",
        "defaultMessage": "Once per day at..."
    },
    optionText0900: {
        "id": "personal-settings-preference-fields.common.batch-window.option-text-0900",
        "defaultMessage": "9:00 AM"
    },
    optionText5: {
        "id": "personal-settings-preference-fields.common.batch-window.option-text-5",
        "defaultMessage": "No Batching"
    },
    batchWindowFieldLabel: {
        "id": "personal-settings-preference-fields.common.batch-window.batch-window-field-label",
        "defaultMessage": "Notifications for the same issue will be grouped together into one email"
    },
    batchWindowFieldLabelIssueTermRefresh: {
        "id": "personal-settings-preference-fields.common.batch-window.batch-window-field-label-issue-term-refresh",
        "defaultMessage": "Notifications for the same work item will be grouped together into one email"
    },
    timePickerLabel: {
        "id": "personal-settings-preference-fields.common.batch-window.time-picker-label",
        "defaultMessage": "Select notification time"
    },
    selectBatchWindowLabel: {
        "id": "personal-settings-preference-fields.common.batch-window.select-batch-window-label",
        "defaultMessage": "Email notification frequency"
    }
});

});


parcelRegister("5rZRJ", function(module, exports) {

$parcel$export(module.exports, "EnableBatchingPreferenceField", () => $0e503c94b4df0bb4$export$e04eeaa762935305);

var $jMxQ1 = parcelRequire("jMxQ1");

var $eTwBU = parcelRequire("eTwBU");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $2NMNM = parcelRequire("2NMNM");

var $2x3Cb = parcelRequire("2x3Cb");

var $6tRzQ = parcelRequire("6tRzQ");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $dTlW6 = parcelRequire("dTlW6");

var $jcw0u = parcelRequire("jcw0u");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $9InRy = parcelRequire("9InRy");

var $jgJNO = parcelRequire("jgJNO");

var $8zOmE = parcelRequire("8zOmE");

var $koeKL = parcelRequire("koeKL");

var $fzQ1Y = parcelRequire("fzQ1Y");
const $0e503c94b4df0bb4$export$e04eeaa762935305 = ({ enableBatchingFragment: enableBatchingFragment })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const cloudId = (0, $koeKL.useCloudId)();
    const { showErrorFlag: showErrorFlag } = (0, $9InRy.useShowErrorFlag)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [isInfoPanelOpen, setIsInfoPanelOpen] = (0, $5uXOq.useState)(false);
    const data = (0, $8Uumt.useFragment)((0, $eTwBU.default), enableBatchingFragment);
    const [commit] = (0, $8Uumt.useMutation)((0, $jMxQ1.default));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        spread: "space-between",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2x3Cb.Label), {
        htmlFor: "enable-batching"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center",
        xcss: $0e503c94b4df0bb4$var$labelHolderStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        testId: "personal-settings-preference-fields.common.ui.enable-batching.toggle",
        xcss: $0e503c94b4df0bb4$var$labelStyles,
        alignBlock: "center"
    }, formatMessage((0, $fzQ1Y.default).toggleLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        placement: "right-start",
        messageId: "personal-settings-preference-fields.common.ui.enable-batching.popup",
        messageType: "transactional",
        isOpen: isInfoPanelOpen,
        onClose: ()=>{
            setIsInfoPanelOpen(false);
        },
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                xcss: $0e503c94b4df0bb4$var$infoDialogStyles
            }, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $fzQ1Y.default).infoDialogContentIssueTermRefresh : (0, $fzQ1Y.default).infoDialogContent)),
        trigger: ({ ref: ref, 'aria-haspopup': ariaHasPopup, 'aria-controls': ariaControls, 'data-ds--level': dataDSLevel })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                xcss: $0e503c94b4df0bb4$var$infoIconStyles,
                onMouseEnter: ()=>{
                    setIsInfoPanelOpen(true);
                },
                onMouseLeave: ()=>{
                    setIsInfoPanelOpen(false);
                },
                testId: "personal-settings-preference-fields.common.ui.enable-batching.info-pop-up-button-container",
                ref: ref,
                "aria-haspopup": ariaHasPopup,
                "aria-controls": ariaControls,
                "data-ds--level": dataDSLevel
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6tRzQ))), {
                label: formatMessage((0, $fzQ1Y.default).infoPanelTriggerLabel),
                color: "var(--ds-icon, #44546F)"
            }))
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dTlW6.default), {
        id: "enable-batching",
        isChecked: data.batchWindow !== 'NO_BATCHING',
        onChange: (option)=>{
            if (option) {
                const isEnabled = option.currentTarget.checked;
                commit({
                    variables: {
                        cloudId: cloudId,
                        input: {
                            batchWindow: option.currentTarget.checked ? 'DEFAULT_BATCHING' : 'NO_BATCHING'
                        }
                    },
                    optimisticResponse: {
                        jira: {
                            updateGlobalNotificationOptions: {
                                success: true,
                                errors: [],
                                options: {
                                    id: data.id,
                                    batchWindow: option.currentTarget.checked ? 'DEFAULT_BATCHING' : 'NO_BATCHING'
                                }
                            }
                        }
                    },
                    onError: (error)=>{
                        showErrorFlag();
                        (0, $jcw0u.default)({
                            meta: {
                                id: 'mutateBatchWindowPreference',
                                packageName: 'jiraPersonalSettingsPreferenceFields',
                                teamName: 'jira-notifications-platform'
                            },
                            error: error,
                            sendToPrivacyUnsafeSplunk: true
                        });
                    },
                    onCompleted: (response)=>{
                        const errors = response?.jira?.updateGlobalNotificationOptions?.errors;
                        if (errors && errors?.length > 0) {
                            showErrorFlag();
                            errors.forEach((error)=>{
                                (0, $jcw0u.default)({
                                    meta: {
                                        id: 'mutateBatchWindowPreferenceCompletedError',
                                        packageName: 'jiraPersonalSettingsPreferenceFields',
                                        teamName: 'jira-notifications-platform'
                                    },
                                    error: new Error(error?.message || 'Unknown Error'),
                                    sendToPrivacyUnsafeSplunk: true
                                });
                            });
                        } else {
                            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'batchWindow changed', 'batchWindow', {
                                value: isEnabled ? 'DEFAULT_BATCHING' : 'NO_BATCHING'
                            });
                            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'mutateBatchWindowPreference success', {
                                value: isEnabled ? 'DEFAULT_BATCHING' : 'NO_BATCHING'
                            });
                        }
                    }
                });
            }
        }
    }));
};
const $0e503c94b4df0bb4$var$labelHolderStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.050'
});
const $0e503c94b4df0bb4$var$labelStyles = (0, $8CUq3.xcss)({
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    color: 'color.text'
});
const $0e503c94b4df0bb4$var$infoIconStyles = (0, $8CUq3.xcss)({
    marginLeft: 'space.100',
    marginTop: 'space.025'
});
const $0e503c94b4df0bb4$var$infoDialogStyles = (0, $8CUq3.xcss)({
    paddingTop: 'space.200',
    paddingBottom: 'space.200',
    paddingRight: 'space.300',
    paddingLeft: 'space.300',
    maxWidth: '575px'
});

});
parcelRegister("jMxQ1", function(module, exports) {

$parcel$export(module.exports, "default", () => $30d94092652e45ad$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0f0afcd51275051df29c9a3aa4a23d8d>>
 * @relayHash 7086dd49c5ed612ee7b849c55c846e67
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4bc064920e43df38639bc8e57762cc6b2a60eaaeda11e5a12df5ca9aab9c4bf4
const $30d94092652e45ad$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "enableBatching_personalSettingsPreferenceFields_EnableBatchingPreferenceFieldMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateNotificationOptionsPayload",
                            "kind": "LinkedField",
                            "name": "updateGlobalNotificationOptions",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraNotificationOptions",
                                    "kind": "LinkedField",
                                    "name": "options",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "enableBatching_personalSettingsPreferenceFields_EnableBatchingPreferenceField"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "enableBatching_personalSettingsPreferenceFields_EnableBatchingPreferenceFieldMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateNotificationOptionsPayload",
                            "kind": "LinkedField",
                            "name": "updateGlobalNotificationOptions",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraNotificationOptions",
                                    "kind": "LinkedField",
                                    "name": "options",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "batchWindow"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "4bc064920e43df38639bc8e57762cc6b2a60eaaeda11e5a12df5ca9aab9c4bf4",
            "metadata": {},
            "name": "enableBatching_personalSettingsPreferenceFields_EnableBatchingPreferenceFieldMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$30d94092652e45ad$var$node.hash = "a4e62f8ffeeff266b9eade8e2b8363a1";
var $30d94092652e45ad$export$2e2bcd8739ae039 = $30d94092652e45ad$var$node;

});

parcelRegister("eTwBU", function(module, exports) {

$parcel$export(module.exports, "default", () => $f76d0d9cc8ae1251$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2e86ad8818506bd90c11bf340bfbd488>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f76d0d9cc8ae1251$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "enableBatching_personalSettingsPreferenceFields_EnableBatchingPreferenceField",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "batchWindow"
            },
            "action": "THROW",
            "path": "batchWindow"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        }
    ],
    "type": "JiraNotificationOptions"
};
$f76d0d9cc8ae1251$var$node.hash = "d1db2d25612b798be82a19d7b2e04325";
var $f76d0d9cc8ae1251$export$2e2bcd8739ae039 = $f76d0d9cc8ae1251$var$node;

});

parcelRegister("fzQ1Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6b3ddbc8d83786f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f6b3ddbc8d83786f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    toggleLabel: {
        "id": "personal-settings-preference-fields.common.enable-batching.toggle-label",
        "defaultMessage": "Group notification emails together"
    },
    infoDialogContent: {
        "id": "personal-settings-preference-fields.common.enable-batching.info-dialog-content",
        "defaultMessage": "Use this setting to choose how often you want to receive grouped email notifications. By default, we\u2019ll email you three minutes after the last issue update. If more updates are made before three minutes is up, we\u2019ll wait another three minutes. After 10 minutes, we\u2019ll email you anyway."
    },
    infoPanelTriggerLabel: {
        "id": "personal-settings-preference-fields.common.enable-batching.info-panel-trigger-label",
        "defaultMessage": "default mode info"
    },
    infoDialogContentIssueTermRefresh: {
        "id": "personal-settings-preference-fields.common.enable-batching.info-dialog-content-issue-term-refresh",
        "defaultMessage": "Use this setting to choose how often you want to receive grouped email notifications. By default, we\u2019ll email you three minutes after the last work item update. If more updates are made before three minutes is up, we\u2019ll wait another three minutes. After 10 minutes, we\u2019ll email you anyway."
    }
});

});


parcelRegister("dt9Hd", function(module, exports) {

$parcel$export(module.exports, "default", () => $3dd940e7b31e24ba$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $3dd940e7b31e24ba$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    wrapperNote: {
        "id": "personal-settings-preference-fields.common.group-notification-emails-wrapper.wrapper-note",
        "defaultMessage": "We'll group together notifications for the same issues into one email. How often do you want to receive these?"
    },
    wrapperNoteIssueTermRefresh: {
        "id": "personal-settings-preference-fields.common.group-notification-emails-wrapper.wrapper-note-issue-term-refresh",
        "defaultMessage": "We'll group together notifications for the same work items into one email. How often do you want to receive these?"
    }
});

});


parcelRegister("3LGU6", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2eaefe6fc1a8494$export$2e2bcd8739ae039);

var $6EPCb = parcelRequire("6EPCb");

var $elQIT = parcelRequire("elQIT");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $2NMNM = parcelRequire("2NMNM");

var $qfj8c = parcelRequire("qfj8c");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $jouoW = parcelRequire("jouoW");

var $jcw0u = parcelRequire("jcw0u");

var $koVbs = parcelRequire("koVbs");

var $9InRy = parcelRequire("9InRy");

var $8zOmE = parcelRequire("8zOmE");

var $koeKL = parcelRequire("koeKL");

var $9BkBA = parcelRequire("9BkBA");
const $a2eaefe6fc1a8494$var$MimeTypePreferenceField = ({ mimeTypeFragment: mimeTypeFragment })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const cloudId = (0, $koeKL.useCloudId)();
    const { showErrorFlag: showErrorFlag } = (0, $9InRy.useShowErrorFlag)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const data = (0, $8Uumt.useFragment)((0, $elQIT.default), mimeTypeFragment);
    const [commit] = (0, $8Uumt.useMutation)((0, $6EPCb.default));
    const mimeTypeOptions = (0, $5uXOq.useMemo)(()=>[
            {
                label: 'HTML',
                value: 'HTML'
            },
            {
                label: formatMessage((0, $9BkBA.default).optionText),
                value: 'TEXT'
            }
        ], [
        formatMessage
    ]);
    const selectedOption = mimeTypeOptions.find((option)=>option.value === data.emailMimeType);
    const handleChange = (0, $5uXOq.useCallback)((event)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const option = event.target.value;
        if (option) commit({
            variables: {
                cloudId: cloudId,
                input: {
                    emailMimeType: option
                }
            },
            optimisticResponse: {
                jira: {
                    updateGlobalNotificationOptions: {
                        success: true,
                        errors: [],
                        options: {
                            id: data.id,
                            isEmailMimeTypeEditable: data.isEmailMimeTypeEditable,
                            emailMimeType: option
                        }
                    }
                }
            },
            onError: (error)=>{
                showErrorFlag();
                (0, $jcw0u.default)({
                    meta: {
                        id: 'mutateMimeTypePreference',
                        packageName: 'jiraPersonalSettingsPreferenceFields',
                        teamName: 'jira-notifications-platform'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            },
            onCompleted: (response)=>{
                const errors = response?.jira?.updateGlobalNotificationOptions?.errors;
                if (errors && errors?.length > 0) {
                    showErrorFlag();
                    errors.forEach((error)=>{
                        (0, $jcw0u.default)({
                            meta: {
                                id: 'mutateMimeTypePreferenceCompletedError',
                                packageName: 'jiraPersonalSettingsPreferenceFields',
                                teamName: 'jira-notifications-platform'
                            },
                            error: new Error(error?.message || 'Unknown Error'),
                            sendToPrivacyUnsafeSplunk: true
                        });
                    });
                } else (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'mutateMimeTypePreference success');
            }
        });
    }, [
        cloudId,
        commit,
        createAnalyticsEvent,
        data.id,
        data.isEmailMimeTypeEditable,
        showErrorFlag
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $a2eaefe6fc1a8494$var$radioBoxStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jouoW.default), {
        value: mimeTypeOptions[0].value,
        label: mimeTypeOptions[0].label,
        name: mimeTypeOptions[0].value,
        testId: "personal-settings-preference-fields.common.ui.mime-type.radio-html",
        isChecked: selectedOption === mimeTypeOptions[0],
        onChange: handleChange
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jouoW.default), {
        value: mimeTypeOptions[1].value,
        label: mimeTypeOptions[1].label,
        name: mimeTypeOptions[1].value,
        testId: "personal-settings-preference-fields.common.ui.mime-type.radio-text",
        isChecked: selectedOption === mimeTypeOptions[1],
        onChange: handleChange,
        isDisabled: !data.isEmailMimeTypeEditable
    })), !data.isEmailMimeTypeEditable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.HelperMessage), {
        testId: "personal-settings-preference-fields.common.ui.mime-type.helper-message"
    }, formatMessage((0, $9BkBA.default).description)));
};
const $a2eaefe6fc1a8494$var$radioBoxStyles = (0, $8CUq3.xcss)({
    marginBottom: 'space.100'
});
var $a2eaefe6fc1a8494$export$2e2bcd8739ae039 = $a2eaefe6fc1a8494$var$MimeTypePreferenceField;

});
parcelRegister("6EPCb", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c3e68941f6e786c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4c44e9c5f5ae3c268e81b9caca161a54>>
 * @relayHash d1a990f1bcd9708d3b6b3074bc4a9a41
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4e255e32d1c9934d3c8bc35a592c5d2155ddccd366406829758d570afdcffd3d
const $5c3e68941f6e786c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "mimeType_personalSettingsPreferenceFields_MimeTypePreferenceFieldMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateNotificationOptionsPayload",
                            "kind": "LinkedField",
                            "name": "updateGlobalNotificationOptions",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraNotificationOptions",
                                    "kind": "LinkedField",
                                    "name": "options",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "mimeType_personalSettingsPreferenceFields_MimeTypePreferenceField"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "mimeType_personalSettingsPreferenceFields_MimeTypePreferenceFieldMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateNotificationOptionsPayload",
                            "kind": "LinkedField",
                            "name": "updateGlobalNotificationOptions",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraNotificationOptions",
                                    "kind": "LinkedField",
                                    "name": "options",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "emailMimeType"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isEmailMimeTypeEditable"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "4e255e32d1c9934d3c8bc35a592c5d2155ddccd366406829758d570afdcffd3d",
            "metadata": {},
            "name": "mimeType_personalSettingsPreferenceFields_MimeTypePreferenceFieldMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$5c3e68941f6e786c$var$node.hash = "7e95e63201e95d82104282c7ab474b5c";
var $5c3e68941f6e786c$export$2e2bcd8739ae039 = $5c3e68941f6e786c$var$node;

});

parcelRegister("elQIT", function(module, exports) {

$parcel$export(module.exports, "default", () => $3762e30dffc06931$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<06743b0678d8774cd5fce06af8471cde>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3762e30dffc06931$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "mimeType_personalSettingsPreferenceFields_MimeTypePreferenceField",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "emailMimeType"
            },
            "action": "THROW",
            "path": "emailMimeType"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "isEmailMimeTypeEditable"
            },
            "action": "THROW",
            "path": "isEmailMimeTypeEditable"
        }
    ],
    "type": "JiraNotificationOptions"
};
$3762e30dffc06931$var$node.hash = "46917d18330cb3a196b7f51f1ccdb2d0";
var $3762e30dffc06931$export$2e2bcd8739ae039 = $3762e30dffc06931$var$node;

});

parcelRegister("jouoW", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d22fafff331be84$export$2e2bcd8739ae039);
/* radio.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $6QvkM = parcelRequire("6QvkM");

var $eGmKJ = parcelRequire("eGmKJ");

var $VSDnB = parcelRequire("VSDnB");
const $5d22fafff331be84$var$packageName = "platform-pkg";
const $5d22fafff331be84$var$packageVersion = "0.0.0-use.local";
const $5d22fafff331be84$var$noop = (0, $eGmKJ.default);
const $5d22fafff331be84$var$labelPaddingStyles = null;
const $5d22fafff331be84$var$labelStyles = null;
const $5d22fafff331be84$var$radioStyles = null;
const $5d22fafff331be84$var$newRadioStyles = null;
const $5d22fafff331be84$var$InnerRadio = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function Radio(props, ref) {
    const { ariaLabel: ariaLabel, isDisabled: isDisabled = false, isRequired: isRequired, isInvalid: isInvalid = false, isChecked: isChecked = false, label: label, name: name, onChange: onChange = $5d22fafff331be84$var$noop, value: value, testId: testId, analyticsContext: analyticsContext, // events and all other input props
    ...rest } = props;
    const onChangeAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'radio',
        packageName: $5d22fafff331be84$var$packageName,
        packageVersion: $5d22fafff331be84$var$packageVersion
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("label", {
        "data-testid": testId && `${testId}--radio-label`,
        "data-disabled": isDisabled ? 'true' : undefined,
        className: (0, $bwpsq.default)([
            "_11c82smr _1e0c1txw _vchhusvi _kqswh2mm _4cvr1y6m _syazj3m3 _mqf81tvo _g7st13gf"
        ]),
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                ...rest,
                tabIndex: 0,
                "aria-label": ariaLabel,
                checked: isChecked,
                disabled: isDisabled,
                name: name,
                onChange: onChangeAnalytics,
                required: isRequired,
                type: "radio",
                value: value,
                "data-testid": testId && `${testId}--radio-input`,
                // use :invalid selector
                "data-invalid": isInvalid ? 'true' : undefined,
                ref: ref,
                className: (0, $bwpsq.default)([
                    "_18s8ze3t _19it3vzd _2rko1q5u _12ji1r31 _1qu2glyw _12y31o36 _v56415j1 _1e0c1txw _1bsb1tcg _4t3i1tcg _kqswh2mm _4cvr1h6o _1bah1h6o _1o9zidpf _bfhk4t47 _13diglyw _1q6qmag2 _11511fmg _1s6w1qbb _tqbwidpf _t9ec1s1q _s7n4jp4b _wstuglyw _16r2ucr4 _14mj1q5u _qc5orqeg _z0ai1cbz _1qdg1cbz _18postnw _aetrb3bt _1peq1xmd _iosizyvw _11jyzyvw _f3ett94y _19ybk8x7 _1d7pk8x7 _j5dh13gf _scgf13gf _1gcs13gf _1x1a13gf _6hp813gf _4rya1y1w _o1bd1y1w _nxi61y1w _neoe1y1w _1el21y1w _lekrzcs9 _11v7zcs9 _1f8czcs9 _s2ftzcs9 _17a1zcs9 _x48a15t7 _1ib215t7 _1yk915t7 _gdmb15t7 _pmm415t7 _y2mvehbj _1bg4jfq9 _6tjkehbj _awqnjfq9 _1rvq10ko _1p9j1fmg _x2tzhh5a _1iwzhh5a _sj8y1wq0 _jckox2ru _1dvd1fmg _60ak1dzn",
                    (0, $VSDnB.fg)('platform-visual-refresh-icons') && "_t9ec1soj _z0ai120g _1qdg120g"
                ])
            }),
            label ? /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                className: (0, $bwpsq.default)([
                    "_85i5v77o _1q51v77o _y4ti1b66 _bozg1b66"
                ]),
                children: label
            }) : null
        ]
    });
}); /**
     * __Radio__
     *
     * A radio input allows users to select only one option from a number of choices. Radio is generally displayed in a radio group.
     *
     * - [Examples](https://atlassian.design/components/radio/examples)
     * - [Code](https://atlassian.design/components/radio/code)
     * - [Usage](https://atlassian.design/components/radio/usage)
     */ 
const $5d22fafff331be84$var$Radio = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function Radio(props, ref) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)($5d22fafff331be84$var$InnerRadio, {
        ...props,
        ref: ref
    });
}));
var $5d22fafff331be84$export$2e2bcd8739ae039 = $5d22fafff331be84$var$Radio;

});

parcelRegister("9BkBA", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5a2e7cc580e5d72$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b5a2e7cc580e5d72$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    dropdownTitle: {
        "id": "personal-settings-preference-fields.common.mime-type.dropdown-title",
        "defaultMessage": "Email notifications format"
    },
    optionText: {
        "id": "personal-settings-preference-fields.common.mime-type.option-text",
        "defaultMessage": "Text"
    },
    description: {
        "id": "personal-settings-preference-fields.common.mime-type.description",
        "defaultMessage": "Your email notification format is set to HTML since your organization has signed up for HIPAA"
    },
    mimeTypeFieldLabel: {
        "id": "personal-settings-preference-fields.common.mime-type.mime-type-field-label",
        "defaultMessage": "Email format"
    }
});

});


parcelRegister("4aN0x", function(module, exports) {

$parcel$export(module.exports, "NotifyOwnChangesPreferenceField", () => $2ed1378300730a42$export$2638b4456f2a8667);

var $dYLr2 = parcelRequire("dYLr2");

var $ewVDV = parcelRequire("ewVDV");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $2NMNM = parcelRequire("2NMNM");

var $kkJfY = parcelRequire("kkJfY");

var $2x3Cb = parcelRequire("2x3Cb");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $jcw0u = parcelRequire("jcw0u");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $9InRy = parcelRequire("9InRy");

var $8zOmE = parcelRequire("8zOmE");

var $koeKL = parcelRequire("koeKL");

var $9dEdH = parcelRequire("9dEdH");
const $2ed1378300730a42$export$2638b4456f2a8667 = ({ notifyOwnChangesEnabledFragment: notifyOwnChangesEnabledFragment })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const cloudId = (0, $koeKL.useCloudId)();
    const { showErrorFlag: showErrorFlag } = (0, $9InRy.useShowErrorFlag)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const data = (0, $8Uumt.useFragment)((0, $ewVDV.default), notifyOwnChangesEnabledFragment);
    const [commit] = (0, $8Uumt.useMutation)((0, $dYLr2.default));
    const handleOnChange = (option)=>{
        if (option) commit({
            variables: {
                cloudId: cloudId,
                input: {
                    notifyOwnChangesEnabled: option.currentTarget.checked
                }
            },
            optimisticResponse: {
                jira: {
                    updateGlobalNotificationOptions: {
                        success: true,
                        errors: [],
                        options: {
                            id: data.id,
                            notifyOwnChangesEnabled: option.currentTarget.checked
                        }
                    }
                }
            },
            onError: (error)=>{
                showErrorFlag();
                (0, $jcw0u.default)({
                    meta: {
                        id: 'mutateNotifyOwnChangesEnabledPreference',
                        packageName: 'jiraPersonalSettingsPreferenceFields',
                        teamName: 'jira-notifications-platform'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            },
            onCompleted: (response)=>{
                const errors = response?.jira?.updateGlobalNotificationOptions?.errors;
                if (errors && errors?.length > 0) {
                    showErrorFlag();
                    errors.forEach((error)=>{
                        (0, $jcw0u.default)({
                            meta: {
                                id: 'mutateNotifyOwnChangesEnabledPreferenceCompletedError',
                                packageName: 'jiraPersonalSettingsPreferenceFields',
                                teamName: 'jira-notifications-platform'
                            },
                            error: new Error(error?.message || 'Unknown Error'),
                            sendToPrivacyUnsafeSplunk: true
                        });
                    });
                } else (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'mutateNotifyOwnChangesEnabledPreference success');
            }
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2x3Cb.Label), {
        htmlFor: "notify-own-changes-checkbox"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kkJfY.default), {
        id: "notify-own-changes-checkbox",
        isChecked: !!data.notifyOwnChangesEnabled,
        onChange: handleOnChange,
        testId: "personal-settings-preference-fields.common.ui.notify-own-changes.checkbox"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingInlineStart: "space.100",
        testId: "personal-settings-preference-fields.common.ui.notify-own-changes.toggle",
        xcss: $2ed1378300730a42$var$labelStyles
    }, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $9dEdH.default).checkboxLabelIssueTermRefresh : (0, $9dEdH.default).checkboxLabel))));
};
const $2ed1378300730a42$var$labelStyles = (0, $8CUq3.xcss)({
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    marginRight: 'space.100'
});

});
parcelRegister("dYLr2", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a7474bbf3947fef$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5be604e529cfb8aa5c9260e528ac5c52>>
 * @relayHash d06b98e23b0d9f167cc6552fa6c9ead6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0513f0d42a6bc982c2e943742f38e9638c694449a85ec61a4af7cc4b7dc15bf8
const $0a7474bbf3947fef$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "notifyOwnChanges_personalSettingsPreferenceFields_NotifyOwnChangesEnabledPreferenceFieldMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateNotificationOptionsPayload",
                            "kind": "LinkedField",
                            "name": "updateGlobalNotificationOptions",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraNotificationOptions",
                                    "kind": "LinkedField",
                                    "name": "options",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "notifyOwnChanges_personalSettingsPreferenceFields_NotifyOwnChangesPreferenceField"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "notifyOwnChanges_personalSettingsPreferenceFields_NotifyOwnChangesEnabledPreferenceFieldMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateNotificationOptionsPayload",
                            "kind": "LinkedField",
                            "name": "updateGlobalNotificationOptions",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraNotificationOptions",
                                    "kind": "LinkedField",
                                    "name": "options",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "notifyOwnChangesEnabled"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "0513f0d42a6bc982c2e943742f38e9638c694449a85ec61a4af7cc4b7dc15bf8",
            "metadata": {},
            "name": "notifyOwnChanges_personalSettingsPreferenceFields_NotifyOwnChangesEnabledPreferenceFieldMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$0a7474bbf3947fef$var$node.hash = "4741a5c35d13a6df6f5a96236f525a52";
var $0a7474bbf3947fef$export$2e2bcd8739ae039 = $0a7474bbf3947fef$var$node;

});

parcelRegister("ewVDV", function(module, exports) {

$parcel$export(module.exports, "default", () => $232290f6fa8ce5c6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6f49f537e3cf0bf740ddfecdfbb9e47a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $232290f6fa8ce5c6$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "notifyOwnChanges_personalSettingsPreferenceFields_NotifyOwnChangesPreferenceField",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        },
        {
            "kind": "ScalarField",
            "name": "notifyOwnChangesEnabled"
        }
    ],
    "type": "JiraNotificationOptions"
};
$232290f6fa8ce5c6$var$node.hash = "0770bc0487be60d78cf1a64f40e601ec";
var $232290f6fa8ce5c6$export$2e2bcd8739ae039 = $232290f6fa8ce5c6$var$node;

});

parcelRegister("9dEdH", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b687c8939d12892$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $8b687c8939d12892$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    toggleLabel: {
        "id": "personal-settings-preference-fields.common.notify-own-changes.toggle-label",
        "defaultMessage": "Receive emails when you make changes to issues"
    },
    checkboxLabel: {
        "id": "personal-settings-preference-fields.common.notify-own-changes.checkbox-label",
        "defaultMessage": "You make changes to issues"
    },
    toggleLabelIssueTermRefresh: {
        "id": "personal-settings-preference-fields.common.notify-own-changes.toggle-label-issue-term-refresh",
        "defaultMessage": "Receive emails when you make changes to work items"
    },
    checkboxLabelIssueTermRefresh: {
        "id": "personal-settings-preference-fields.common.notify-own-changes.checkbox-label-issue-term-refresh",
        "defaultMessage": "You make changes to work items"
    }
});

});


parcelRegister("55i55", function(module, exports) {

$parcel$export(module.exports, "NotifyWhenRoleIsReporter", () => $d78b50b96cfab884$export$e656997f9048591a);

var $hBxoa = parcelRequire("hBxoa");

var $4uESP = parcelRequire("4uESP");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $2NMNM = parcelRequire("2NMNM");

var $kkJfY = parcelRequire("kkJfY");

var $2x3Cb = parcelRequire("2x3Cb");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $jcw0u = parcelRequire("jcw0u");

var $koVbs = parcelRequire("koVbs");

var $9InRy = parcelRequire("9InRy");

var $8zOmE = parcelRequire("8zOmE");

var $koeKL = parcelRequire("koeKL");

var $2tCDf = parcelRequire("2tCDf");
const $d78b50b96cfab884$export$e656997f9048591a = ({ reporterRolePreferenceFragment: reporterRolePreferenceFragment })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const cloudId = (0, $koeKL.useCloudId)();
    const { showErrorFlag: showErrorFlag } = (0, $9InRy.useShowErrorFlag)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const data = (0, $8Uumt.useFragment)((0, $4uESP.default), reporterRolePreferenceFragment);
    const [commit] = (0, $8Uumt.useMutation)((0, $hBxoa.default));
    const handleOnChange = (option)=>{
        if (option) commit({
            variables: {
                cloudId: cloudId,
                input: {
                    notifyWhenRoleReporterEnabled: option.currentTarget.checked
                }
            },
            optimisticResponse: {
                jira: {
                    updateGlobalNotificationOptions: {
                        success: true,
                        errors: [],
                        options: {
                            id: data.id,
                            notifyWhenRoleReporterEnabled: option.currentTarget.checked
                        }
                    }
                }
            },
            onError: (error)=>{
                showErrorFlag();
                (0, $jcw0u.default)({
                    meta: {
                        id: 'mutateNotifyWhenRoleReporterEnabled',
                        packageName: 'jiraPersonalSettingsPreferenceFields',
                        teamName: 'jira-notifications-platform'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            },
            onCompleted: (response)=>{
                const errors = response?.jira?.updateGlobalNotificationOptions?.errors;
                if (errors && errors?.length > 0) {
                    showErrorFlag();
                    errors.forEach((error)=>{
                        (0, $jcw0u.default)({
                            meta: {
                                id: 'mutateNotifyWhenRoleReporterEnabledPreferenceCompletedError',
                                packageName: 'jiraPersonalSettingsPreferenceFields',
                                teamName: 'jira-notifications-platform'
                            },
                            error: new Error(error?.message || 'Unknown Error'),
                            sendToPrivacyUnsafeSplunk: true
                        });
                    });
                } else (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'mutateNotifyWhenRoleReporterEnabledPreference success');
            }
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2x3Cb.Label), {
        htmlFor: "notify-when-role-reporter-enabled-checkbox"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kkJfY.default), {
        id: "notify-when-role-reporter-enabled-checkbox",
        isChecked: !!data.notifyWhenRoleReporterEnabled,
        onChange: handleOnChange,
        testId: "personal-settings-preference-fields.common.ui.reporter-role.checkbox"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingInlineStart: "space.100",
        testId: "personal-settings-preference-fields.common.ui.reporter-role.toggle",
        xcss: $d78b50b96cfab884$var$labelStyles
    }, formatMessage((0, $2tCDf.default).checkboxLabel))));
};
const $d78b50b96cfab884$var$labelStyles = (0, $8CUq3.xcss)({
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    marginRight: 'space.100'
});

});
parcelRegister("hBxoa", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a292967c9bdd239$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b63860f5eb783d0afa09e5a04381fd18>>
 * @relayHash 71a9b991fdc73342916469c8ec508201
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1a7407c36f74ab70d49c98d11b36ab3b87e28036c449aba3a021ca61e0a0ca70
const $9a292967c9bdd239$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "reporterRole_personalSettingsPreferenceFields_NotifyWhenRoleIsReporterFieldMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateNotificationOptionsPayload",
                            "kind": "LinkedField",
                            "name": "updateGlobalNotificationOptions",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraNotificationOptions",
                                    "kind": "LinkedField",
                                    "name": "options",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "reporterRole_personalSettingsPreferenceFields_NotifyWhenRoleIsReporter"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "reporterRole_personalSettingsPreferenceFields_NotifyWhenRoleIsReporterFieldMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraUpdateNotificationOptionsPayload",
                            "kind": "LinkedField",
                            "name": "updateGlobalNotificationOptions",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraNotificationOptions",
                                    "kind": "LinkedField",
                                    "name": "options",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "notifyWhenRoleReporterEnabled"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "1a7407c36f74ab70d49c98d11b36ab3b87e28036c449aba3a021ca61e0a0ca70",
            "metadata": {},
            "name": "reporterRole_personalSettingsPreferenceFields_NotifyWhenRoleIsReporterFieldMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$9a292967c9bdd239$var$node.hash = "9c4c361aadb9dccd91d2e01482df400f";
var $9a292967c9bdd239$export$2e2bcd8739ae039 = $9a292967c9bdd239$var$node;

});

parcelRegister("4uESP", function(module, exports) {

$parcel$export(module.exports, "default", () => $961b6751b35ec2cf$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0d5675471bc09b7ad426cc73d9a915ac>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $961b6751b35ec2cf$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "reporterRole_personalSettingsPreferenceFields_NotifyWhenRoleIsReporter",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        },
        {
            "kind": "ScalarField",
            "name": "notifyWhenRoleReporterEnabled"
        }
    ],
    "type": "JiraNotificationOptions"
};
$961b6751b35ec2cf$var$node.hash = "4b74d988a38dc868c149c718ee77d4a1";
var $961b6751b35ec2cf$export$2e2bcd8739ae039 = $961b6751b35ec2cf$var$node;

});

parcelRegister("2tCDf", function(module, exports) {

$parcel$export(module.exports, "default", () => $26b0a33b9d380c4e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $26b0a33b9d380c4e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    checkboxLabel: {
        "id": "personal-settings-preference-fields.common.reporter-role.checkbox-label",
        "defaultMessage": "You're the reporter"
    }
});

});


parcelRegister("lTuLD", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e9642865a623706$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $3e9642865a623706$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    wrapperNote: {
        "id": "personal-settings-preference-fields.notification-preferences-options-wrapper.wrapper-note",
        "defaultMessage": "Receive emails when:"
    },
    emailFormatNote: {
        "id": "personal-settings-preference-fields.notification-preferences-options-wrapper.email-format-note",
        "defaultMessage": "How do you like your emails?"
    },
    emailFormatHeading: {
        "id": "personal-settings-preference-fields.notification-preferences-options-wrapper.email-format-heading",
        "defaultMessage": "Email format"
    }
});

});


parcelRegister("8NIyn", function(module, exports) {

$parcel$export(module.exports, "default", () => $f61219bca783f6fd$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f61219bca783f6fd$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    notificationsPageTitle: {
        "id": "personal-settings-notifications.notifications-page-title",
        "defaultMessage": "Project and issue notifications"
    },
    notificationsExplanation: {
        "id": "personal-settings-notifications.notifications-explanation",
        "defaultMessage": "Control when you receive email or in-product notifications from Jira. You can change these settings at any time. "
    },
    notificationsSettingsHelper: {
        "id": "personal-settings-notifications.notifications-settings-helper",
        "defaultMessage": "Learn more about managing your notifications."
    },
    notificationProjectSettingsHeading: {
        "id": "personal-settings-notifications.notification-project-settings-heading",
        "defaultMessage": "Customize project notifications"
    },
    notificationProjectSettingsDescription: {
        "id": "personal-settings-notifications.notification-project-settings-description",
        "defaultMessage": "Make your notifications specific to your project needs. Choose a project to set customized notifications."
    },
    notificationProjectSettingsAddProjectNotificationsButtonText: {
        "id": "personal-settings-notifications.notification-project-settings-add-project-notifications-button-text",
        "defaultMessage": "Add project notifications"
    },
    notificationEmailPreferencesHeading: {
        "id": "personal-settings-notifications.notification-email-preferences-heading",
        "defaultMessage": "Email preferences"
    },
    notificationEmailPreferencesDescriptionWithBatching: {
        "id": "personal-settings-notifications.notification-email-preferences-description-with-batching",
        "defaultMessage": "Tell us what kind of email updates you want to receive, and how often we should send you notifications via email."
    },
    notificationsPageTitleIssueTermRefresh: {
        "id": "personal-settings-notifications.notifications-page-title-issue-term-refresh",
        "defaultMessage": "Notifications for projects and work items"
    }
});

});



parcelRegister("5rqex", function(module, exports) {

$parcel$export(module.exports, "checkAndEmitApdexSignal", () => $ab527e70454bab7e$export$3082c88b693a5230);
$parcel$export(module.exports, "default", () => $ab527e70454bab7e$export$2e2bcd8739ae039);
$parcel$export(module.exports, "baseDefaultProps", () => $ab527e70454bab7e$export$9b3029ee6188a41f);

var $5uXOq = parcelRequire("5uXOq");

var $99gkn = parcelRequire("99gkn");

var $aOr3t = parcelRequire("aOr3t");

var $1u4q7 = parcelRequire("1u4q7");

var $1AZST = parcelRequire("1AZST");

var $6G6w0 = parcelRequire("6G6w0");

var $3wLoG = parcelRequire("3wLoG");

var $gtdbK = parcelRequire("gtdbK");

var $zbAs4 = parcelRequire("zbAs4");

var $3B7oW = parcelRequire("3B7oW");
const $ab527e70454bab7e$export$3082c88b693a5230 = (appName, metricKey)=>{
    var emitSignal;
};
class $ab527e70454bab7e$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isExpectedToHaveSsr: false,
            withMarks: [],
            extra: {},
            emitOnAnimationFrame: false
        };
    }
    render() {
        const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        $ab527e70454bab7e$export$3082c88b693a5230(appName, metricKey);
        const isUFODefined = (0, $1AZST.GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
        if (isUFODefined) (0, $zbAs4.addUFOSSRDoneAsFMPToInteraction)();
        if (metric) {
            // https://product-fabric.atlassian.net/browse/UFO-323
            (0, $gtdbK.addBM3SSRDoneAsFMPToInteraction)(metric);
            (0, $3B7oW.trackBM3FeatureFlagsAccessed)(metric);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $99gkn.default), {
            data: extra
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aOr3t.UFOBM3TimingsToUFO), {
            marks: metric?.getData()?.marks,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            timings: metric?.getData()?.config?.timings
        }), isUFODefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3wLoG.StopUfo), {
            appName: appName,
            customData: extra,
            key: (0, $1u4q7.getInteractionId)().current
        }) : metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6G6w0.StopBrowserMetrics3), {
            metric: metric,
            customData: extra,
            emitOnAnimationFrame: emitOnAnimationFrame
        }));
    }
}
const $ab527e70454bab7e$export$9b3029ee6188a41f = $ab527e70454bab7e$export$2e2bcd8739ae039.defaultProps;

});
parcelRegister("aOr3t", function(module, exports) {

$parcel$export(module.exports, "getBm3Timings", () => $a3e67858f0c2f8da$export$f02972da195a43bb);
$parcel$export(module.exports, "UFOBM3TimingsToUFO", () => $a3e67858f0c2f8da$export$30f0b5e5acd268bf);
$parcel$export(module.exports, "addBM3TimingsToUFO", () => $a3e67858f0c2f8da$export$d93d677ef2f33c5c);

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");
function $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $a3e67858f0c2f8da$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $5uXOq.useContext)((0, $1tcYS.default));
    const interactionId = (0, $1u4q7.getInteractionId)().current;
    (0, $5uXOq.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $bFU4G.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $a3e67858f0c2f8da$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $1u4q7.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $bFU4G.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timingsConfig);
        (0, $bFU4G.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("6G6w0", function(module, exports) {

$parcel$export(module.exports, "StopBrowserMetrics3", () => $84d0d168ebb35c8a$export$575e93c0f9905999);

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");

var $21pfT = parcelRequire("21pfT");

var $x9xyg = parcelRequire("x9xyg");

var $7N30e = parcelRequire("7N30e");

var $4dRjY = parcelRequire("4dRjY");

var $2SVPM = parcelRequire("2SVPM");

var $6b6Tk = parcelRequire("6b6Tk");

const $84d0d168ebb35c8a$var$emitMetrics = (metric, customData, stopTime)=>{
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    if (stopTime !== undefined) metric.stop({
        customData: customData,
        stopTime: stopTime
    });
    else metric.stop({
        customData: customData
    });
    if ((0, $6b6Tk.isAutomaticExposureCollectionEnabled)()) (0, $7N30e.stopLowPriorityEventDelay)();
};
class $84d0d168ebb35c8a$export$575e93c0f9905999 extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        if (!metric) return;
        const start = (0, $21pfT.browserMetrics).getPageLoadMetric()?.getData()?.start || 0;
        (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_START', {
            startTime: start
        });
        (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_END');
        (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
        const bm3Data = metric.getData();
        if (emitOnAnimationFrame) {
            const stopTime = performance.now();
            (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $4dRjY.PRODUCT_START_MARK), true);
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
            if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_TASK_END');
                (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
            });
            requestAnimationFrame(()=>{
                metric.mark((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, $x9xyg.setMark)((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $ce556f125dee8174$export$99c08ec92759c71c));
                setTimeout(()=>{
                    $84d0d168ebb35c8a$var$emitMetrics(metric, customData, stopTime);
                }, 500);
            });
        } else {
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: performance.now()
            });
            (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $4dRjY.PRODUCT_START_MARK), true);
            $84d0d168ebb35c8a$var$emitMetrics(metric, customData);
        }
    }
    static{
        this.contextType = (0, $1tcYS.default);
    }
    render() {
        return null;
    }
}

});
parcelRegister("4dRjY", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_START_MARK", () => $9953c23a4f71adac$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $9953c23a4f71adac$export$2a999c5f84501025);

var $x9xyg = parcelRequire("x9xyg");
const $9953c23a4f71adac$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $9953c23a4f71adac$export$2a999c5f84501025 = ()=>{
    if (!false) {
        performance.clearMarks($9953c23a4f71adac$export$8e54fca0a680fdfd);
        (0, $x9xyg.setMark)($9953c23a4f71adac$export$8e54fca0a680fdfd);
    }
    return null;
};

});

const $ce556f125dee8174$export$56940a9488e85199 = 'jira.fe.spa-';
const $ce556f125dee8174$export$45c4b6bf7935c69a = `${$ce556f125dee8174$export$56940a9488e85199}start`;
const $ce556f125dee8174$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $ce556f125dee8174$export$ff834eccc35b9089 = 'appBundleReady';
const $ce556f125dee8174$export$86b05e34d462ead8 = 'prefetchApiReady';
const $ce556f125dee8174$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $ce556f125dee8174$export$3ae43cc1782d058f = 'jswRenderStart';
const $ce556f125dee8174$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $ce556f125dee8174$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $ce556f125dee8174$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $ce556f125dee8174$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $ce556f125dee8174$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $ce556f125dee8174$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $ce556f125dee8174$export$99c08ec92759c71c = 'tti-raf-mark';
const $ce556f125dee8174$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("3wLoG", function(module, exports) {

$parcel$export(module.exports, "StopUfo", () => $bc9c50f4292c4530$export$d91154f099475c5);

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");

var $1AZST = parcelRequire("1AZST");
class $bc9c50f4292c4530$export$d91154f099475c5 extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { customData: customData, appName: appName } = this.props;
        (0, $1AZST.GlobalPageLoadExperience).success({
            force: true,
            metadata: customData
        });
        const name = appName || (0, $1AZST.GlobalPageLoadExperience).loadingPageLoadId;
        if (name) this.context?.addApdex({
            key: name,
            stopTime: performance.now()
        });
    }
    static{
        this.contextType = (0, $1tcYS.default);
    }
    render() {
        return null;
    }
}

});

parcelRegister("gtdbK", function(module, exports) {

$parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", () => $9088c71f7c9189f4$export$bf239ac2bfb04967);

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");
function $9088c71f7c9189f4$export$bf239ac2bfb04967(metric) {
    const interactionId = (0, $1u4q7.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // Use BM3 SSR mark as FMP config for UFO if it exists, temporarily.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && data?.isInitial) (0, $bFU4G.addMetadata)(currentInteractionId, {
        __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
    });
}

});

parcelRegister("zbAs4", function(module, exports) {

$parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", () => $30d390cd1767d57f$export$e63862cd888fe05a);

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");

var $1AZST = parcelRequire("1AZST");
var $49z18 = parcelRequire("49z18");
async function $30d390cd1767d57f$export$e63862cd888fe05a() {
    const interactionId = (0, $1u4q7.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    // Use UFO SSR mark as FMP config for rUFO if it exists, temporarily.
    const data = await (0, $1AZST.GlobalPageLoadExperience).exportData();
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, $49z18.payloadPublisher).ssr?.getDoneMark();
    if (data.initial && fmpMark) (0, $bFU4G.addMetadata)(currentInteractionId, {
        __legacy__ufoConfigSSRDoneAsFmp: true
    });
}

});

parcelRegister("3B7oW", function(module, exports) {

$parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", () => $afa764d83f81f55e$export$f00f1e874ce869e9);

var $1u4q7 = parcelRequire("1u4q7");

var $y7eb2 = parcelRequire("y7eb2");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$startsAsObject = (value)=>{
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$isString = (input)=>{
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
const $afa764d83f81f55e$export$7b4abba432e57989 = (value)=>$afa764d83f81f55e$var$isString(value) && $afa764d83f81f55e$var$startsAsObject(value) || $afa764d83f81f55e$var$isObject(value);
const $afa764d83f81f55e$export$fcc03ee4c944962f = (featureFlagValue)=>$afa764d83f81f55e$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
const $afa764d83f81f55e$export$d2818866b4acbea4 = new Map();
const $afa764d83f81f55e$export$f00f1e874ce869e9 = (metric)=>{
    const interactionId = (0, $1u4q7.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && config?.featureFlags?.length) {
        const allFeatureFlags = (0, $y7eb2.default)();
        config.featureFlags.forEach((featureFlagName)=>{
            const value = allFeatureFlags[featureFlagName];
            if (value === undefined) return;
            const featureFlagValue = $afa764d83f81f55e$export$fcc03ee4c944962f(value);
            $afa764d83f81f55e$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
        });
    }
};

});


parcelRegister("9dbF6", function(module, exports) {

$parcel$export(module.exports, "SubProductUpdater", () => $5979c081afa32bfa$export$eb40d3df56aa5c53);

var $5uXOq = parcelRequire("5uXOq");

var $5h5Fg = parcelRequire("5h5Fg");

var $3iTiR = parcelRequire("3iTiR");

var $ero6m = parcelRequire("ero6m");

var $54I24 = parcelRequire("54I24");

var $8OHH4 = parcelRequire("8OHH4");
const $5979c081afa32bfa$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
    const subProduct = (0, $8OHH4.isSubProductProps)(props) ? props.subProduct : (0, $ero6m.getSubProductFromProjectType)(props.projectType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5h5Fg.default), {
        op: (0, $54I24.default),
        args: [
            subProduct,
            allowMonolithDeferral
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3iTiR.default), {
        subProduct: subProduct
    }));
};

});
parcelRegister("3iTiR", function(module, exports) {

$parcel$export(module.exports, "default", () => $1214b0731559b377$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $01Rn4 = parcelRequire("01Rn4");

var $hFChZ = parcelRequire("hFChZ");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1214b0731559b377$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $01Rn4.default), {
        op: (0, $hFChZ.default),
        args: [
            subProduct
        ]
    });

});
parcelRegister("hFChZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e606430ead76cd8$export$2e2bcd8739ae039);

var $2YZCu = parcelRequire("2YZCu");

var $eusud = parcelRequire("eusud");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0e606430ead76cd8$export$2e2bcd8739ae039 = (subProduct)=>{
    (0, $eusud.performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
        (0, $2YZCu.default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
    });
};

});


parcelRegister("ero6m", function(module, exports) {

$parcel$export(module.exports, "getSubProductFromProjectType", () => $0997694844c8a9e7$export$b1fe420ed15dff7b);

var $16v4H = parcelRequire("16v4H");
const $0997694844c8a9e7$export$b1fe420ed15dff7b = (projectType)=>{
    // for Analytics only 'product_discovery' is mapped to 'polaris'. In other cases it is mapped to 'software'
    if (projectType === 'product_discovery') return 'polaris';
    return (0, $16v4H.subProductFromProjectType)(projectType);
};

});

parcelRegister("54I24", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcbbcd48ca398ed4$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $7T84i = parcelRequire("7T84i");
var $9B86Q = parcelRequire("9B86Q");
var $cQZXC = parcelRequire("cQZXC");


var $2YZCu = parcelRequire("2YZCu");

var $fjcgS = parcelRequire("fjcgS");
const $bcbbcd48ca398ed4$var$maybeDelayAndRace = (// @ts-expect-error - TS2304 - Cannot find name 'Deferred'.
maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
        maybeWaitPromise.then(getDefaultPromise),
        getRacePromise()
    ]) : getDefaultPromise();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bcbbcd48ca398ed4$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
    (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
        client.setSubProduct(subProduct);
        if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
            solutions: [
                (0, $86344d58e71e925a$export$c8b406ad8ee0dab9)
            ]
        });
        else client.removeUIViewedAttribute('solutions');
    });
    // IMPORTANT -
    // Until such time as all pre-TTI WRM loads are removed we find that waitForHeritage() then
    // loadBridgeStrict() is too slow, resulting in `subproduct:unknown` for analytics events.
    // In that same case however, profiling shows us that polling in loadBridgeWeak() somehow
    // resolves the same AMD code faster.
    // This is not well understood, but it does allow us to work around the issue by racing these
    // two techniques.
    // Once there is no pre-TTI WRM loads we the waitForHeritage() then loadBridgeStrict() does seem
    // to be faster such that we can remove the `Promise.race()`.
    /* eslint-disable jira/wrm/no-load-bridge */ $bcbbcd48ca398ed4$var$maybeDelayAndRace(allowMonolithDeferral ? (0, $cQZXC.waitForHeritage)() : null, ()=>(0, $7T84i.loadBridgeStrict)({
            name: 'jira/analytics/sub-product-resolver',
            wrmKeys: [
                'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
            ]
        }), ()=>(0, $9B86Q.loadBridgeWeak)({
            name: 'jira/analytics/sub-product-resolver'
        })).then((subProductResolver)=>{
        subProductResolver.setSubProduct(subProduct);
    }).catch((e)=>(0, $2YZCu.default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
/* eslint-enable jira/wrm/no-load-bridge */ };

});
const $86344d58e71e925a$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';


parcelRegister("8OHH4", function(module, exports) {

$parcel$export(module.exports, "isSubProductProps", () => $701d07b56c3e3574$export$c3063d6d7a8c075f);
const $701d07b56c3e3574$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';

});


parcelRegister("3nGSC", function(module, exports) {

$parcel$export(module.exports, "NotificationsPageTitle", () => $16ddfa2efd9596fd$export$b3b17fafb1f634da);

var $5uXOq = parcelRequire("5uXOq");

var $id7K0 = parcelRequire("id7K0");

var $koVbs = parcelRequire("koVbs");

var $bnhK1 = parcelRequire("bnhK1");
const $16ddfa2efd9596fd$export$b3b17fafb1f634da = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $id7K0.DocumentTitle), {
        title: formatMessage((0, $bnhK1.default).notificationsPageTitle)
    });
};

});
parcelRegister("id7K0", function(module, exports) {

$parcel$export(module.exports, "DocumentTitle", () => $938046587fdeeb52$export$dd5ad0b65cf665da);

var $5uXOq = parcelRequire("5uXOq");

var $cSD7y = parcelRequire("cSD7y");

var $4CAXd = parcelRequire("4CAXd");
// eslint-disable-next-line jira/react/no-class-components
class $938046587fdeeb52$var$DocumentTitleOld extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            TitleSubscriber: (0, $4CAXd.DocumentTitleSubscriber)
        };
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.title !== this.props.title;
    }
    render() {
        const { title: title, TitleSubscriber: TitleSubscriber = (0, $4CAXd.DocumentTitleSubscriber) } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4CAXd.DocumentTitleHelperOld), {
                title: title,
                setTitle: setTitle,
                addDocumentTitle: addDocumentTitle,
                contextArray: contextArray,
                removeDocumentTitle: removeDocumentTitle,
                TitleSubscriber: TitleSubscriber
            }));
    }
}
const $938046587fdeeb52$export$dd5ad0b65cf665da = (0, $cSD7y.componentWithFG)('jira-concurrent-document-title', (0, $4CAXd.DocumentTitleHelper), $938046587fdeeb52$var$DocumentTitleOld);

});

parcelRegister("bnhK1", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5c670b3e29f0520$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e5c670b3e29f0520$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    notificationsPageTitle: {
        "id": "spa-apps-personal-settings-notifications.notifications-page-title",
        "defaultMessage": "Personal settings - Notifications"
    }
});

});




//# sourceMappingURL=async-personal-settings-notifications.c943e234.js.map
